export type Translations = Record<string, string>

export const translationsPl: Translations = {
  // Nav
  'nav.about': 'O projekcie',
  'nav.aboutOverview': 'O projekcie',
  'nav.aboutNews': 'Aktualności',
  'nav.aboutRanking': 'Ranking',
  'nav.pricing': 'Cennik',
  'nav.faq': 'FAQ',
  'nav.places': 'Miejsca',
  'nav.community': 'Społeczność',
  'nav.join': 'Dołącz do wyzwania',
  'nav.panel': 'Mój panel',
  'nav.menu.open': 'Otwórz menu nawigacji',
  'nav.menu.close': 'Zamknij menu nawigacji',
  'nav.menu.label': 'Nawigacja strony',
  'promo.launchBar.prefix': 'Nowa niższa cena —',
  'promo.launchBar.priceLabel': '',
  'promo.launchBar.aria': 'Promocja wpisowego, przejdź do rejestracji',
  'promo.launchBlock.registerHint': 'Nowa, niższa cena: 19 zł zamiast 29 zł.',
  'promo.countdown.daySuffix': 'd',
  'promo.countdown.ariaDays': '{{count}} dni',
  'promo.countdown.ariaHms': '{{hours}} godzin, {{minutes}} minut, {{seconds}} sekund',

  'promo.freePopup.eyebrow': 'Program testerski',
  'promo.freePopup.title': 'Dołącz za darmo i podziel się opinią',
  'promo.freePopup.body':
    'Mamy ograniczoną liczbę bezpłatnych miejsc w Paszporcie Dolnego Śląska. Zarejestruj się, przetestuj panel i napisz, co możemy poprawić.',
  'promo.freePopup.cta': 'Dołącz za darmo',
  'promo.freePopup.later': 'Później',
  'promo.freePopup.closeAria': 'Zamknij okno',

  'promo.page.seoTitle': 'Promocja — darmowe konto',
  'promo.page.seoDescription':
    'Jednorazowa promocja: dołącz do Paszportu Dolnego Śląska za darmo, przetestuj program i podziel się opinią.',
  'promo.page.eyebrow': 'Jednorazowa promocja',
  'promo.page.title': 'Dołącz do Paszportu Dolnego Śląska za darmo',
  'promo.page.intro':
    'To wyjątkowa, jednorazowa akcja dla osób, które chcą poznać program i pomóc nam go dopracować. Rejestracja jest bezpłatna — bez płatności HotPay.',
  'promo.page.feedbackHint':
    'Po założeniu konta korzystasz z panelu jak płatni uczestnicy. Będziemy wdzięczni za krótką opinię (np. w ustawieniach lub mailowo).',
  'promo.page.slotsRemaining': 'Zostało {{remaining}} z {{total}} wolnych miejsc',
  'promo.page.slotsUnknown': 'Program obejmuje maksymalnie {{total}} darmowych kont',
  'promo.page.exhaustedBody': 'Wszystkie miejsca w tej promocji zostały już zajęte.',
  'promo.page.exhaustedCta': 'Możesz nadal dołączyć standardowo —',
  'promo.page.exhaustedCtaLink': 'rejestracja z wpisowym',
  'promo.page.submit': 'Załóż darmowe konto',
  'promo.page.submitBusy': 'Zakładam konto…',
  'promo.page.errors.slotsExhausted': 'Niestety, wszystkie darmowe miejsca są już zajęte.',
  'promo.page.errors.alreadyClaimed': 'Ten adres email już wykorzystał promocję.',
  'promo.page.errors.generic': 'Nie udało się założyć konta. Spróbuj ponownie.',

  'promo25.seoTitle': 'Promocja wpisowego 19 zł — Paszport Dolnego Śląska',
  'promo25.seoDescription':
    'Dołącz do programu na rok 2026 w promocyjnej cenie wpisowego. Zbieraj wirtualne pieczątki, prowadź dziennik i odkrywaj 12 miejsc Dolnego Śląska.',
  'promo25.hero.eyebrow': 'Promocja startowa',
  'promo25.hero.title': 'Odkrywaj Dolny Śląsk przez cały rok — teraz w niższej cenie wpisowego',
  'promo25.hero.subtitle':
    'Jedna opłata, pełny dostęp do panelu: 12 miejsc, wirtualne pieczątki, dziennik podróży i społeczność odkrywców. Bez subskrypcji i ukrytych kosztów.',
  'promo25.hero.priceHighlight': 'Nowa, niższa cena:',
  'promo25.countdown.label': 'Promocja kończy się za',
  'promo25.offer.bullet1': '12 starannie wybranych miejsc na mapie Dolnego Śląska',
  'promo25.offer.bullet2': 'Wirtualne pieczątki i dziennik w panelu — na telefonie i komputerze',
  'promo25.offer.bullet3': '14 dni na zwrot wpisowego, jeśli program Ci nie pasuje',
  'promo25.form.title': 'Załóż konto i opłać wpisowe',
  'promo25.form.subtitle': 'Po płatności HotPay od razu logujesz się do panelu i zaczynasz zbierać pieczątki.',
  'promo25.form.badge': 'Promocja',
  'promo25.form.submit': 'Opłać wpisowe',
  'promo25.sticky.cta': 'Dołącz w promocji',

  'newsletterLogin.seoTitle': '-10% dla subskrybentów. Paszport Dolnego Śląska',
  'newsletterLogin.seoDescription':
    'Rabat 10% na wpisowe Mini dla subskrybentów newslettera. Załóż konto i dołącz do Paszportu Dolnego Śląska.',
  'newsletterLogin.eyebrow': 'Oferta newslettera',
  'newsletterLogin.title': '-10% dla subskrybentów',
  'newsletterLogin.subtitle':
    'Rabat na wpisowe Mini jest już wliczony. Załóż konto, opłać wpisowe i zacznij zbierać pieczątki na Dolnym Śląsku.',
  'newsletterLogin.priceNote': 'cena z rabatem newslettera',
  'newsletterLogin.form.submit': 'Opłać wpisowe',

  'promo25.offer.eyebrow': 'Co dostajesz',
  'promo25.offer.title': 'Jedyny turystyczny Paszport Dolnego Śląska',
  'promo25.offer.subtitle':
    'Paszport to wyzwanie odkrywcze: zweryfikuj wizytę, zbierz pieczątkę, zapisz wspomnienia i wracaj do miejsc, które Cię poruszyły.',
  'promo25.offer.savings': 'Oszczędzasz 5 zł w promocji',
  'promo25.offer.card1.title': 'Wirtualne pieczątki',
  'promo25.offer.card1.body':
    'Każde odwiedzone miejsce to pieczątka w panelu — widzisz postęp na mapie i w kolekcji sezonu.',
  'promo25.offer.card2.title': '12 historii regionu',
  'promo25.offer.card2.body':
    'Artykuły, zdjęcia i wskazówki do każdego miejsca — planujesz weekendy bez przeszukiwania internetu.',
  'promo25.offer.card3.title': 'Społeczność i ranking',
  'promo25.offer.card3.body':
    'Dziel się odkryciami, komentuj i zobacz, jak inni odkrywcy przeżywają ten sam program.',
  'promo25.testimonials.eyebrow': 'Opinie uczestników',
  'promo25.testimonials.title': 'Ludzie już zbierają pieczątki — dołącz do nich',
  'promo25.testimonial3.text':
    'Wpisowe w promocji to była dobra decyzja: panel jest przejrzysty, a dziennik pomaga pamiętać, dlaczego warto wracać na Dolny Śląsk.',
  'promo25.testimonial3.author': 'Anna M.',
  'promo25.testimonial3.meta': 'Jelenia Góra',
  'promo25.socialBand.subtitle':
    'Dołącz w promocyjnej cenie wpisowego — jedna płatność na cały sezon 2026.',
  'promo25.socialBand.cta': 'Dołącz teraz za',
  'promo25.final.eyebrow': 'Ostatni krok',
  'promo25.final.title': 'Dołącz w promocyjnej cenie — formularz zajmie 2 minuty',
  'promo25.final.subtitle':
    'Wypełnij dane, opłać wpisowe przez HotPay i wejdź do panelu. Reszta roku należy do Ciebie i Dolnego Śląska.',

  // Locale / settings
  'settings.account.title': 'Ustawienia konta',
  'settings.account.subtitle': 'Uzupełnij dane profilu.',
  'settings.membership.activeFrom': 'Członkostwo (wpisowe): aktywne od {{date}}.',
  'settings.membership.pricingNote':
    'Każdy wariant kosztuje 19 zł. Drugą wersję odblokujesz w panelu za 19 zł.',
  'settings.membership.pricingNoteMiniOnly':
    'Wpisowe to 19 zł za edycję sezonu 2026.',
  'settings.membership.tierFull': 'Paszport Dolnego Śląska (60 miejsc)',
  'settings.membership.tierMini': 'Paszport Dolnego Śląska Mini (12 miejsc / sezon 2026)',
  'settings.membership.unlockFull.body':
    'Masz edycję specjalną 2026. Za 19 zł odblokujesz pełny Paszport — 60 miejsc bez limitu czasu.',
  'settings.membership.unlockFull.cta': 'Odblokuj pełny Paszport',
  'settings.membership.unlockFull.busy': 'Przekierowanie…',
  'settings.membership.unlockMini.body':
    'Masz pełny Paszport (60 miejsc). Drugą wersję — edycję Mini (12 miejsc, sezon 2026) — odblokujesz za 19 zł tak samo, jak uczestnicy Mini dokupują pełny wariant.',

  // Settings - eyebrows + sekcje
  'settings.language.eyebrow': 'Język',
  'settings.verification.eyebrow': 'Weryfikacja',
  'settings.verification.title': 'Sposób weryfikacji miejsc',
  'settings.verification.subtitle':
    'Możesz wymusić weryfikację „tylko po zdjęciu". Wtedy przed weryfikacją pojawi się krótki quiz (2 pytania). Przydatne, gdy GPS jest zawodny.',
  'settings.verification.toggle.label': 'Tylko po zdjęciu + quiz',
  'settings.verification.toggle.help': 'Wyłącza GPS, włącza quiz przed weryfikacją.',
  'settings.verification.toggle.aria': 'Włącz weryfikację tylko po zdjęciu',

  'settings.profile.eyebrow': 'Twój profil',
  'settings.profile.title': 'Dane profilu',
  'settings.profile.subtitle':
    'Imię (lub pseudonim), miejscowość i informacja, jak nas znalazłaś/-eś. Dane są widoczne przy Twoich komentarzach i wpisach.',
  'settings.profile.fullName.label': 'Imię',
  'settings.profile.fullName.placeholder': 'np. Zosia',
  'settings.profile.origin.label': 'Skąd pochodzisz',
  'settings.profile.origin.placeholder': 'np. Wrocław',
  'settings.profile.heardAbout.label': 'Skąd dowiedziałaś/-eś się o nas?',
  'settings.profile.heardAbout.empty': ', opcjonalnie / nie wybrano ,',
  'settings.profile.heardAbout.previouslySaved': '{{value}} (wcześniej zapisane)',
  'settings.profile.inviter.label': 'Email zapraszającego',
  'settings.profile.inviter.placeholder': 'np. znajoma@email.pl',
  'settings.profile.inviter.help': 'Pole opcjonalne. Po zapisaniu nie można go zmienić.',
  'settings.profile.inviter.locked': 'Email zapraszającego został już zapisany.',
  'settings.profile.inviter.error.invalid': 'Podaj poprawny email zapraszającego.',

  'settings.avatar.eyebrow': 'Awatar',
  'settings.avatar.title': 'Zdjęcie profilowe',
  'settings.avatar.subtitle': 'Ustaw avatar widoczny w panelu. Maks. 3 MB (PNG / JPG / WEBP).',
  'settings.avatar.uploading': 'Wysyłam…',
  'settings.avatar.change': 'Zmień zdjęcie',
  'settings.avatar.set': 'Ustaw zdjęcie',
  'settings.avatar.remove': 'Usuń',
  'settings.avatar.error.notLoggedIn': 'Brak zalogowanego użytkownika.',
  'settings.avatar.error.notImage': 'Wybierz plik graficzny (PNG/JPG/WEBP).',
  'settings.avatar.error.tooLarge': 'Plik jest za duży. Maksymalnie 3 MB.',
  'settings.avatar.error.uploadFailed': 'Nie udało się ustawić zdjęcia profilowego.',
  'settings.avatar.error.removeFailed': 'Nie udało się usunąć zdjęcia profilowego.',
  'settings.avatar.error.bucketMissing':
    'Nie znaleziono bucketa na avatary ({{candidates}}). Ustaw VITE_SUPABASE_AVATARS_BUCKET albo utwórz bucket "{{defaultBucket}}" w Supabase Storage.',

  'settings.password.eyebrow': 'Bezpieczeństwo',
  'settings.password.title': 'Zmień hasło',
  'settings.password.subtitle': 'Ustaw nowe hasło (min. 6 znaków). Po zapisaniu sesja pozostanie zalogowana.',
  'settings.password.new.label': 'Nowe hasło',
  'settings.password.repeat.label': 'Powtórz nowe hasło',
  'settings.password.changed': 'Hasło zostało zmienione.',
  'settings.password.changing': 'Zmieniam hasło…',
  'settings.password.save': 'Zapisz nowe hasło',
  'settings.password.error.tooShort': 'Hasło musi mieć co najmniej 6 znaków.',
  'settings.password.error.mismatch': 'Hasła nie są takie same.',
  'settings.password.error.failed': 'Nie udało się zmienić hasła.',

  'settings.delete.eyebrow': 'Strefa krytyczna',
  'settings.delete.title': 'Usuń konto',
  'settings.delete.subtitle': 'Ta operacja jest nieodwracalna , Twoje konto zostanie trwale usunięte.',
  'settings.delete.confirm.label': 'Wpisz „USUN", aby potwierdzić',
  'settings.delete.confirm.placeholder': 'USUN',
  'settings.delete.deleting': 'Usuwam konto…',
  'settings.delete.cta': 'Usuń konto',
  'settings.delete.error.confirmMismatch': 'Wpisz dokładnie: USUN',
  'settings.delete.error.failed': 'Nie udało się usunąć konta.',

  'settings.language.title': 'Język',
  'settings.language.subtitle':
    'Wybór języka wpływa m.in. na format dat i liczb (oraz docelowo na treści aplikacji).',
  'settings.language.label': 'Wersja językowa',
  'settings.language.pl': 'Polski',
  'settings.language.cs': 'Čeština',
  'settings.profile.loadError': 'Nie udało się pobrać profilu.',
  'settings.profile.saveError': 'Nie udało się zapisać profilu.',
  'settings.points.banner': 'Twoje punkty sezonu: {{points}}',
  'settings.points.visibility.label': 'Pokazuj moje punkty',
  'settings.points.visibility.help': 'Po wyłączeniu punkty nie będą widoczne w panelu i ustawieniach.',

  // Common
  'common.loading': 'Ładowanie…',
  'common.error': 'Błąd',
  'common.loadError': 'Błąd pobierania.',
  'common.save': 'Zapisz',
  'common.saving': 'Zapisywanie...',
  'common.saved': 'Zapisano.',
  'common.add': 'Dodaj',
  'common.delete': 'Usuń',
  'common.cancel': 'Anuluj',
  'common.close': 'Zamknij',
  'common.back': 'Wróć',
  'common.ok': 'OK',
  'common.readMore': 'Czytaj więcej',
  'common.uploading': 'Wgrywanie…',
  'common.chooseFile': 'Wybierz plik',
  'common.location': 'Lokalizacja',
  'common.visibility.ariaLabel': 'Widoczność',
  'common.visibility.private': 'Tylko ja',
  'common.visibility.public': 'Wszyscy',
  'common.loadData': 'Wczytaj dane',
  'common.loadingDots': 'Ładowanie...',

  // Profile onboarding
  'profile.onboarding.title': 'Witaj w programie',
  'profile.onboarding.subtitle':
    'Konto jest aktywne. Zanim przejdziesz dalej, powiedz nam coś o sobie , zajmie to chwilę.',
  'profile.onboarding.fullName.label': 'Imię',
  'profile.onboarding.fullName.placeholder': 'np. Zosia',
  'profile.onboarding.origin.label': 'Skąd jestem / pochodzenie',
  'profile.onboarding.origin.placeholder': 'np. Wrocław, Dolny Śląsk',
  'profile.onboarding.heardAbout.label': 'Skąd dowiedziałeś się o nas?',
  'profile.onboarding.heardAbout.ariaLabel': 'Skąd dowiedziałeś się o nas?',
  'profile.onboarding.heardAbout.chooseOption': 'Wybierz opcję',
  'profile.onboarding.inviter.label': 'Email zapraszającego (opcjonalnie)',
  'profile.onboarding.inviter.placeholder': 'np. znajoma@email.pl',
  'profile.onboarding.inviter.help': 'Możesz dodać tylko raz.',
  'profile.onboarding.inviter.locked': 'Email zapraszającego został już zapisany i nie można go zmienić.',
  'profile.onboarding.inviter.error.invalid': 'Podaj poprawny email zapraszającego.',
  'profile.onboarding.submit.saving': 'Zapisuję…',
  'profile.onboarding.submit.cta': 'Zapisz i przejdź do panelu',
  'profile.onboarding.error.fillAllFields': 'Wypełnij wszystkie pola.',
  'profile.onboarding.error.saveFailed': 'Nie udało się zapisać.',

  // Place discovered modal
  'place.discovered.ariaLabel': 'Odkryto miejsce',
  'place.discovered.badge.verified': 'Zweryfikowano',
  'place.discovered.title': 'Gratulacje!',
  'place.discovered.subtitle': 'Odkryłeś(aś) miejsce na mapie Dolnego Śląska:',
  'place.discovered.note': 'Pieczątka wpada do dziennika. Możesz iść po kolejne.',
  'place.discovered.close': 'Zamknij okno gratulacji',
  'place.discovered.describe': 'Opisz swoje przeżycia',
  'place.discovered.exploreArticle': 'Lepiej poznaj to miejsce',
  'place.discovered.cta': 'Super',

  // Dashboard / panel shell
  'panel.shell.title': 'Panel użytkownika',
  'panel.shell.eyebrow': 'Panel użytkownika',
  'panel.places.title': 'Twoje miejsca',
  'panel.places.subtitle': 'Wejdź w miejsce, zobacz szczegóły i dodaj własny opis.',
  'panel.nav.dashboard': 'Pulpit',
  'panel.nav.places': 'Miejsca',
  'panel.nav.mini2026': 'Edycja 2026',
  'panel.nav.journal': 'Dziennik',
  'panel.nav.quiz': 'Quiz',
  'panel.nav.settings': 'Ustawienia',
  'panel.nav.logout': 'Wyloguj',

  // Panel - section headers (per route)
  'panel.section.dashboard.title': 'Twój pulpit',
  'panel.section.dashboard.subtitle': 'Progres, weekendowy typ i to, co dzieje się w społeczności , wszystko w jednym miejscu.',
  'panel.section.places.title': 'Miejsca',
  'panel.section.places.subtitle': 'Wszystkie miejsca z Paszportu , przeglądaj, filtruj i wybieraj kolejne, do których chcesz zajrzeć.',
  'panel.section.mini2026.title': 'Edycja 2026',
  'panel.section.mini2026.subtitle': '12 wybranych miejsc sezonu 2026 — mapa, lista i weryfikacja w ramach Paszportu Mini.',
  'panel.section.mini2026.stats.subtitle': 'Zweryfikowane miejsca w edycji Mini 2026 (12)',
  'panel.section.mini2026.mapTitle': 'Mapa 12 miejsc',
  'panel.section.mini2026.mapSubtitle': 'Pinezki pokazują miejsca edycji 2026 — stuknij, żeby zobaczyć skrót i przejść dalej.',
  'panel.section.mini2026.stampsTitle': 'Twoje pieczątki edycji 2026',
  'panel.section.mini2026.stampsSubtitle': '12 miejsc sezonu — każda pieczątka to potwierdzona wizyta z weryfikacją.',
  'panel.section.mini2026.stampsCollected': 'zaliczone',
  'panel.section.place.title': 'Miejsce',
  'panel.section.place.subtitle': 'Wszystko, co dotyczy tego miejsca: opis, weryfikacja, Twoje notatki i komentarze.',
  'panel.section.journal.title': 'Dziennik',
  'panel.section.journal.subtitle': 'Każde odwiedzone miejsce to osobna historia. Pisz, dopisuj, wracaj.',
  'panel.section.community.title': 'Społeczność',
  'panel.section.community.subtitle': 'Twoje wpisy i głosy ze wspólnej książki podróży po Dolnym Śląsku.',
  'panel.section.quiz.title': 'Wielki Quiz',
  'panel.section.quiz.subtitle':
    '30 pytań o Dolnym Śląsku. Wygrywa najwyższy wynik, a przy remisie najkrótszy czas.',
  'panel.section.settings.title': 'Ustawienia',
  'panel.section.settings.subtitle': 'Profil, język, hasło i preferencje weryfikacji.',

  'panel.bigQuiz.eyebrow': 'Konkurs wiedzy',
  'panel.bigQuiz.rules':
    'Odpowiedz na 30 pytań o regionie. Liczy się wynik punktowy, a przy remisie wygrywa najkrótszy czas. Trzy najlepsze osoby dostają nagrody. Tylko jedno podejście.',
  'panel.bigQuiz.winnersTitle': 'Podium (top 3)',
  'panel.bigQuiz.winnersEmpty': 'Nikt jeszcze nie ukończył quizu. Bądź pierwszy.',
  'panel.bigQuiz.loading': 'Ładuję ranking…',
  'panel.bigQuiz.loadError': 'Nie udało się wczytać rankingu quizu.',
  'panel.bigQuiz.anonymous': 'Uczestnik',
  'panel.bigQuiz.you': 'Ty',
  'panel.bigQuiz.timeLabel': 'Czas',
  'panel.bigQuiz.myResult':
    'Twój wynik {{correct}}/{{total}} ({{percent}}%), czas {{time}}.',
  'panel.bigQuiz.alreadyPlayed': 'Masz już zapisane podejście. Ponowny start nie jest możliwy.',
  'panel.bigQuiz.closed': 'Zabawa zakończyła się 31 sierpnia 2026.',
  'panel.bigQuiz.addressLabel': 'Adres do wysyłki nagrody',
  'panel.bigQuiz.addressPlaceholder': 'Imię i nazwisko, ulica lub paczkomat, kod, miejscowość',
  'panel.bigQuiz.addressHint': 'Może to być punkt odbioru, np. paczkomat InPost.',
  'panel.bigQuiz.addressError': 'Podaj adres do wysyłki (min. kilka znaków).',
  'panel.bigQuiz.start': 'Start quizu',
  'panel.bigQuiz.progress': 'Pytanie {{current}} z {{total}}',
  'panel.bigQuiz.submitting': 'Zapisuję wynik…',
  'panel.bigQuiz.submitError': 'Nie udało się zapisać wyniku. Spróbuj ponownie później.',
  'panel.bigQuiz.resultTitle': 'Koniec!',
  'panel.bigQuiz.resultBody': 'Masz {{correct}} z {{total}} poprawnych odpowiedzi w czasie {{time}}.',
  'panel.bigQuiz.resultSaved': 'Wynik zapisany. To było Twoje jedyne podejście.',
  'panel.bigQuiz.termsTitle': 'Krótki regulamin',
  'panel.bigQuiz.terms.1':
    'Zabawa trwa do 31 sierpnia 2026. Po tym terminie nie przyjmujemy nowych wyników.',
  'panel.bigQuiz.terms.2':
    'Każda zalogowana osoba może podejść do quizu tylko raz.',
  'panel.bigQuiz.terms.3':
    'Warunkiem udziału jest podanie adresu do wysyłki. Może to być punkt odbioru, np. paczkomat.',
  'panel.bigQuiz.terms.4':
    'Nagrody to gadżety dolnośląskie dla trzech najlepszych wyników (punkty, a przy remisie czas).',
  'panel.bigQuiz.terms.5':
    'Organizator pokrywa wszystkie koszty wysyłki nagród.',
  'panel.bigQuiz.terms.6':
    'Organizator kontaktuje się z laureatami do 7 września 2026 w sprawie odbioru nagród.',
  'panel.section.legacyFull.title': 'Paszport 60 miejsc',
  'panel.section.legacyFull.subtitle': 'Pełny katalog miejsc do zweryfikowania — mapa, lista i weryfikacja. Bez dziennika.',
  'panel.legacyFull.unlock.eyebrow': 'Dla obecnych uczestników',
  'panel.legacyFull.unlock.title': 'Pełny Paszport — 60 miejsc',
  'panel.legacyFull.unlock.body':
    'Jako uczestnik sprzed podziału na Mini i Full możesz jednym kliknięciem odblokować pełny katalog 60 miejsc. Zobaczysz listę, mapę i możliwość weryfikacji — bez dziennika podróży.',
  'panel.legacyFull.unlock.cta': 'Odblokuj',
  'panel.legacyFull.unlock.busy': 'Odblokowuję…',
  'panel.legacyFull.places.stats.eyebrow': 'Twój postęp',
  'panel.legacyFull.places.stats.subtitle': 'Zweryfikowane miejsca w pełnym Paszporcie (60)',
  'panel.legacyFull.places.mapTitle': 'Mapa 60 miejsc',
  'panel.legacyFull.places.mapSubtitle': 'Pinezki pokazują miejsca do odwiedzenia i zweryfikowania w pełnym katalogu.',
  'panel.legacyFull.notebook.eyebrow': 'Książeczka do pieczątek',
  'panel.legacyFull.notebook.title': 'Zamów książeczkę do zbierania pieczątek',
  'panel.legacyFull.notebook.body':
    'Przygotowujemy fizyczną książeczkę Paszportu Dolnego Śląska do zbierania pieczątek w terenie. Zamówienia wkrótce — zapisz się, damy znać.',
  'panel.legacyFull.notebook.stampsNote':
    'Uwaga: jeszcze nie wszystkie miejsca posiadają pieczątki w terenie.',
  'panel.legacyFull.notebook.orderDisabled': 'Zamów książeczkę',
  'panel.legacyFull.notebook.joinCta': 'CZEKAM!',
  'panel.legacyFull.notebook.joinBusy': 'Zapisuję…',
  'panel.legacyFull.notebook.waitlisted': 'Zapisano — damy znać!',

  // Panel - lista wszystkich miejsc
  'panel.placesList.stats.eyebrow': 'Zweryfikowane',
  'panel.placesList.stats.subtitle': 'Tyle miejsc z Paszportu już odhaczyłaś.',
  'panel.placesList.stats.shown': 'Pokazane: {{current}}/{{total}}',
  'panel.placesList.filters.eyebrow': 'Filtry',
  'panel.placesList.filters.region': 'Region',
  'panel.placesList.filters.region.all': 'Wszystkie regiony',
  'panel.placesList.filters.category': 'Kategoria',
  'panel.placesList.filters.category.all': 'Wszystkie kategorie',
  'panel.placesList.empty': 'Nic nie pasuje do Twoich filtrów.',
  'panel.placesList.error.loadFailed': 'Nie udało się pobrać statusu Twoich weryfikacji.',
  'panel.placesList.status.verified': 'Zweryfikowane',
  'panel.placesList.status.visited': 'W trakcie',
  'panel.placesList.status.untouched': 'Do zrobienia',
  'panel.placesList.cta.open': 'Otwórz',

  // Panel - mapka pod listą miejsc
  'panel.placesMap.eyebrow': 'Mapa',
  'panel.placesMap.title': 'Wszystkie miejsca na mapie',
  'panel.placesMap.subtitle': 'Każda pinezka to jedno miejsce. Stuknij, żeby zobaczyć skrót i przejść dalej.',
  'panel.placesMap.hint': 'Wybierz pinezkę, aby zobaczyć szczegóły.',
  'panel.placesMap.cta.open': 'Otwórz miejsce',
  'panel.placesMap.cta.verify': 'Zweryfikuj',
  'panel.placesMap.legend.verified': 'Zweryfikowane',
  'panel.placesMap.legend.untouched': 'Do odhaczenia',
  'panel.placesMap.popup.close': 'Zamknij',
  'panel.placesMap.loading': 'Ładowanie mapy…',

  // Panel - mobile nav
  'panel.mobileNav.open': 'Otwórz menu',
  'panel.mobileNav.close': 'Zamknij menu',
  'panel.mobileNav.label': 'Menu panelu użytkownika',

  // Panel - sidebar (menu po prawej + konto)
  'panel.sidebar.menu.eyebrow': 'Nawigacja',
  'panel.sidebar.search.eyebrow': 'Wyszukiwarka',
  'panel.sidebar.search.placeholder': 'Szukaj miejsca…',
  'panel.sidebar.search.count': '{{current}} z {{total}} miejsc',
  'panel.sidebar.visited': 'Odwiedzone',
  'panel.sidebar.account.eyebrow': 'Konto',
  'panel.sidebar.account.label': 'Konto:',
  'panel.sidebar.account.empty': 'Brak',
  'panel.sidebar.account.role': 'Zalogowany użytkownik',
  'panel.points.label': 'Punkty sezonu: {{points}}',
  'panel.sidebar.hint.journal': 'W dzienniku zobaczysz miejsca oznaczone jako odwiedzone i dodasz własne wspomnienia.',
  'panel.sidebar.hint.community': 'W społeczności dodasz post i zarządzisz swoimi wpisami.',
  'panel.sidebar.hint.settings': 'W ustawieniach uzupełnisz dane profilu i wybierzesz tryb weryfikacji.',

  // Panel welcome
  'panel.welcome.cta.showJournal': 'Zobacz dziennik',
  'panel.welcome.map.eyebrow': 'Wirtualna mapa',
  'panel.welcome.map.title': 'Kliknij, dotknij, odkryj',
  'panel.welcome.map.subtitle': 'Każdy punkt to konkretne miejsce z naszej kolekcji. Po lewej zobaczysz szczegóły i przejdziesz do pełnego widoku.',
  'panel.welcome.map.location': 'Lokalizacja',
  'panel.welcome.map.cta': 'Czytaj więcej',
  'panel.welcome.map.hint': 'Kliknij punkt na mapie, żeby zobaczyć szczegóły.',
  'panel.welcome.progress.eyebrow': 'Twój progres',
  'panel.welcome.progress.title': 'Ile już zaliczone',
  'panel.welcome.progress.window': 'Okno: {{total}} dni · zostało {{left}}',
  'panel.welcome.progress.loading': 'Ładowanie progresu…',
  'panel.welcome.progress.visitedLabel': 'Odwiedzone miejsca',
  'panel.welcome.progress.percent': '{{pct}}% kolekcji',
  'panel.welcome.progress.barLabel': 'Pasek progresu',
  'panel.welcome.progress.startedOn': 'Start: {{date}} · minęło {{days}} dni',
  'panel.welcome.stamps.eyebrow': 'Pieczątki',
  'panel.welcome.stamps.title': 'Twój Paszport',
  'panel.welcome.stamps.cta.goToEntry': 'Przejdź do wpisu',
  'panel.welcome.weekend.eyebrow': 'Weekendowa propozycja',
  'panel.welcome.weekend.title': 'Najbliższy weekend',
  'panel.welcome.weekend.cta.details': 'Zobacz szczegóły',
  'panel.welcome.weekend.cta.reroll': 'Wylosuj nową',
  'panel.welcome.weekend.loading': 'Losowanie…',
  'panel.welcome.comments.eyebrow': 'Z życia społeczności',
  'panel.welcome.comments.title': 'Ostatnie komentarze',
  'panel.welcome.comments.subtitle': 'Najświeższe wpisy użytkowników , zobacz, co inni piszą o miejscach.',
  'panel.welcome.comments.empty': 'Nikt jeszcze nic nie napisał. Bądź pierwszą osobą.',
  'panel.welcome.comments.placeUnknown': 'Miejsce',
  'panel.welcome.comments.author.anonymous': 'Użytkownik',
  'panel.welcome.comments.author.fromOrigin': 'Użytkownik ({{origin}})',
  'panel.welcome.announcements.eyebrow': 'Aktualności',
  'panel.welcome.announcements.title': 'Ogłoszenia',
  'panel.welcome.announcements.empty': 'Na razie brak ogłoszeń.',
  'panel.welcome.users.counting': 'Liczę użytkowników…',
  'panel.welcome.users.label': 'Zarejestrowanych:',
  'panel.welcome.users.unavailable': 'Liczba użytkowników niedostępna',
  'panel.welcome.gallery.eyebrow': 'Klimat regionu',
  'panel.welcome.gallery.title': 'Zdjęcia z kolekcji',
  'panel.welcome.gallery.subtitle': 'Kadry z miejsc Paszportu i Dolnego Śląska , tak wygląda podróż po naszej liście.',
  'panel.welcome.badge.locked': 'Odznaka główna',
  'panel.welcome.badge.remaining': 'Jeszcze {{count}} miejsc, żeby zdobyć odznakę',

  'panel.nearby.barAria': 'Powiadomienia o lokalizacji przy weryfikacji',
  'panel.nearby.eyebrow': 'Weryfikacja w terenie',
  'panel.nearby.hint':
    'Włącz lokalizację , gdy będziesz w promieniu miejsca z Paszportu (GPS jak przy weryfikacji), zaproponujemy szybkie przejście do odhaczenia.',
  'panel.nearby.status.idle': 'Lokalizacja wyłączona , kliknij, by włączyć.',
  'panel.nearby.status.requesting': 'Łączenie z GPS…',
  'panel.nearby.status.active': 'GPS aktywny , szukamy miejsc w pobliżu.',
  'panel.nearby.status.denied': 'Brak dostępu do lokalizacji. Włącz ją w ustawieniach przeglądarki.',
  'panel.nearby.status.unsupported': 'Ta przeglądarka nie obsługuje geolokalizacji.',
  'panel.nearby.cta.enable': 'Włącz lokalizację',
  'panel.nearby.cta.stop': 'Wyłącz',
  'panel.nearby.modal.closeAria': 'Zamknij',
  'panel.nearby.modal.eyebrow': 'Jesteś w pobliżu',
  'panel.nearby.modal.title': 'Chyba jesteś tu…',
  'panel.nearby.modal.body': 'Wygląda na to, że jesteś przy: {{name}}. Możesz od razu przejść do weryfikacji.',
  'panel.nearby.modal.later': 'Później',
  'panel.nearby.modal.verify': 'Zweryfikuj',

  // Panel - Journal (header lifting)
  'panel.journal.eyebrow': 'Twoja kronika',
  'panel.stamps.eyebrow': 'Pieczątki',

  // Panel - Journal
  'panel.journal.title': 'Dziennik',
  'panel.journal.subtitle': 'Każde odwiedzone miejsce to osobna historia. Rozwiń rozdział, dopisz wspomnienia i dodaj zdjęcia.',
  'panel.journal.loginToSee': 'Zaloguj się, żeby zobaczyć odwiedzone miejsca.',
  'panel.journal.loading': 'Ładowanie dziennika…',
  'panel.journal.error.loadFailed': 'Nie udało się pobrać dziennika.',
  'panel.journal.unlockedCount': '{{current}}/{{total}} odblokowanych',
  'panel.journal.day.locked': 'Nieodblokowane',
  'panel.journal.month.fallback': 'Rozdział',
  'panel.journal.entry.aria': 'Wpis dziennika: {{name}}',
  'panel.journal.entry.lockedAria': 'Zablokowany rozdział: {{name}}',
  'panel.journal.chapter.expand': 'Rozwiń rozdział',
  'panel.journal.chapter.collapse': 'Zwiń rozdział',
  'panel.journal.chapter.locked': 'Rozdział zablokowany',
  'panel.journal.chapter.lockedInline': 'Ten rozdział odblokujesz po weryfikacji miejsca.',
  'panel.journal.locked.badge': 'Do odblokowania',
  'panel.journal.locked.toggle': 'Pozostałe miejsca ({{count}})',
  'panel.journal.cover.label': 'Okładka (zdjęcie)',
  'panel.journal.cover.alt': 'Okładka: {{name}}',
  'panel.journal.cover.dropHint': 'Przeciągnij zdjęcie tutaj albo wybierz plik.',
  'panel.journal.cover.empty': 'Brak okładki',
  'panel.journal.cover.cta.save': 'Zapisz okładkę',
  'panel.journal.cover.error.chooseFirst': 'Najpierw wybierz zdjęcie.',
  'panel.journal.cover.error.saveFailed': 'Nie udało się zapisać okładki.',
  'panel.journal.location.label': 'Lokalizacja',
  'panel.journal.cta.edit': 'Dopisz / edytuj',
  'panel.journal.cta.unlock': 'Odblokuj (weryfikuj)',
  'panel.journal.note.title': 'Opis',
  'panel.journal.note.help': 'Możesz dopisać/zmienić opis po dodaniu wpisu.',
  'panel.journal.note.placeholder': 'Np. co Ci się podobało, jak dojechać, ile czasu zajęło…',
  'panel.journal.note.emptyInline': 'Tu jeszcze nie ma opisu. Rozwiń rozdział i dopisz kilka zdań.',
  'panel.journal.note.cta.save': 'Zapisz opis',
  'panel.journal.note.error.saveFailed': 'Nie udało się zapisać opisu.',
  'panel.journal.visitedAt': 'Odwiedzono: {{date}}',
  'panel.journal.verifiedAt': 'Zweryfikowano: {{date}}',
  'panel.journal.empty':
    'Nie masz jeszcze wpisów. Wejdź w miejsce i przejdź weryfikację (bez GPS: po zdanym quizie).',

  // Panel - Stamps
  'panel.stamps.title': 'Pieczątki',
  'panel.stamps.subtitle': 'Zweryfikowane miejsca, w których masz przybitą pieczątkę.',
  'panel.stamps.empty': 'Jeszcze nie masz pieczątek. Wejdź w miejsce i przejdź weryfikację.',
  'panel.stamps.badge': 'Pieczątka',
  'panel.stamps.count.one': '{{count}} pieczątka',
  'panel.stamps.count.few': '{{count}} pieczątki',
  'panel.stamps.count.many': '{{count}} pieczątek',

  // Panel - Journal photos
  'panel.journal.photos.title': 'Dodatkowe zdjęcia',
  'panel.journal.photos.help': 'Możesz dodać dodatkowe zdjęcia do wpisu (łącznie maks. 3 na miejsce: okładka + 2).',
  'panel.journal.photos.loading': 'Ładowanie zdjęć…',
  'panel.journal.photos.dropOrClick': 'Przeciągnij lub kliknij, aby wybrać',
  'panel.journal.photos.slotsLeft': 'Pozostało dodatkowych: {{left}}/2',
  'panel.journal.photos.newAlt': 'Nowe zdjęcie: {{name}}',
  'panel.journal.photos.extraAlt': 'Dodatkowe zdjęcie: {{name}}',
  'panel.journal.photos.empty': 'Brak dodatkowych zdjęć.',
  'panel.journal.photos.error.loadFailed': 'Nie udało się pobrać zdjęć.',
  'panel.journal.photos.error.addFailed': 'Nie udało się dodać zdjęcia.',
  'panel.journal.photos.error.deleteFailed': 'Nie udało się usunąć zdjęcia.',
  'panel.journal.photos.error.limitReached': 'Osiągnięto limit 3 zdjęć na miejsce.',

  // Panel - Place details / notes
  'panel.place.notFound.eyebrow': 'Brak miejsca',
  'panel.place.notFound.title': 'Nie znaleziono miejsca',
  'panel.place.notFound.subtitle': 'Wybierz inne z listy.',
  'panel.place.note.eyebrow': 'Twoje notatki',
  'panel.place.note.title': 'Twój opis',
  'panel.place.note.subtitle': 'Dodaj własne notatki (zapisywane w bazie danych).',
  'panel.place.note.placeholder': 'Np. co Ci się podobało, jak dojechać, ile czasu zajęło...',
  'panel.place.note.extraQuestions.title': 'Dodatkowe pytania (opcjonalnie)',
  'panel.place.note.extraQuestions.placeholder': 'Napisz, jeśli chcesz...',
  'panel.note.question.learned': 'Czego nowego dowiedziałaś/dowiedziałeś się o tym miejscu?',
  'panel.note.question.surprised': 'Co Cię zaskoczyło?',
  'panel.note.question.disliked': 'Co Ci się nie spodobało?',
  'panel.place.note.loginToAdd': 'Zaloguj się, żeby dodać opis.',
  'panel.place.note.error.saveFailed': 'Nie udało się zapisać opisu.',

  // Panel - Verification
  'panel.verification.eyebrow': 'Weryfikacja',
  'panel.verification.ariaLabel': 'Weryfikacja miejsca',
  'panel.verification.title': 'Weryfikacja miejsca',
  'panel.verification.subtitle': 'Dodanie zdjęcia jest obowiązkowe. {{mode}}',
  'panel.verification.mode.photoOnly': 'Masz włączoną weryfikację tylko po zdjęciu (z quizem).',
  'panel.verification.mode.choose': 'Wybierz metodę: GPS albo „po zdjęciu”.',
  'panel.verification.methodLabel': 'Metoda:',
  'panel.verification.method.photo': 'Po zdjęciu',
  'panel.verification.loginToVerify': 'Zaloguj się, żeby zweryfikować miejsce.',
  'panel.verification.inProgress': 'Weryfikacja w toku…',
  'panel.verification.openQuiz': 'Otwórz quiz',
  'panel.verification.cta.verify': 'Kliknij, żeby zweryfikować',
  'panel.verification.verifiedAt': 'Zweryfikowano • {{date}}',
  'panel.verification.error.photoRequired': 'Dodanie zdjęcia jest obowiązkowe.',
  'panel.verification.error.gpsFirst': 'Najpierw pobierz lokalizację GPS.',
  'panel.verification.error.tooFar': 'Jesteś za daleko od miejsca, żeby zweryfikować przez GPS.',
  'panel.verification.error.verifyFailed': 'Nie udało się zweryfikować miejsca.',
  'panel.verification.photo.required': 'Zdjęcie (obowiązkowe)',
  'panel.verification.photo.add': 'Dodaj zdjęcie',
  'panel.verification.photo.previewAlt': 'Podgląd zdjęcia',
  'panel.verification.photo.empty': 'Brak zdjęcia.',
  'panel.verification.publicPhoto.title': 'Zdjęcie publiczne',
  'panel.verification.publicPhoto.alt': 'Zdjęcie miejsca: {{name}}',
  'panel.verification.publicPhoto.note': 'Na razie pokazujemy Twoje publiczne zdjęcie.',
  'panel.verification.gps.optional': 'GPS (opcjonalnie)',
  'panel.verification.gps.subtitle': 'W trybie GPS sprawdzamy, czy jesteś w pobliżu miejsca.',
  'panel.verification.gps.disabledBecausePhotoOnly':
    'Masz włączoną opcję „tylko po zdjęciu”, więc GPS jest wyłączony.',
  'panel.verification.gps.fetch': 'Pobierz GPS',
  'panel.verification.gps.error.notSupported': 'Twoja przeglądarka nie wspiera geolokalizacji.',
  'panel.verification.gps.error.fetchFailed': 'Nie udało się pobrać lokalizacji.',
  'panel.verification.gps.distance': 'Odległość:',
  'panel.verification.gps.tooFarBadge': 'ZA DALEKO',
  'panel.verification.gps.accuracy': 'Dokładność: {{meters}} m',
  'panel.verification.gps.empty': 'Brak lokalizacji.',
  'panel.verification.gps.thresholds': 'Progi GPS: {{distance}} m i dokładność ≤ {{accuracy}} m.',

  // Panel - Quick verify (modal)
  'panel.quickVerify.cta': 'Szybka weryfikacja',
  'panel.quickVerify.ariaLabel': 'Szybka weryfikacja miejsca',
  'panel.quickVerify.eyebrow': 'Szybka weryfikacja',
  'panel.quickVerify.title': 'Zweryfikuj miejsce w 30 sekund',
  'panel.quickVerify.subtitle': 'Wybierz miejsce, dodaj zdjęcie i potwierdź weryfikację.',
  'panel.quickVerify.close': 'Zamknij okno szybkiej weryfikacji',
  'panel.quickVerify.gps.searching': 'Szukam miejsca w pobliżu…',
  'panel.quickVerify.gps.found': 'Najbliżej: {{name}}',
  'panel.quickVerify.gps.failed': 'Nie udało się pobrać lokalizacji. Wybierz miejsce ręcznie.',
  'panel.quickVerify.gps.noNearby': 'Nie znaleziono miejsca w pobliżu. Wybierz je z listy.',
  'panel.quickVerify.placeLabel': 'Miejsce',
  'panel.quickVerify.placePlaceholder': 'Wybierz miejsce…',
  'panel.quickVerify.alreadyVerified': 'To miejsce masz już zweryfikowane.',
  'panel.quickVerify.openPlace': 'Otwórz kartę miejsca',
  'panel.quickVerify.modeGpsOk': 'Możesz zweryfikować przez GPS.',
  'panel.quickVerify.modePhotoQuiz': 'Weryfikacja „po zdjęciu” (z krótkim quizem).',
  'panel.quickVerify.photo.camera': 'Zrób zdjęcie',
  'panel.quickVerify.photo.gallery': 'Wybierz z galerii',

  // Panel - Quiz
  'panel.quiz.eyebrow': 'Quiz',
  'panel.quiz.ariaLabel': 'Quiz weryfikacyjny',
  'panel.quiz.title': 'Quiz weryfikacyjny',
  'panel.quiz.subtitle': 'Odpowiedz na 2 pytania, żeby móc zweryfikować miejsce „po zdjęciu”.',
  'panel.quiz.close': 'Zamknij quiz',
  'panel.quiz.q1': '1) W jakim regionie jest to miejsce?',
  'panel.quiz.q2': '2) Jaka to kategoria?',
  'panel.quiz.error.answerBoth': 'Odpowiedz na oba pytania.',
  'panel.quiz.error.wrong': 'Niepoprawne odpowiedzi. Spróbuj ponownie.',
  'panel.quiz.cta.passAndVerify': 'Zaliczenie quizu i weryfikacja',

  // Place comments
  'place.comments.eyebrow': 'Rozmowa',
  'place.comments.title': 'Komentarze',
  'place.comments.subtitle': 'Zostaw komentarz do tego miejsca.',
  'place.comments.placeholder': 'Napisz komentarz…',
  'place.comments.loginToComment': 'Zaloguj się, żeby komentować.',
  'place.comments.visibilityNote': 'Widoczne dla zalogowanych użytkowników.',
  'place.comments.persistNote': 'Komentarze zapisują się w bazie danych.',
  'place.comments.addError': 'Nie udało się dodać komentarza.',
  'place.comments.author.fallback': 'Użytkownik',

  // Public place details - comments
  'place.comments.add': 'Dodaj komentarz',
  'place.comments.empty': 'Brak komentarzy. Bądź pierwszy.',
  'place.comments.loadError': 'Nie udało się pobrać komentarzy. Spróbuj ponownie później.',

  // Public place details - article + sections
  'place.article.eyebrow': 'Artykuł',
  'place.article.notReady.title': 'W przygotowaniu',
  'place.article.notReady.body':
    'Ten artykuł dopracowujemy. Wróć za chwilę , w międzyczasie sprawdź praktyczne informacje i mapę poniżej.',
  'place.article.audio.aria': 'Dźwięk z miejsca',
  'place.article.audio.eyebrow': 'Posłuchaj',
  'place.article.audio.title': 'Dźwięk z miejsca',
  'place.article.audio.unsupported': 'Twoja przeglądarka nie obsługuje odtwarzania audio.',
  'place.article.history.skip': 'Nie lubię historii, pomijam',
  'place.article.history.skipped': 'Historię pominięto.',
  'place.hero.locationEyebrow': 'Lokalizacja',
  'place.hero.commentsEyebrow': 'Komentarze',
  'place.hero.commentsLogin': 'Zaloguj się',
  'place.hero.commentsHint': 'Dodawanie i podgląd komentarzy tylko dla użytkowników.',
  'place.hero.cta.verifyInPanel': 'Dodaj zdjęcie / weryfikuj w panelu',
  'place.hero.cta.loginToContribute': 'Zaloguj się, żeby dodać treści',
  'place.highlights.eyebrow': 'Najważniejsze',
  'place.toc.eyebrow': 'Spis treści',
  'place.practical.eyebrow': 'Praktyczne informacje',
  'place.practical.visitDuration': 'Czas zwiedzania',
  'place.practical.howToGetThere': 'Dojazd',
  'place.practical.parking': 'Parking',
  'place.practical.accessibility': 'Warunki / dostępność',
  'place.practical.goodToKnow': 'Warto wiedzieć',
  'place.faq.eyebrow': 'FAQ',
  'place.map.eyebrow': 'Mapa',
  'place.map.pointsHint': 'Kliknij pinezkę, żeby zobaczyć punkt na mapie parku.',
  'place.map.mainPin': 'Park w Bukowcu (centrum)',
  'place.publicPhotos.eyebrow': 'Zdjęcia użytkowników',
  'place.publicPhotos.subtitle': 'Publiczne zdjęcia dodane podczas weryfikacji miejsca.',
  'place.publicPhotos.cta.add': 'Dodaj',
  'place.publicPhotos.loading': 'Wczytywanie zdjęć…',
  'place.publicPhotos.empty': 'Brak publicznych zdjęć dla tego miejsca.',
  'place.publicPhotos.error': 'Nie udało się pobrać publicznych zdjęć. Spróbuj ponownie później.',
  'place.photoLightbox.closeAria': 'Zamknij podgląd zdjęcia',
  'place.photoLightbox.captionEditorial': 'Ilustracja do opisu miejsca {{place}}.',
  'place.photoLightbox.captionUser': 'Zdjęcie z weryfikacji miejsca {{place}}.',
  'place.photoLightbox.altEditorial': 'Zdjęcie do artykułu: {{place}}',
  'place.photoLightbox.altUser': 'Zdjęcie użytkownika: {{place}}',
  'place.photoLightbox.promo': 'Możesz też zrobić takie zdjęcie razem z Paszportem Dolnego Śląska.',
  'place.photoLightbox.ctaRegister': 'Przejdź do rejestracji',
  'place.photoLightbox.ctaPanel': 'Dodaj zdjęcie w panelu',
  'place.photoLightbox.openAria': 'Otwórz powiększone zdjęcie: {{place}}',
  'site.photoLightbox.caption': 'Zdjęcie z materiałów {{name}}.',
  'site.photoLightbox.alt': 'Ilustracja: {{name}}',
  'place.notFound.eyebrow': 'Miejsce',
  'place.notFound.title': 'Nie znaleziono tego miejsca',
  'place.notFound.subtitle': 'Sprawdź adres albo wybierz inne z listy.',
  'place.notFound.cta.home': 'Wróć na stronę główną',

  // Landing - Auth journal
  'landing.journal.smallTitle': 'Dziennik',
  'landing.journal.title': 'Twoje miejsce na wspomnienia z 12 wyjątkowych miejsc.',
  'landing.journal.subtitleLead': 'Kolekcjonuj wspomnienia',
  'landing.journal.subtitleRest':
    'zapisuj wrażenia, dodawaj notatki i wracaj do nich jak do mapy swoich odkryć.',
  'landing.journal.tags.notes': 'notatki',
  'landing.journal.tags.photos': 'zdjęcia',
  'landing.journal.tags.memories': 'wspomnienia',
  'landing.journal.account.label': 'Konto',
  'landing.journal.account.name': 'Ania',
  'landing.journal.visitDate.label': 'Data odwiedzenia',
  'landing.journal.visitDate.value': '12.05.2026',
  'landing.journal.travelNote.title': 'Notatka z podróży',
  'landing.journal.travelNote.body':
    'Ach, jak się zachwyciłam tym miejscem… Cisza, światło między drzewami i ta chwila, kiedy chce się zostać jeszcze trochę. W drodze powrotnej pomyślałam, że to jeden z tych zakątków, do których wraca się myślami tygodniami. Zrobiłam kilka zdjęć, zapisałam detale (zapach lasu po deszczu, ciepło słońca na kamieniach) , i już wiem, że wrócę tu jesienią.',
  'landing.journal.preview.label': 'Podgląd wpisu w Dzienniku',

  // Landing - Hero / stats
  'landing.hero.cta.register': 'Załóż konto',
  'landing.hero.cta.readMore': 'Dowiedz się więcej',
  'landing.stats.users.fallback': 'Uczestnicy',
  'landing.stats.users': '{{count}} uczestników',
  'landing.stats.cities.fallback': 'Miasta',
  'landing.stats.cities': '{{count}} miast',

  // Landing - Social proof
  'landing.socialProof.eyebrow': 'Społeczność odkrywców',
  'landing.socialProof.headline.before': 'Dołącz do',
  'landing.socialProof.headline.after':
    'osób, które już zbierają pieczątki i odkrywają Dolny Śląsk',
  'landing.socialProof.headline.loading': 'Ładuję licznik uczestników…',
  'landing.socialProof.headline.fallback':
    'Dołącz do społeczności odkrywców, którzy już zbierają pieczątki i odkrywają Dolny Śląsk',
  'landing.socialProof.statsAria': 'Liczba uczestników programu',
  'landing.socialProof.recent.eyebrow': 'Ostatnio dołączyli',
  'landing.socialProof.recent.aria': 'Ostatnio dołączeni uczestnicy',
  'landing.socialProof.recent.loading': 'Ładuję listę ostatnio dołączonych…',
  'landing.socialProof.recent.unavailable':
    'Lista ostatnio dołączonych wymaga aktualizacji bazy (RPC community_recent_members).',
  'landing.socialProof.map.eyebrow': 'Skąd pochodzą uczestnicy',
  'landing.socialProof.map.loading': 'Ładuję mapę pochodzenia…',
  'landing.socialProof.map.empty':
    'Gdy uczestnicy uzupełnią miasto pochodzenia, zobaczysz je na mapie.',
  'landing.socialProof.map.hint':
    'Punkty pokazują miasta podane przy rejestracji. Rozmiar kółka zależy od liczby osób z danego miejsca.',
  'landing.socialProof.cta': 'Dołącz do Społeczności',
  'landing.socialProof.testimonial1.text':
    'Pierwsza pieczątka w Bukowcu była jak otwarcie nowego rozdziału. Teraz planuję każdy weekend inaczej , z mapą i dziennikiem pod ręką.',
  'landing.socialProof.testimonial1.author': 'Marta K.',
  'landing.socialProof.testimonial1.meta': 'Wrocław',
  'landing.socialProof.testimonial2.text':
    'Najbardziej lubię wracać do wpisów w dzienniku miesiącami później. To jak mały album wspomnień z miejsc, których nie znałam wcześniej.',
  'landing.socialProof.testimonial2.author': 'Piotr W.',
  'landing.socialProof.testimonial2.meta': 'Legnica',

  // Landing - Hero (nowy szablon)
  'landing.hero.eyebrow': 'Paszport Dolnego Śląska 2026',
  'landing.hero.stampsCaption': '',
  'landing.hero.headline': 'Zbieraj wirtualne pieczątki i zostań odkrywcą Dolnego Śląska',
  'landing.hero.cta.join': 'Dołącz do wyzwania',
  'landing.hero.cta.more': 'O projekcie',
  'landing.mobileJoinBar.cta': 'Dołącz do wyzwania',

  // Landing - Hero (launch 2026)
  'landing.heroLaunch.eyebrow': 'Dołącz do odkrywców Dolnego Śląska',
  'landing.heroLaunch.headline': 'Paszport Dolnego Śląska 2026 wystartował!',
  'landing.heroLaunch.stampAlt': 'Pieczątka — Paszport Dolnego Śląska, 12 z 12 miejsc',
  'landing.heroLaunch.passportCard.aria':
    'Przykładowa kartka paszportu z sześcioma zebranymi pieczątkami z dwunastu miejsc',
  'landing.heroLaunch.passportCard.hint': 'Przykładowy podgląd z panelu uczestnika',
  'landing.heroLaunch.joinCta': 'Dołączam!',
  'landing.heroLaunch.form.subtitle': 'Załóż konto i zacznij zbierać pieczątki',
  'landing.heroLaunch.form.haveAccount': 'Masz już konto?',
  'landing.heroLaunch.form.signIn': 'Zaloguj się',
  'landing.heroLaunch.form.alreadyLogged.eyebrow': 'Cześć ponownie!',
  'landing.heroLaunch.form.alreadyLogged.title':
    'Jesteś już zalogowany — wskakuj do panelu i ruszaj po pieczątki.',
  'landing.heroLaunch.form.alreadyLogged.cta': 'Wejdź do panelu',

  // Strona /formularz
  'formularz.title': 'Załóż konto',
  'formularz.offer.eyebrow': 'Oferta startowa',
  'formularz.offer.lead': 'Płacisz',
  'formularz.offer.joinSuffix': 'za dołączenie — w pakiecie masz:',
  'formularz.offer.bulletEbook': 'Darmowy ebook (notatnik PDF na Twój e-mail)',
  'formularz.offer.bulletRefund':
    'Gwarancję zwrotu — jeśli Ci się nie spodoba, oddajemy pieniądze w 7 dni',
  'formularz.loginCta': 'Masz konto? Zaloguj się',
  'formularz.heardAbout.label': 'Skąd o nas?',
  'formularz.heardAbout.ariaLabel': 'Skąd o nas, opcjonalnie',
  'formularz.heardAbout.empty': 'Opcjonalnie',
  'formularz.legalPrefix': 'Zakładając konto, zgadzasz się z',
  'formularz.legalTermsLink': 'regulaminem',
  'formularz.submit': 'Opłać wpisowe',
  'formularz.submitSuffix': 'i dołącz',
  'formularz.tier.feeLabel': 'wpisowe',

  'fullPass.label': 'Pełny program',
  'fullPass.title': '60 miejsc do odwiedzenia',
  'fullPass.desc':
    '{{published}} miejsc gotowych, {{count}} w planie, bez limitu czasu. Najszerszy katalog na Dolnym Śląsku.',
  'fullPass.bonus': 'Notatnik do druku (PDF) w pakiecie.',
  'fullPass.meta': '60 miejsc · bez limitu czasu',

  'specialEdition2026.label': 'Edycja specjalna 2026',
  'specialEdition2026.title': '12 miejsc w 12 miesięcy',
  'specialEdition2026.desc':
    'Sezonowe wyzwanie na cały rok 2026. Zbieraj wirtualne pieczątki w swoim panelu i prowadź dziennik. Niższe wpisowe na sezon.',
  'specialEdition2026.months': '{{count}} miejsc · 12 miesięcy · sezon 2026',
  'specialEdition2026.journal': 'Indywidualny dziennik podróży w panelu',
  'specialEdition2026.ctaLanding': 'Wybieram edycję specjalną na 2026 za',
  'specialEdition2026.pickHint': 'Kliknij kartę, jeśli wolisz mniejszą skalę na sezon 2026.',
  'specialEdition2026.backToFull': 'Wracam do pełnego programu: 60 miejsc do odwiedzenia',

  'formularz.success.title': 'Dzięki, dane zapisane',
  'formularz.success.body': 'Możesz teraz dokończyć rejestrację i opłacić udział w programie.',

  // Landing - Intro (sekcja z herbem Dolnego Śląska)
  'landing.intro.eyebrow': 'O programie',
  'landing.intro.title': 'Pierwszy wirtualny turystyczny paszport na Dolnym Śląsku',
  'landing.intro.subtitle':
    'Domyślnie odkrywasz 60 miejsc bez limitu czasu. Możesz też wybrać edycję specjalną na 2026: 12 miejsc w 12 miesięcy z osobistym dziennikiem w panelu.',
  'landing.intro.subtitleMiniOnly':
    'Edycja specjalna na 2026: 12 miejsc w 12 miesięcy z osobistym dziennikiem w panelu.',
  'landing.intro.regionLogoAlt': 'Herb i logo Dolnego Śląska',

  // Landing - Honorowy patronat
  'landing.patronage.title': 'Pod honorowym patronatem',
  'landing.patronage.logoAlt':
    'Logotyp honorowego patronatu Marszałka Województwa Dolnośląskiego Pawła Gancarza',

  // Landing - Partnerzy
  'landing.partners.title': 'Partnerzy',
  'landing.partners.listAria': 'Partnerzy programu Paszport Dolnego Śląska',
  'landing.partners.pds.name': 'Przystanek Dolny Śląsk',
  'landing.partners.pds.logoAlt': 'Przystanek Dolny Śląsk — logo partnera',
  'landing.partners.mds.name': 'Miejsca Dolnego Śląska',
  'landing.partners.mds.logoAlt': 'Miejsca Dolnego Śląska — logo partnera',
  'landing.partners.skiBikeHouse.name': 'Sky & Bike House Stronie Śląskie',
  'landing.partners.skiBikeHouse.logoAlt': 'Sky & Bike House Stronie Śląskie — logo partnera',

  // Landing - Prizes teaser (banner przed sekcją Social Proof)
  'landing.prizesTeaser.eyebrow': 'Punkty i nagrody',
  'landing.prizesTeaser.title':
    'Zbieraj punkty i wygrywaj atrakcyjne nagrody związane z Dolnym Śląskiem',
  'landing.prizesTeaser.subtitle':
    'Im więcej miejsc odwiedzisz, tym wyżej trafisz w rankingu 2026. Najlepsi uczestnicy odbierają dolnośląskie nagrody na koniec roku.',
  'landing.prizesTeaser.cta': 'Załóż konto, żeby dowiedzieć się więcej',

  // Landing - Stamps showcase
  'landing.stamps.eyebrow': 'Pełny Paszport',
  'landing.stamps.eyebrowMiniOnly': 'Edycja specjalna 2026',
  'landing.stamps.title': '60 miejsc do odwiedzenia',
  'landing.stamps.titleMiniOnly': '12 miejsc w 12 miesięcy',
  'landing.stamps.subtitle':
    'Najszerszy katalog na Dolnym Śląsku: wirtualne pieczątki, ranking i notatnik do druku. Bez ograniczenia czasu.',
  'landing.stamps.subtitleMiniOnly':
    'Sezonowe wyzwanie na 2026: wirtualne pieczątki, dziennik w panelu i ranking społeczności.',
  'landing.stamps.descMiniOnly.before':
    'Paszport Dolnego Śląska to cyfrowe wyzwanie na 2026 rok. Zbierz 12 wirtualnych pieczątek i odblokuj fizyczną odznakę Paszportu Dolnego Śląska! Rób fantastyczne zdjęcia i dziel się z innymi w panelu ',
  'landing.stamps.descMiniOnly.communityLink': 'Społeczności',
  'landing.stamps.descMiniOnly.after': '.',
  'landing.stamps.listAria': 'Przykładowe pieczątki z programu',
  'landing.stamps.footnote':
    'Pieczątki powyżej pochodzą z katalogu edycji specjalnej 2026. Pełny Paszport obejmuje 60 miejsc.',
  'landing.stamps.footnoteMiniOnly':
    'Pieczątki powyżej pochodzą z katalogu edycji specjalnej 2026.',
  'landing.stamps.counter.eyebrow': 'Społeczność Paszportu',
  'landing.stamps.counter.loading': 'Liczę uczestników i zebrane pieczątki…',
  'landing.stamps.counter.usersLabel': 'osób już dołączyło',
  'landing.stamps.counter.stampsLabel': 'pieczątek już zebranych',
  'landing.stamps.counter.tagline':
    'Codziennie ktoś robi pierwszą pieczątkę. Dołącz do społeczności odkrywców i zacznij swoją kolekcję.',
  'landing.stamps.counter.fallback':
    'Dołącz do społeczności odkrywców, którzy już zbierają pieczątki i odkrywają Dolny Śląsk.',
  'landing.stamps.counter.cta': 'Dołącz do społeczności',

  'landing.howItWorks.eyebrow': 'Jak to działa',
  'landing.howItWorks.title': '3 kroki i jesteś w grze',
  'landing.howItWorks.subtitle':
    'Zakładasz konto i przez rok odwiedzasz {{count}} miejsc z listy. To wyzwanie promujące region , bez presji, za to z piękną pamiątką na koniec.',
  'landing.howItWorks.step1.title': 'Wybierz miejsce',
  'landing.howItWorks.step1.desc':
    'Przeglądasz listę {{count}} lokalizacji i układasz trasę pod siebie: jednodniówka, weekend lub urlop.',
  'landing.howItWorks.step2.title': 'Potwierdź wizytę',
  'landing.howItWorks.step2.desc':
    'Na miejscu zbierasz pieczątkę w panelu , kodem lub inną formą weryfikacji przygotowaną przez organizatora.',
  'landing.howItWorks.step3.title': 'Zbierz komplet',
  'landing.howItWorks.step3.desc':
    'Kończysz rok z listą wspomnień: pieczątkami, wpisami w dzienniku i miejscami, do których chcesz wracać.',

  // O projekcie
  'about.seo.title': 'O projekcie , Paszport Dolnego Śląska',
  'about.seo.description':
    'Historia Paszportu Dolnego Śląska: pasja do regionu, społeczność odkrywców, 12 miejsc i filozofia wolnego odkrywania bez pośpiechu.',
  'about.seo.keywords':
    'Paszport Dolnego Śląska, o projekcie, pasja, Dolny Śląsk, społeczność, 12 miejsc',
  'about.hero.eyebrow': 'O projekcie',
  'about.hero.title': 'Z pasji do Dolnego Śląska',
  'about.hero.subtitle':
    'Paszport powstał z miłości do regionu, historii i miejsc, których nie znajdziesz w popularnych przewodnikach. To zaproszenie do wolniejszego odkrywania , z pieczątkami, dziennikiem i ludźmi, którzy kochają te same zakątki.',
  'about.story.eyebrow': 'Nasza historia',
  'about.story.lead':
    'Chcemy pokazać, że Dolny Śląsk to coś więcej niż kilka znanych punktów na mapie. Każde miejsce w programie ma swoją historię , a Ty możesz napisać do niej własny rozdział.',
  'about.passion.bodyExtra':
    'Szukamy opactw ukrytych w lesie, parków, w których słychać tylko ptaki, i widoków, które zapadają w pamięć na długo po powrocie do domu. Nie musisz być „turystą z przewodnika” , wystarczy ciekawość i odrobina planu.',
  'about.passion.bodyExtra2':
    'Dlatego zamiast checklisty atrakcji dajemy ramę na cały rok: 12 miejsc, 12 miesięcy i przestrzeń na to, żeby każde z nich przeżyć po swojemu.',
  'about.community.bodyExtra':
    'W społeczności dzielimy się zdjęciami, notatkami i drobnymi odkryciami , bez rywalizacji o tempo. Możesz czytać, komentować i dodawać własne wpisy, kiedy masz na to ochotę.',
  'about.vision.title': 'Po co nam ten projekt?',
  'about.vision.body':
    'Chcemy, żeby Dolny Śląsk był odkrywany świadomie i z szacunkiem do miejsca. Paszport łączy podróż, pamięć i ludzi , tak, żeby po roku zostało coś więcej niż album zdjęć w telefonie.',

  // Aktualności
  'news.seo.title': 'Aktualności , Paszport Dolnego Śląska',
  'news.seo.description':
    'Nowości i komunikaty Paszportu Dolnego Śląska: zmiany w programie, promocje i informacje dla uczestników.',
  'news.seo.keywords': 'aktualności, nowości, Paszport Dolnego Śląska, komunikaty',
  'news.section.eyebrow': 'Aktualności',
  'news.section.title': 'Co nowego w Paszporcie',
  'news.section.subtitle': 'Krótkie wpisy o zmianach w programie, promocjach i tym, co warto wiedzieć przed startem.',
  'news.section.ctaAll': 'Wszystkie aktualności',
  'news.page.title': 'Aktualności',
  'news.page.subtitle': 'Tu publikujemy nowości o Paszporcie Dolnego Śląska , od funkcji w panelu po warunki udziału.',
  'news.page.backToAbout': '← Wróć do strony O projekcie',

  // Konkurs
  'contest.seo.title': 'Konkurs , Paszport Dolnego Śląska',
  'contest.seo.description':
    'Wygraj gadżety z Dolnego Śląska. Dołącz do Odkrywców, dodaj post w Społeczności i zgłoś go na konkurs.',
  'contest.seo.keywords': 'konkurs, gadżety, Dolny Śląsk, społeczność, Paszport Dolnego Śląska',
  'contest.news.tabsAria': 'Wybór sekcji aktualności',
  'contest.news.tabNews': 'Aktualności',
  'contest.news.tabContest': 'Konkurs',
  'contest.tab.eyebrow': 'Konkurs',
  'contest.tab.title': 'Wygraj gadżety z Dolnego Śląska',
  'contest.tab.subtitle':
    'Najciekawsze zdjęcia i opisy z Społeczności wygrywają pakiety gadżetów regionalnych.',
  'contest.tab.step1': 'Dołącz do Odkrywców Dolnego Śląska na paszportdolnegoslaska.pl',
  'contest.tab.step2': 'Dodaj post na profilu Społeczności i zaznacz Zgłoś na konkurs',
  'contest.tab.step3': 'Najciekawsze zdjęcia i opisy wygrywają',
  'contest.tab.ctaPost': 'Dodaj post i zgłoś',
  'contest.tab.ctaFeed': 'Zobacz Społeczność',
  'contest.rules.heading': 'Regulamin konkursu',
  'contest.rules.organizer.title': 'Organizator i przedmiot',
  'contest.rules.organizer.body':
    'Organizatorem konkursu jest Paszport Dolnego Śląska (paszportdolnegoslaska.pl).\nPrzedmiotem konkursu jest wybór najciekawszych zdjęć i opisów opublikowanych w Społeczności oraz nagrodzenie ich gadżetami z Dolnego Śląska.',
  'contest.rules.eligibility.title': 'Kto może wziąć udział',
  'contest.rules.eligibility.body':
    'W konkursie mogą brać udział zarejestrowani uczestnicy programu Odkrywcy Dolnego Śląska.\nUdział wymaga aktywnego konta i publikacji posta w zakładce Społeczność.',
  'contest.rules.howto.title': 'Jak wziąć udział',
  'contest.rules.howto.body':
    'Dołącz do programu na paszportdolnegoslaska.pl.\nDodaj post w Społeczności ze zdjęciem i opisem związanym z odkrywaniem Dolnego Śląska.\nPrzy publikacji zaznacz opcję Zgłoś na konkurs. Zgłoszony post oznaczamy żółtą ikoną konkursu.',
  'contest.rules.judging.title': 'Ocena zgłoszeń',
  'contest.rules.judging.body':
    'Zwycięzców wybiera organizator spośród zgłoszonych postów, kierując się ciekawością zdjęć i opisów.\nDecyzja organizatora jest ostateczna.',
  'contest.rules.prizes.title': 'Nagrody',
  'contest.rules.prizes.body':
    'Nagrodami są gadżety z Dolnego Śląska, m.in. butelki, kubek, maskotki i torba, zgodnie z materiałem konkursowym.\nSzczegółowy zestaw nagród może się różnić w zależności od dostępności.',
  'contest.rules.moderation.title': 'Moderacja i wykluczenia',
  'contest.rules.moderation.body':
    'Zgłoszenia podlegają regulaminowi kanału społecznościowego.\nOrganizator może wykluczyć treści naruszające zasady, wulgarne, reklamowe lub niezwiązane z programem.',
  'contest.rules.contact.title': 'Kontakt',
  'contest.rules.contact.body':
    'W sprawach konkursu napisz na kontakt@paszportdolnegoslaska.pl.',
  'contest.poster.alt': 'Plakat konkursu Wygraj gadżety z Dolnego Śląska',
  'contest.poster.openAria': 'Otwórz plakat konkursu',
  'contest.popup.title': 'Konkurs gadżetów z Dolnego Śląska',
  'contest.popup.closeAria': 'Zamknij popup konkursu',
  'contest.popup.later': 'Później',
  'contest.popup.cta': 'Weź udział',
  'contest.badge.label': 'Zgłoszenie konkursowe',
  'contest.badge.short': 'Konkurs',
  'contest.badge.title': 'Post zgłoszony do konkursu gadżetów',
  'contest.compose.toggle': 'Zgłoś na konkurs',
  'contest.compose.helper':
    'Zaznacz, jeśli chcesz, by ten post brał udział w konkursie gadżetów. W Społeczności pojawi się żółta ikona.',

  // Ranking
  'ranking.word': 'Ranking',
  'ranking.seo.title': 'Ranking , Paszport Dolnego Śląska',
  'ranking.seo.description':
    'Jak działają punkty w Paszporcie Dolnego Śląska, sezonowy ranking społeczności i nagrody dla zwycięzcy roku 2026.',
  'ranking.seo.keywords': 'ranking, punkty, nagrody, społeczność, Paszport Dolnego Śląska, 2026',
  'ranking.page.title': 'Ranking i nagrody',
  'ranking.page.subtitle':
    'Zbieraj punkty za aktywność w programie i w Społeczności. Na koniec 2026 roku osoba z najwyższym wynikiem wygrywa atrakcyjne nagrody.',
  'ranking.page.backToAbout': '← Wróć do strony O projekcie',
  'ranking.how.title': 'Jak zdobywać punkty?',
  'ranking.how.intro':
    'Punkty naliczamy automatycznie za wybrane działania w panelu i w Społeczności. Im więcej odkrywasz i dzielisz się wspomnieniami, tym wyżej możesz awansować w rankingu sezonowym.',
  'ranking.points.like': '1 punkt za polubienie postu w Społeczności',
  'ranking.points.invite': '50 punktów za podanie adresu e-mail osoby, która Cię zaprosiła (tylko raz)',
  'ranking.points.visit': '100 punktów za zweryfikowaną wizytę w miejscu z programu',
  'ranking.points.complete': '500 punktów za komplet wszystkich 12 miejsc',
  'ranking.how.visibility':
    'W publicznym rankingu pokazujemy uczestników od 100 punktów. Ukrycie punktów w ustawieniach konta nie wyklucza z rankingu.',
  'ranking.prizes.title': 'Nagrody na koniec 2026 roku',
  'ranking.prizes.body':
    'Na zakończenie roku 2026 zwycięzcą zostaje uczestnik z najwyższą liczbą punktów w sezonowym rankingu. Przygotowaliśmy atrakcyjne nagrody , szczegóły ogłosimy w trakcie trwania programu.',
  'ranking.prizes.note':
    'Wynik liczony jest na podstawie punktów zebranych do końca sezonu. W przypadku remisu decydują zasady opisane w regulaminie kanału społecznościowego.',
  'ranking.rulesLink.prefix': 'Pełne zasady punktacji i rankingu znajdziesz w',
  'ranking.rulesLink.label': 'regulaminie kanału społecznościowego',
  'ranking.section.eyebrow': 'Ranking 2026',
  'ranking.section.title': 'Zdobądź najwięcej punktów i wygraj nagrody',
  'ranking.section.body':
    'Odwiedzaj miejsca, dziel się wspomnieniami w Społeczności i zbieraj punkty. Na koniec roku 2026 najlepszy wynik w rankingu to atrakcyjne nagrody.',
  'ranking.section.cta': 'Jak działa ranking',
  'news.card.readMore': 'Czytaj więcej',
  'news.article.back': 'Wróć do aktualności',
  'news.post.whatIs.category': 'O programie',
  'news.post.whatIs.title': 'Paszport Dolnego Śląska 2026 — co to jest i jak działa?',
  'news.post.whatIs.excerpt':
    'Cyfrowy program na cały rok: 12 miejsc, wirtualne pieczątki, dziennik i społeczność. Wyjaśniamy krok po kroku, od rejestracji po weryfikację wizyt.',
  'news.post.whatIs.body1':
    'Paszport Dolnego Śląska to program turystyczny na sezon 2026. Nie jest kartą zniżkową ani karnetem do muzeów , to zaproszenie do świadomego odkrywania regionu we własnym tempie. Kupujesz dostęp raz, logujesz się do panelu i przez cały rok masz mapę 12 starannie wybranych miejsc, materiały do każdej lokalizacji oraz narzędzia, które zamieniają zwykłe weekendy w spójną podróż po Dolnym Śląsku.',
  'news.post.whatIs.body2':
    'Każde miejsce w programie to osobna opowieść: park, opactwo, pałac, rezerwat, wieża widokowa czy szlak. Na publicznej stronie miejsca znajdziesz artykuł, praktyczne wskazówki i mapę. W panelu uczestnika widać postęp , które punkty masz już zweryfikowane, a które czekają na wizytę. Cel sezonu? Komplet wszystkich wirtualnych pieczątek i własny dziennik z całego roku.',
  'news.post.whatIs.body3':
    'Jak zacząć? Zakładasz konto na stronie logowania, opłacasz jednorazowe wpisowe i od razu wchodzisz do panelu. Nie musisz planować całej trasy z góry: możesz jechać pojedynczo, wracać do ulubionych miejsc albo łączyć kilka punktów w jeden wyjazd. Program działa w przeglądarce na telefonie , nie trzeba instalować osobnej aplikacji.',
  'news.post.whatIs.body4':
    'Pieczątkę zdobywasz po zweryfikowanej wizycie. Na miejscu włączasz geolokalizację w panelu i potwierdzasz obecność przez GPS. Jeśli nie zdążysz tego zrobić od razu , możesz zweryfikować wizytę później: dodajesz zdjęcie z miejsca i odpowiadasz na krótki quiz o regionie i kategorii obiektu. Po sukcesie pieczątka wpada do Twojego dziennika, a miejsce na mapie oznacza się jako odkryte.',
  'news.post.whatIs.body5':
    'Paszport to nie tylko „zaliczenia”. W dzienniku zapisujesz wspomnienia, zdjęcia i notatki z każdej wizyty. W Społeczności dzielisz się doświadczeniami z innymi uczestnikami, a w rankingu sezonowym zbierasz punkty za aktywność. Na koniec 2026 roku najlepszy wynik w rankingu to atrakcyjne nagrody , szczegóły ogłaszamy w trakcie programu.',
  'news.post.whatIs.body6':
    'Wpisowe zależy od wariantu: edycja 2026 (12 miejsc) i pełny Paszport (60 miejsc) kosztują po 19 zł. W cenie masz pełny dostęp do panelu, pieczątek, dziennika i społeczności. Jeśli po zakupie uznasz, że program Ci nie pasuje , działa gwarancja zwrotu pieniędzy w ciągu 14 dni , bez proszenia o uzasadnienie.',
  'news.post.whatIs.body7.before': 'Chcesz zobaczyć listę miejsc i zaplanować pierwszy wyjazd? Zajrzyj na ',
  'news.post.whatIs.link.places': 'mapę 12 miejsc',
  'news.post.whatIs.body7.mid': ', a potem na ',
  'news.post.whatIs.link.pricing': 'stronę cennika',
  'news.post.whatIs.body7.after':
    ', żeby dołączyć do programu. Dolny Śląsk czeka , reszta roku należy do Ciebie.',
  'news.post.whatIs.img.places.alt': 'Alejka w Parku w Bukowcu, jedno z 12 miejsc programu',
  'news.post.whatIs.img.places.caption': '12 lokalizacji na mapie Dolnego Śląska , od parków po zamki i rezerwaty.',
  'news.post.whatIs.img.stamp.alt': 'Wirtualna pieczątka Park w Bukowcu w panelu uczestnika',
  'news.post.whatIs.img.stamp.caption': 'Pieczątka pojawia się po weryfikacji GPS lub quizie ze zdjęciem.',
  'news.post.whatIs.img.journal.alt': 'Dziennik podróży w panelu Paszportu Dolnego Śląska',
  'news.post.whatIs.img.journal.caption': 'Dziennik, społeczność i ranking , wszystko w jednym panelu.',
  'news.post.wilczkiWeekend.category': 'Miejsca',
  'news.post.wilczkiWeekend.title':
    'Wodospad Wilczki na weekend: 22 metry wody i Wodogrzmoty Żeromskiego',
  'news.post.wilczkiWeekend.excerpt':
    'Drugi co do wielkości wodospad w polskich Sudetach, krótkie dojście z Międzygórza i nazwa z życia Żeromskiego — którego tu prawdopodobnie nigdy nie było. Weekendowy plan z Paszportem Dolnego Śląska.',
  'news.post.wilczkiWeekend.body1':
    'A może w ten weekend wybierz się do… Wodospadu Wilczki w rezerwacie przyrody koło Międzygórza. Kilka minut spacerem od centrum wsi, a na końcu trasy czeka kaskada w zielonym wąwozie Masywu Śnieżnika — duży efekt przy małym wysiłku, bez całodniowej wyprawy.',
  'news.post.wilczkiWeekend.body2':
    'Czy wiesz, że ma aż ok. 22 metry wysokości i jest drugim co do wielkości wodospadem w polskich Sudetach, tuż po Wodospadzie Kamieńczyka w Karkonoszach? Wiosną i po deszczach Wilczka niesie najwięcej wody — wtedy kaskada robi największe wrażenie, choć w zielonym wąwozie dobrze czuć się przez cały sezon.',
  'news.post.wilczkiWeekend.body3':
    'Kiedyś nazywano go Wodogrzmotami Żeromskiego — nazwa miała nadać miejscu polski charakter po II wojnie światowej, chociaż sam Stefan Żeromski prawdopodobnie nigdy tam nie dotarł. Dziś znów mówi się po prostu o Wodospadzie Wilczki, a rezerwat chroni ten fragment doliny Wilczki od 1958 roku.',
  'news.post.wilczkiWeekend.body4':
    'Na sam wodospad i powrót wystarczy ok. 30–60 minut. W sezonie bywa tłoczno, więc rano w dni powszednie to najlepszy moment na spokojne zdjęcia. Przy kaskadzie bywa mokro i ślisko — trzymaj się wyznaczonej ścieżki i barierki tam, gdzie jest ustawiona.',
  'news.post.wilczkiWeekend.body5.before':
    'W Paszporcie Dolnego Śląska Rezerwat Wodospad Wilczki to jedno z 12 miejsc sezonu 2026. Na stronie miejsca znajdziesz artykuł, galerię zdjęć i wskazówki przed wyjazdem — zobacz ',
  'news.post.wilczkiWeekend.link.place': 'Wodospad Wilczki',
  'news.post.wilczkiWeekend.body5.after':
    ' — a po wizycie zbierz pieczątkę w panelu.',
  'news.post.wilczkiWeekend.body6':
    'Samo Międzygórze zawdzięcza swój urok… Mariannie Orańskiej! Pałac Marianny może być Twoim drugim punktem odkrywania Dolnego Śląska z Paszportem Dolnego Śląska!',
  'news.post.wilczkiWeekend.body7.before':
    'Neogotycka rezydencja w Kamieńcu Ząbkowickim, tarasy i park angielski — wszystko o tym miejscu przeczytasz w artykule o ',
  'news.post.wilczkiWeekend.link.palace': 'Pałacu Marianny Orańskiej',
  'news.post.wilczkiWeekend.body7.after': '.',
  'news.post.wilczkiWeekend.img.waterfall.alt':
    'Wodospad Wilczki w rezerwacie przyrody koło Międzygórza — główna kaskada w Masywie Śnieżnika',
  'news.post.wilczkiWeekend.img.waterfall.caption':
    'Ok. 22 metry spadającej wody — jeden z najwyższych wodospadów w polskich Sudetach.',
  'news.post.skiBikeHouse.category': 'Partnerzy',
  'news.post.skiBikeHouse.title':
    'Sky & Bike House Stronie Śląskie: nowy partner Paszportu Dolnego Śląska',
  'news.post.skiBikeHouse.excerpt':
    'W okolicy Masywu Śnieżnika dołącza nocleg na aktywny wypad: zwiedź Wodospad Wilczki, zbierz pieczątkę i zostań na rowerową noc w Stroniu Śląskim.',
  'news.post.skiBikeHouse.body1':
    'Do grona partnerów Paszportu Dolnego Śląska dołącza Sky & Bike House Stronie Śląskie — baza w sercu Ziemi Kłodzkiej dla osób, które łączą zwiedzanie z ruchem na dwóch kółkach. To naturalne połączenie z naszym programem: w ciągu dnia pieczątka przy wodospadzie, wieczorem aktywny odpoczynek blisko szlaków.',
  'news.post.skiBikeHouse.body2':
    'Sky & Bike House to miejsce w Stroniu Śląskim stworzone z myślą o rowerzystach i miłośnikach górskich tras. Nocujesz blisko wyjazdów na szlaki, planujesz kolejny etap na mapie i wracasz po wycieczce tam, gdzie tempo wyjazdu jest dopasowane do aktywnego wypoczynku — bez pośpiechu, za to z porządną dawką ruchu.',
  'news.post.skiBikeHouse.body3':
    'W programie Paszportu znajdziesz też Rezerwat Wodospad Wilczki — jedno z 12 miejsc sezonu 2026. Krótkie podejście, efektowny wodospad w otoczeniu zieleni i od razu szansa na zebranie pieczątki w panelu po zweryfikowanej wizycie. Po wizycie warto zostać w okolicy dłużej: połącz wodospad z noclegiem w Stroniu i zaplanuj aktywny weekend na rowerze.',
  'news.post.skiBikeHouse.body4.before': 'Więcej o ofercie noclegowej, trasach i warunkach pobytu znajdziesz na stronie ',
  'news.post.skiBikeHouse.link.website': 'skibikehouse.pl',
  'news.post.skiBikeHouse.body4.after':
    '. Jeśli szukasz bazy na odkrywanie Masywu Śnieżnika z pieczątką w kieszeni — to dobre miejsce na start.',
  'news.post.skiBikeHouse.img.logo.alt':
    'Logo Sky & Bike House Stronie Śląskie, partner Paszportu Dolnego Śląska',
  'news.post.skiBikeHouse.img.logo.caption':
    'Nocleg i baza rowerowa w Stroniu Śląskim, w pobliżu Wodospadu Wilczki.',
  'news.post.pdsPartner.category': 'Partnerzy',
  'news.post.pdsPartner.title':
    'Przystanek Dolny Śląsk: nowy partner Paszportu Dolnego Śląska',
  'news.post.pdsPartner.excerpt':
    'Do grona partnerów programu dołącza jedyny taki kwartalnik o regionie: bezpłatne archiwum wydań online i inspiracje, które świetnie łączą się z podróżą po 12 miejscach.',
  'news.post.pdsPartner.body1':
    'Z radością informujemy, że Przystanek Dolny Śląsk został partnerem Paszportu Dolnego Śląska. To spotkanie dwóch inicjatyw, które mówią o tym samym regionie innym językiem: my zapraszamy do aktywnego zwiedzania z pieczątkami i dziennikiem, oni od ponad dekady opowiadają o Dolnym Śląsku w formie kwartalnika, który czyta się jak dobra wycieczka.',
  'news.post.pdsPartner.body2.before':
    'Przystanek Dolny Śląsk to magazyn poświęcony krajoznawstwu, historii regionalnej oraz turystyce indywidualnej i transporcie publicznym. Wydaje go ',
  'news.post.pdsPartner.link.institute': 'Instytut Dolnośląski',
  'news.post.pdsPartner.body2.after':
    ', instytucja która łączy miłośników regionu: jego dziejów, kultury, przyrody i zabytków. Każdy numer to setki stron reportaży, szlaków, ciekawostek kolejowych i opowieści z miejsc, które często mijamy w pośpiechu.',
  'news.post.pdsPartner.body3':
    'Kwartalnik ukazuje się regularnie, sezonowo (wiosną, latem, jesienią i zimą) i od lat buduje archiwum wydań dostępnych bezpłatnie w sieci. To rzadkość: pismo, które nie chowa treści za paywallem, tylko zaprasza do lektury wszystkich zainteresowanych Dolnym Śląskiem.',
  'news.post.pdsPartner.body4.before': 'Najnowsze i starsze numery możesz pobrać na stronie ',
  'news.post.pdsPartner.link.website': 'przystanekd.pl',
  'news.post.pdsPartner.body4.after':
    '. W archiwum kwartalnika znajdziesz dziesiątki wydań, część z nich sprzed ponad dziesięciu lat. Przed wyjazdem do punktów z mapy Paszportu warto zajrzeć do aktualnego numeru: znajdziesz tam pomysły na trasy, kontekst historyczny i inspiracje, które ubierają samą wizytę w pełniejszą opowieść.',
  'news.post.pdsPartner.body5.before':
    'Jeśli podoba Ci się ten klimat, obserwuj Przystanek online: zapisz się na ',
  'news.post.pdsPartner.link.substack': 'newsletter na Substacku',
  'news.post.pdsPartner.body5.mid': ' i zajrzyj na ',
  'news.post.pdsPartner.link.biblioteczka': 'Dolnośląską biblioteczkę',
  'news.post.pdsPartner.body5.after':
    ', gdzie redakcja dzieli się zapowiedziami numerów, fragmentami artykułów i dolnoslaskimi odkryciami. Wspólnie chcemy, żeby Dolny Śląsk był nie tylko odwiedzany, ale też rozumiany i pamiętany: na mapie programu i na kartach kwartalnika.',
  'news.post.pdsPartner.img.logo.alt':
    'Logo Przystanek Dolny Śląsk, partner Paszportu Dolnego Śląska',
  'news.post.pdsPartner.img.logo.caption':
    'Jedyny taki kwartalnik o Dolnym Śląsku. Wydawca: Instytut Dolnośląski.',
  'news.post.launch.category': 'Premiera',
  'news.post.launch.title':
    'Premiera: jedyny Paszport Dolnego Śląska. Zbierz wszystkie wirtualne pieczątki',
  'news.post.launch.excerpt':
    'Rusza nowa atrakcja turystyczna na Dolny Śląsk. Roczna podróż przez 12 miejsc, wirtualne pieczątki w panelu i wspomnienia na dłużej niż jeden weekend.',
  'news.post.launch.body1':
    'Na mapie Dolnego Śląska pojawia się coś, czego wcześniej tu nie było w takiej formie. Paszport Dolnego Śląska to program na 12 miesięcy, 12 wyjątkowych miejsc i 12 historii do przeżycia we własnym tempie. To nie kolejny przewodnik z listą must see, tylko zaproszenie do świadomego odkrywania regionu z pieczątkami, dziennikiem i społecznością podróżników.',
  'news.post.launch.body2':
    'W panelu uczestnika zbierasz wirtualne pieczątki za zweryfikowane wizyty w miejscach z programu. Każda pieczątka to odznaczenie na mapie i punkt wyjścia do artykułu, zdjęć oraz wspomnień w dzienniku. Cel sezonu? Komplet wszystkich pieczątek i pełna opowieść o roku na Dolnym Śląsku.',
  'news.post.launch.body3':
    'Program łączy turystykę, historię i ludzi. W jednym miejscu masz mapę miejsc, ranking sezonowy, kanał społecznościowy i materiały przygotowane z szacunkiem do lokalnych opowieści. Możesz jechać sam, z rodziną lub z przyjaciółmi. Odkrywaj w swoim rytmie, bez presji zaliczenia wszystkiego w jeden dzień.',
  'news.post.launch.body4':
    'Paszport Dolnego Śląska jest dziś jedyną tego typu inicjatywą w regionie. Spójny sezon 2026, przejrzyste zasady i jeden panel, w którym widać postęp. Jeśli szukasz nowej atrakcji na Dolny Śląsk, nie tylko jednego muzeum czy punktu widokowego, ale całorocznej przygody, to właśnie ten format.',
  'news.post.launch.body5':
    'Dołącz do programu, zajrzyj do mapy miejsc i zacznij kolekcjonować pieczątki. Pierwsze kroki zajmą kilka minut. Reszta roku należy do Ciebie i do Dolnego Śląska, który dopiero poznasz.',
  'news.post.launch.hashtag.before':
    'Pokazuj Dolny Śląsk na swoich zdjęciach. Udostępniaj wspomnienia z wizyt i dodaj do posta ',
  'news.post.launch.hashtag.after':
    '. Chętnie zobaczymy Twoje kadry w Społeczności i przy punktach w rankingu.',
  'news.post.launch.img.journal.alt': 'Dziennik podróży w panelu Paszportu Dolnego Śląska',
  'news.post.launch.img.journal.caption': 'Zapisuj wspomnienia z każdego miejsca w swoim dzienniku.',
  'news.post.launch.img.places.alt': 'Alejka w Parku w Bukowcu, jedno z miejsc programu',
  'news.post.launch.img.places.caption': '12 miejsc na mapie. Każde z własną historią i pieczątką.',
  'news.post.launch.img.stamp.alt': 'Wirtualna pieczątka Park w Bukowcu',
  'news.post.launch.img.stamp.caption': 'Pieczątki zbierasz w panelu po zweryfikowanej wizycie.',
  'news.post.launch.img.landscape.alt': 'Górskie jezioro na Dolnym Śląsku',
  'news.post.launch.img.landscape.caption': 'Region czeka na Twoje zdjęcia i historie z trasy.',
  'news.post.guarantee.category': 'Gwarancja',
  'news.post.guarantee.title': 'Gwarancja ceny i zwrot pieniędzy',
  'news.post.guarantee.excerpt':
    'Dodaliśmy przejrzystą gwarancję: korzystasz z promocyjnej ceny wpisowego, a jeśli program Ci nie pasuje , zwracamy opłatę w ciągu 14 dni.',
  'news.post.guarantee.body1':
    'Chcemy, żeby decyzja o dołączeniu była spokojna i bez ryzyka. Dlatego obok promocji startowej działa gwarancja satysfakcji: masz czas, żeby zajrzeć do panelu, zobaczyć mapę miejsc i poczuć, czy taki sposób odkrywania Dolnego Śląska jest dla Ciebie.',
  'news.post.guarantee.body2':
    'Jeśli po rozpoczęciu uznasz, że Paszport nie spełnia Twoich oczekiwań , wystarczy, że napiszesz do nas w ciągu 14 dni od zakupu. Zwrócimy wpisowe bez proszenia o uzasadnienie , zgodnie z regulaminem.',
  'news.post.guarantee.body3':
    'Szczegóły procedury i wyjątków znajdziesz w regulaminie. Na stronie logowania i w panelu przypominamy też o gwarancji , żeby była zawsze pod ręką.',

  // Landing - Sekcje numerowane 01 / 02
  'landing.section01.eyebrow': '01',
  'landing.section01.title': 'Odkryj nieznane perełki',
  'landing.section01.body':
    'Paszport Dolnego Śląska powstał z pasji. Z pasji do regionu, historii i przepięknych miejsc tych mniej znanych, których nie znajdziesz w przewodnikach po województwie.',
  'landing.section01.cta': 'Dołączam!',
  'landing.section02.eyebrow': '02',
  'landing.section02.title': 'Dołącz do społeczności',
  'landing.section02.body':
    'Odkrywcy Dolnego Śląska to wspaniali ludzie, którzy tak jak Ty chcą przeżyć i doświadczać życia. Dołącz do programu Paszport Dolnego Śląska, żeby ich poznać.',
  'landing.section02.cta': 'Zobacz społeczność',

  // Landing - Pull quote
  'landing.pullQuote.text':
    'Ten projekt ma pokazać, że Dolny Śląsk to nie tylko Wrocław i Śnieżka.',
  'landing.pullQuote.author': 'Zuzia Kowalska',
  'landing.pullQuote.role': 'Twórca',

  // Landing - Manifesto „12 miejsc. 12 przygód. 12 miesięcy.”
  'landing.manifesto.eyebrow': 'Paszport Dolnego Śląska 2026',
  'landing.manifesto.title': '12 miejsc. 12 przygód. 12 miesięcy.',
  'landing.manifesto.body':
    'Z jednej strony wystarczy, że wsiądziesz w samochód i ruszysz w trasę po wybranych miejscach. Z drugiej , dajemy Ci ramę, dzięki której każdy weekend zmienia się w mały rytuał odkrywania regionu. Zbierasz pieczątki, prowadzisz dziennik, dzielisz się tym, co Cię zaskoczyło. Podejmij wyzwanie i poznaj Dolny Śląsk.',

  // Landing - Galeria
  'landing.gallery.title': 'Odkrywaj i doświadczaj!',
  'landing.gallery.subtitle': 'Poznaj Dolny Śląsk, jakiego nie znasz',
  'landing.gallery.headerImageAlt': 'Dolny Śląsk , park krajobrazowy, widok z drona',
  'landing.gallery.spotlightEyebrow': 'W programie',
  'landing.gallery.spotlightTitle': 'Opactwo Cystersów w Lubiążu',
  'landing.gallery.spotlightBody':
    'Jeden z największych zespołów klasztornych w Europie , barokowa skala w jednym kadrze.',
  'landing.gallery.spotlightCta': 'Zobacz miejsce',
  'landing.gallery.spotlightAltDrone': 'Opactwo cystersów w Lubiążu , widok z drona',
  'landing.gallery.spotlightAltFront': 'Opactwo cystersów w Lubiążu , elewacja',
  'landing.gallery.spotlightAltDetail': 'Opactwo cystersów w Lubiążu , detal architektury',
  'landing.gallery.mapEyebrow': 'Mapa miejsc',
  'landing.gallery.mapTitle': '60 miejsc na mapie Dolnego Śląska',
  'landing.gallery.mapTitleMiniOnly': '12 miejsc na mapie Dolnego Śląska',
  'landing.gallery.mapBody':
    'Przeglądaj pełny katalog na mapie. Powiększ widok, sprawdź lokalizacje i dołącz do programu, żeby odkryć szczegóły.',
  'landing.gallery.mapBodyMiniOnly':
    '12 wyjątkowych i mniej popularnych, ale niesamowicie atrakcyjnych miejsc Dolnego Śląska, które zachwycą Cię swoją historią albo niesamowitymi widokami. Odkryjesz Dolny Śląsk, jakiego jeszcze nie znasz.',
  'landing.gallery.mapHint': 'Wybierz pinezkę na mapie, aby zobaczyć podgląd miejsca.',
  'landing.gallery.mapOpenPlace': 'Zobacz miejsce',
  'landing.gallery.mapLockedTitle': 'Dołącz do wyzwania, żeby odkryć miejsca',
  'landing.gallery.mapLockedCta': 'Zarejestruj się',

  // Landing , wybrane miejsca
  'landing.placesSection.eyebrow': 'Z programu',
  'landing.placesSection.title': 'Odkryj miejsca',
  'landing.placesSection.subtitle': 'Trzy propozycje na start , pełną listę znajdziesz w przewodniku.',
  'landing.placesSection.ctaAll': 'Zobacz wszystkie',

  // Landing - Aplikacja mobilna
  'landing.app.title': 'Paszport Dolnego Śląska dostępny w aplikacji!',
  'landing.app.subtitle':
    'Pobierz aplikację i zbieraj wirtualne pieczątki w 12 wyjątkowych miejscach Dolnego Śląska.',
  'landing.app.cta': 'Pobierz',
  'landing.app.imageAlt':
    'Telefon z aplikacją Paszport Dolnego Śląska na plaży nad Zalewem Mietków',

  // Landing - Feature: dziennik / pieczątki
  'landing.journalFeature.title':
    'Zbieraj wirtualne pieczątki w swoim panelu i prowadź dziennik',
  'landing.journalFeature.subtitle':
    'Odkrywaj nowe miejsca, zapisuj doświadczenia',
  'landing.journalFeature.cta': 'Dołączam!',
  'landing.journalFeature.previewAlt':
    'Podgląd panelu użytkownika , wpis w dzienniku z miejscem „Park w Bukowcu”',

  'landing.journalPreview.regionAria': 'Interaktywny podgląd dziennika z panelu użytkownika',
  'landing.journalPreview.demoEyebrow': 'Podgląd panelu , osobisty dziennik',
  'landing.journalPreview.hint': 'Kliknij inny wpis, aby przełączyć rozdział.',
  'landing.journalPreview.tabsAria': 'Wybór przykładowego wpisu w dzienniku',
  'landing.journalPreview.entry.1.note':
    'Wróciłam zmęczona i szczęśliwa , ten park naprawdę sprzyja spowolnieniu. Najbardziej zapadł mi w pamięć widok w stronę Karkonoszy z jednej z polan.',
  'landing.journalPreview.entry.1.more':
    'Zabrałam termos herbaty i usiadłam na ławce przy stawie. To był jeden z tych dni, kiedy nic się nie „musiało”.',
  'landing.journalPreview.entry.2.note':
    'Skala budowli robi wrażenie już z parkingu. W środku najbardziej kusi spokój krużganków , robiłam tam sporo zdjęć detalu.',
  'landing.journalPreview.entry.2.more':
    'Warto przyjechać wcześniej; później przybywa grup i trudniej poczuć klimat.',
  'landing.journalPreview.entry.3.note':
    'Neogotycki pałac jak z ilustracji , tarasy i schody robią robotę przy zachodzie słońca.',
  'landing.journalPreview.entry.3.more':
    'Połączyłam zwiedzanie z krótkim spacerem po okolicy; dzień zleciał szybciej niż myślałam.',
  'landing.panelShowcase.eyebrow': 'Funkcje panelu',
  'landing.panelShowcase.title': 'Poznaj panel od środka',
  'landing.panelShowcase.subtitle':
    'Przewijaj zrzuty i zobacz, jak działa dziennik, mapa, weryfikacja oraz gotowe propozycje wyjazdu.',
  'landing.panelShowcase.imageAlt': 'Podgląd funkcji panelu: {{title}}',
  'landing.panelShowcase.slideLabel': 'Ekran {{current}} z {{total}}',
  'landing.panelShowcase.prevAria': 'Poprzedni ekran funkcji panelu',
  'landing.panelShowcase.nextAria': 'Następny ekran funkcji panelu',
  'landing.panelShowcase.tabsAria': 'Wybór podglądu funkcji panelu',
  'landing.panelShowcase.slide.journal.title': 'Dziennik podróży',
  'landing.panelShowcase.slide.journal.body':
    'Każde odwiedzone miejsce zapisuje się jako rozdział — z datą, zdjęciem i notatką, którą możesz rozwijać.',
  'landing.panelShowcase.slide.personalJournal.title': 'Osobiste wpisy',
  'landing.panelShowcase.slide.personalJournal.body':
    'Własne przemyślenia i wspomnienia masz zawsze pod ręką. To Twoja prywatna kronika wypraw po Dolnym Śląsku.',
  'landing.panelShowcase.slide.verification.title': 'Szybka weryfikacja',
  'landing.panelShowcase.slide.verification.body':
    'Panel prowadzi Cię przez prostą weryfikację miejsca, dzięki czemu od razu odblokowujesz pieczątkę i kolejny etap dziennika.',
  'landing.panelShowcase.slide.map.title': 'Interaktywna mapa',
  'landing.panelShowcase.slide.map.body':
    'Na mapie widzisz, które miejsca masz już zaliczone i co jeszcze czeka na odkrycie.',
  'landing.panelShowcase.slide.tripProposal.title': 'Propozycja wyjazdu',
  'landing.panelShowcase.slide.tripProposal.body':
    'Dostajesz gotową inspirację na kolejny wypad: gdzie pojechać, co zobaczyć i jak zaplanować trasę.',

  // Landing - Bez AI
  'landing.noAi.title': 'Bez AI, bez bodźców.',
  'landing.noAi.body':
    'Wszystkie treści, jakie tu zobaczysz, to praca ludzkich rąk. To również miejsca dla Twojej twórczości, wrażliwości i prostego odkrywania. Prowadź dziennik, zapisuj, co Cię zaskoczyło, co Ci się spodobało, a co Ci się nie spodobało. Dziel się tym z innymi i poznawaj punkt widzenia osób podobnych do Ciebie!',

  // Landing - Banner CTA „dołączyć!”
  'landing.joinBanner.line1': 'Nie pozostaje nic innego niż…',
  'landing.joinBanner.line2': 'dołączyć!',
  'landing.joinBanner.aria': 'Dołącz do programu Paszport Dolnego Śląska',

  // Landing - FAQ (nowa zawartość zgodna z Figmą)
  'landing.faq.eyebrow': 'FAQ',
  'landing.faq.title': 'Najczęściej zadawane pytania',
  'landing.faq.subtitle':
    'Krótkie odpowiedzi na pytania, które zwykle pojawiają się przed dołączeniem.',
  'landing.faq.q1': 'Dlaczego jest tylko 12 miejsc?',
  'landing.faq.a1':
    'Bo chcę, żeby każde miejsce było przeżyciem. Poświęć czas na zrobienie pięknych zdjęć oraz prowadzenie swojego wirtualnego dziennika.',
  'landing.faq.q2': 'Jak odbywa się weryfikacja miejsca?',
  'landing.faq.a2':
    'Wystarczy, że na miejscu odpalisz geolokalizację. A jeżeli zapomnisz, możesz zweryfikować miejsce po zdjęciu i krótkim quizie.',
  'landing.faq.q3': 'Co kiedy skończę?',
  'landing.faq.a3':
    'Będziesz mieć dostęp do elektronicznej odznaki, dyplomu oraz możliwość zamówienia fizycznej odznaki.',
  'landing.faq.q4': 'Ile kosztuje dołączenie do programu?',
  'landing.faq.a4': 'Edycja 2026 (12 miejsc) i pełny Paszport (60 miejsc) — po 19 zł. Drugą wersję dokupisz w panelu za 19 zł.',
  'landing.faq.a4MiniOnly':
    'Edycja 2026 obejmuje 12 miejsc. Wpisowe to 19 zł za cały sezon, panel, pieczątki, dziennik i społeczność.',
  'landing.faq.q5': 'Czy mogę wygrać nagrody w rankingu?',
  'landing.faq.a5':
    'Tak. Zbieraj punkty za aktywność w programie i Społeczności , odwiedziny miejsc, polubienia i inne działania opisane na stronie rankingu. Uczestnik z najwyższym wynikiem na koniec 2026 roku otrzyma atrakcyjne nagrody.',
  'landing.physicalPassport.eyebrow': 'Nowość',
  'landing.physicalPassport.title': 'Fizyczny Paszport Dolnego Śląska , książeczka',
  'landing.physicalPassport.body':
    'Pracujemy nad papierową wersją paszportu, którą będzie można zabrać ze sobą w teren, zbierać pieczątki i notatki z podróży. Chcesz dostać informację jako pierwsza/-y, gdy ruszą zapisy?',
  'landing.physicalPassport.form.label': 'Podaj email, jeśli jesteś zainteresowana/-y',
  'landing.physicalPassport.form.placeholder': 'twoj@email.pl',
  'landing.physicalPassport.form.submit': 'Dołącz do newslettera',
  'landing.physicalPassport.form.submitting': 'Zapisuję…',
  'landing.physicalPassport.form.success':
    'Super, zapisane! Damy Ci znać mailowo, gdy ruszy fizyczna książeczka.',
  'landing.physicalPassport.form.error.invalidEmail': 'Podaj poprawny adres email.',
  'landing.physicalPassport.form.error.generic':
    'Nie udało się zapisać maila. Spróbuj ponownie później.',

  'landing.waitlistPopup.eyebrow': 'Za darmo',
  'landing.waitlistPopup.title': 'Odkryj Dolny Śląsk za darmo',
  'landing.waitlistPopup.body':
    'Zostaw swój adres email i dołącz do newslettera, aby być na bieżąco.',
  'landing.waitlistPopup.form.label': 'Twój adres email',
  'landing.waitlistPopup.form.placeholder': 'twoj@email.pl',
  'landing.waitlistPopup.form.submit': 'Zapisz mnie na listę',
  'landing.waitlistPopup.form.submitting': 'Zapisuję…',
  'landing.waitlistPopup.form.success':
    'Świetnie! Jesteś na liście — odezwiemy się mailowo i będziemy podsyłać ciekawostki z Dolnego Śląska.',
  'landing.waitlistPopup.form.error.invalidEmail': 'Podaj poprawny adres email.',
  'landing.waitlistPopup.form.error.generic':
    'Nie udało się zapisać maila. Spróbuj ponownie później.',
  'landing.waitlistPopup.later': 'Później',
  'landing.waitlistPopup.closeAria': 'Zamknij okno',

  // Landing - Why
  'landing.why.badge': 'O akcji',
  'landing.why.title.line1.before': 'Odkryj',
  'landing.why.title.line1.emphasis': 'Dolny Śląsk',
  'landing.why.title.line2.before': 'z nowej',
  'landing.why.title.line2.emphasis': 'perspektywy',
  'landing.why.cards.places.title': '12 wyjątkowych miejsc',
  'landing.why.cards.places.desc':
    'Starannie wybrana lista atrakcji , natura, zabytki i historie, do których chcesz wracać.',
  'landing.why.cards.days.title': '365 dni na komplet',
  'landing.why.cards.days.desc':
    'Zbierasz pieczątki w swoim tempie: weekendami, na urlopie albo przy okazji krótkich wypadów.',
  'landing.why.cards.rules.title': 'Proste zasady',
  'landing.why.cards.rules.desc':
    'Zakładasz konto, odwiedzasz miejsca i potwierdzasz wizyty. Resztę zostawiamy Twojej ciekawości.',

  // Landing - Badge / challenge
  'landing.badge.kicker': 'Wyzwanie',
  'landing.badge.title.line1': 'Zbierz komplet',
  'landing.badge.title.line2': 'i zamknij rok historią',
  'landing.badge.subtitle':
    'Odznaka to symbol drogi , nie chodzi o tempo, tylko o odkrywanie. Każda pieczątka to jeden prawdziwy dzień w terenie.',
  'landing.badge.cta.primary': 'Zobacz miejsca',
  'landing.badge.cta.secondary': 'O akcji',
  'landing.badge.cards.places.k': 'Miejsca',
  'landing.badge.cards.places.v': '12 lokalizacji do odwiedzenia',
  'landing.badge.cards.months.k': 'Czas',
  'landing.badge.cards.months.v': '12 miesięcy na zebranie kompletu',
  'landing.badge.cards.stories.k': 'Historie',
  'landing.badge.cards.stories.v': 'Twoje wpisy, notatki i wspomnienia',

  // Community (public feed)
  'community.public.title': 'Społeczność',
  'community.public.subtitle':
    'Wspomnienia, odkrycia i kadry uczestników Paszportu Dolnego Śląska. Zaloguj się, żeby dodać swój post.',
  'community.public.filter.allPlaces': 'Wszystkie miejsca',
  'community.public.filter.label': 'Filtruj po miejscu',
  'community.public.filter.popular': 'Najbardziej popularne',
  'community.feed.empty': 'Tu jeszcze pusto. Bądź pierwszą osobą, która podzieli się historią.',
  'community.feed.loading': 'Ładowanie postów…',
  'community.feed.loadMore': 'Pokaż więcej',
  'community.feed.loadError': 'Nie udało się pobrać postów społeczności.',
  'community.feed.cta.addPost': 'Dodaj post',
  'community.feed.cta.loginToPost': 'Załóż konto, aby dodawać posty',
  'community.leaderboard.title': 'Ranking sezonu',
  'community.leaderboard.titleSuffix': 'sezonu',
  'community.leaderboard.moreInfo': 'Więcej informacji',
  'community.leaderboard.noSeason': 'Brak aktywnego sezonu',
  'community.leaderboard.status.active': 'Sezon aktywny',
  'community.leaderboard.status.closed': 'Sezon zamknięty',
  'community.leaderboard.loading': 'Ładowanie rankingu…',
  'community.leaderboard.empty': 'Brak punktów w tym sezonie.',
  'community.leaderboard.loadError': 'Nie udało się pobrać rankingu.',
  'community.gate.title': 'Zaloguj się, aby zobaczyć więcej postów',
  'community.gate.subtitle':
    'Początek feedu jest publiczny. Aby kontynuować przeglądanie społeczności, zaloguj się lub załóż konto.',
  'community.gate.backToPreview': 'Wróć do podglądu (bez logowania)',
  'community.registerNudge.title': 'Dołącz do społeczności',
  'community.registerNudge.body': 'Zarejestruj się, żeby dodawać swoje posty, komentować i zbierać punkty w rankingu.',
  'community.registerNudge.cta': 'Zarejestruj się',
  'community.registerNudge.later': 'Nie teraz',
  'community.registerNudge.close': 'Zamknij',
  'community.post.author.anonymous': 'Anonimowy podróżnik',

  // Community (panel)
  'community.panel.title': 'Społeczność',
  'community.panel.subtitle':
    'Twórz nowe posty, zarządzaj treścią i zdjęciami swoich wpisów społeczności.',
  'community.panel.compose.eyebrow': 'Nowy wpis',
  'community.panel.posts.eyebrow': 'Twoje wpisy',
  'community.panel.compose.title': 'Nowy post',
  'community.panel.compose.place.label': 'Miejsce (wymagane)',
  'community.panel.compose.place.placeholder': 'Wybierz miejsce z paszportu',
  'community.panel.compose.body.label': 'Treść posta',
  'community.panel.compose.body.placeholder': 'Napisz, czym chcesz się podzielić…',
  'community.panel.compose.body.counter': '{{current}}/{{max}}',
  'community.panel.compose.photos.label': 'Zdjęcia (opcjonalne)',
  'community.panel.compose.photos.helper':
    'Dozwolone JPG / PNG / WebP. Duże pliki zostaną automatycznie zmniejszone.',
  'community.panel.compose.submit': 'Opublikuj post',
  'community.panel.compose.submitting': 'Publikowanie…',
  'community.panel.compose.success': 'Post został opublikowany.',
  'community.panel.posts.title': 'Twoje posty',
  'community.panel.posts.empty': 'Nie masz jeszcze postów. Napisz pierwszy powyżej.',
  'community.panel.posts.loading': 'Ładowanie Twoich postów…',
  'community.panel.posts.loadError': 'Nie udało się pobrać Twoich postów.',
  'community.panel.posts.editBody': 'Edytuj treść',
  'community.panel.posts.saveBody': 'Zapisz treść',
  'community.panel.posts.cancelEdit': 'Anuluj edycję',
  'community.panel.posts.addPhoto': 'Dodaj zdjęcie',
  'community.panel.posts.addingPhoto': 'Wgrywanie zdjęcia…',
  'community.panel.posts.deletePhoto': 'Usuń zdjęcie',
  'community.panel.posts.deletePhoto.confirm': 'Usunąć to zdjęcie z posta?',
  'community.panel.posts.delete': 'Usuń post',
  'community.panel.posts.delete.confirm': 'Na pewno usunąć ten post? Tej operacji nie da się cofnąć.',
  'community.panel.posts.viewPublic': 'Zobacz w feedzie',
  'community.errors.notLoggedIn': 'Najpierw zaloguj się na konto.',
  'community.errors.placeRequired': 'Wybierz miejsce, którego dotyczy post.',
  'community.errors.bodyRequired': 'Treść posta nie może być pusta.',
  'community.errors.bodyTooLong': 'Treść posta jest za długa.',
  'community.errors.saveFailed': 'Nie udało się zapisać posta.',
  'community.errors.deleteFailed': 'Nie udało się usunąć posta.',
  'community.errors.uploadFailed': 'Nie udało się wgrać zdjęcia.',

  // Publish to community (panel szczegółów miejsca)
  'community.publish.title': 'Opublikuj w społeczności',
  'community.publish.subtitle':
    'Podziel się swoim opisem tego miejsca z innymi użytkownikami w publicznym feedzie społeczności.',
  'community.publish.loginRequired': 'Aby opublikować, zaloguj się na konto.',
  'community.publish.loading': 'Sprawdzam status publikacji…',
  'community.publish.notPublishedHint':
    'Twój opis tego miejsca nie został jeszcze opublikowany w społeczności. Po publikacji znajdzie się w feedzie /spolecznosc.',
  'community.publish.cta': 'Opublikuj w Społeczności',
  'community.publish.publishing': 'Publikowanie…',
  'community.publish.publishedAt': 'Opublikowano {{date}}',
  'community.publish.publishedBody': 'Opublikowana treść',
  'community.publish.viewInFeed': 'Zobacz w feedzie',
  'community.publish.edit': 'Edytuj treść',
  'community.publish.save': 'Zapisz zmiany',
  'community.publish.saving': 'Zapisywanie…',
  'community.publish.cancel': 'Anuluj',
  'community.publish.error.bodyRequired':
    'Najpierw wypełnij opis powyżej (notatka lub odpowiedź na pytanie), a potem publikuj.',
  'community.publish.error.bodyTooLong': 'Treść posta jest za długa.',
  'community.publish.error.publish': 'Nie udało się opublikować w społeczności.',
  'community.publish.error.update': 'Nie udało się zapisać zmian w opublikowanym poście.',
  'community.publish.error.load': 'Nie udało się sprawdzić statusu publikacji.',

  // Likes
  'community.likes.count': '{{count}}',
  'community.likes.like': 'Polub',
  'community.likes.liked': 'Polubione',
  'community.likes.loginToLike': 'Zaloguj się, żeby polubić',
  'community.likes.error': 'Nie udało się zaktualizować polubienia.',

  // Comments
  'community.comments.count': 'Komentarze ({{count}})',
  'community.comments.show': 'Pokaż komentarze ({{count}})',
  'community.comments.hide': 'Ukryj komentarze',
  'community.comments.loading': 'Ładowanie komentarzy…',
  'community.comments.empty': 'Brak komentarzy. Napisz pierwszy.',
  'community.comments.loadError': 'Nie udało się załadować komentarzy.',
  'community.comments.compose.placeholder': 'Napisz komentarz…',
  'community.comments.compose.submit': 'Wyślij',
  'community.comments.compose.submitting': 'Wysyłanie…',
  'community.comments.compose.loginCta': 'Zaloguj się, żeby komentować',
  'community.comments.compose.counter': '{{current}}/{{max}}',
  'community.comments.edit': 'Edytuj',
  'community.comments.save': 'Zapisz',
  'community.comments.cancel': 'Anuluj',
  'community.comments.delete': 'Usuń',
  'community.comments.delete.confirm': 'Usunąć ten komentarz?',
  'community.comments.errors.bodyRequired': 'Komentarz nie może być pusty.',
  'community.comments.errors.bodyTooLong': 'Komentarz jest za długi.',
  'community.comments.errors.saveFailed': 'Nie udało się zapisać komentarza.',
  'community.comments.errors.deleteFailed': 'Nie udało się usunąć komentarza.',

  // Panel nav (community tab)
  'panel.nav.community': 'Społeczność',
  'panel.nav.legacyFull': '60 miejsc',

  // Trust / gwarancja zwrotu
  'trust.moneyBack.text':
    'Nie spodoba Ci się program? Zwrócimy Ci pieniądze w ciągu 14 dni — bez podawania przyczyny.',
  'trust.moneyBack.termsLink': 'Szczegóły w regulaminie.',

  'sales.cta.hint.default': 'Jednorazowa opłata · 365 dni na odkrycia · bez subskrypcji',
  'sales.cta.hint.promo': 'Nowa, niższa cena: 19 zł zamiast 29 zł',
  'sales.conversion.eyebrow': 'Gotowa na start?',
  'sales.conversion.title': 'Zacznij zbierać pieczątki już dziś',
  'sales.conversion.subtitle':
    'Dołącz do programu, odblokuj panel i ruszaj po 12 miejscach Dolnego Śląska we własnym tempie.',
  'sales.conversion.bullet1': 'Jedna opłata — dostęp przez cały rok 2026',
  'sales.conversion.bullet2': '12 miejsc, dziennik i społeczność odkrywców',
  'sales.conversion.bullet3': '14 dni na zwrot, jeśli program nie pasuje',
  'sales.conversion.cta': 'Dołączam teraz',
  'landing.joinBanner.cta': 'Tak — dołączam!',
  'landing.map.cta': 'Odblokuj mapę miejsc',
  'landing.manifesto.cta': 'Dołączam do wyzwania',
  'landing.panelShowcase.cta': 'Zobacz panel po rejestracji',

  // Auth (login / rejestracja)
  'auth.eyebrow.login': 'Logowanie',
  'auth.eyebrow.register': 'Dołączam do programu',
  'auth.title.login': 'Witaj z powrotem',
  'auth.title.register': 'Dołącz do odkrywców Dolnego Śląska',
  'auth.subtitle.login': 'Zaloguj się i wróć do swojej trasy.',
  'auth.subtitle.register': '',
  'auth.toggle.login': 'Logowanie',
  'auth.toggle.register': 'Rejestracja',
  'auth.toggle.aria': 'Wybierz tryb',

  'panel.trial.banner':
    'To konto testowe — widzisz tylko listę miejsc. Pieczątki, dziennik i społeczność odblokujesz po opłaceniu wpisowego.',
  'panel.trial.upgradeCta': 'Wykup pełny paszport',
  'panel.trial.navLockedAria':
    '{{label}} — dostępne w pełnej wersji. Kliknij, aby przejść do rejestracji z wpisowym.',

  'auth.register.pitch.eyebrow': '{{count}} miejsc programu',
  'auth.register.pitch.title': 'Zbieraj wirtualne pieczątki',
  'auth.register.pitch.subtitle':
    'Każda zweryfikowana wizyta odkrywa kolejną pieczątkę w Twoim paszporcie — prawdziwe miejsca Dolnego Śląska, zdjęcia z terenu, nie ze stocku.',
  'auth.register.pitch.highlight1': 'Pieczątka po GPS lub quizie zdjęciowym',
  'auth.register.pitch.highlight2': 'Dziennik i mapa postępu w panelu',
  'auth.register.pitch.highlight3': 'Społeczność odkrywców i ranking',

  'auth.register.shelterDonation':
    '10% z wpisowego przekażemy na jedno z dolnośląskich schronisk dla zwierząt — Ty wybierzesz, które!',

  // Co dostajesz (legacy — panel / inne widoki)
  'auth.benefits.eyebrow': 'Co dostajesz',
  'auth.benefits.title': 'Wszystko w jednym paszporcie',
  'auth.benefits.b1.title': 'Cyfrowy paszport z pieczątkami',
  'auth.benefits.b1.body':
    'Zbierasz pieczątki z każdego odwiedzonego miejsca, prosto w aplikacji , bez papierowej książeczki, którą można zgubić.',
  'auth.benefits.b2.title': 'Interaktywna mapa miejsc',
  'auth.benefits.b2.body':
    'Wyselekcjonowane miejsca Dolnego Śląska , z dojazdem, opisem i zdjęciami zrobionymi na żywo, a nie z banku stocków.',
  'auth.benefits.b3.title': 'Dziennik podróży',
  'auth.benefits.b3.body':
    'Twoje notatki, refleksje i zdjęcia z każdej wizyty , zostają z Tobą na zawsze, prywatnie albo dzielone ze społecznością.',
  'auth.benefits.b4.title': 'Społeczność odkrywców',
  'auth.benefits.b4.body':
    'Ludzie, którzy tak jak Ty chcą poznać region poza Wrocławiem i Śnieżką. Pytaj, polecaj, znajduj kompanów do wyjazdów.',
  'auth.benefits.b5.title': 'Bez AI w treściach',
  'auth.benefits.b5.body':
    'Każdy opis miejsca pisany ręcznie. Każde zdjęcie zrobione osobiście. Żadnych generatywnych podsumowań, żadnych halucynacji.',
  'auth.benefits.b6.title': 'Wszystkie aktualizacje 2026',
  'auth.benefits.b6.body':
    'Nowe miejsca, funkcje i mapy przez cały rok 2026 , bez dopłat, bez subskrypcji, bez ukrytych kosztów.',

  // Dlaczego 19 zł (promo startowa)
  'auth.transparency.eyebrow': 'Cena',
  'auth.transparency.title': 'Dlaczego',
  'auth.transparency.body':
    'Najchętniej oddałabym ten projekt całkiem za darmo. Robię go z pasji do Dolnego Śląska, nie dla zysku , ale ktoś musi za to zapłacić, a ja też muszę coś jeść. Dlatego jednorazowe, uczciwe wpisowe, na cały rok.',
  'auth.transparency.breakdownTitle': 'Na co idą Twoje 19 zł',
  'auth.transparency.cost1':
    'Serwer i utrzymanie aplikacji przez cały 2026 rok',
  'auth.transparency.cost2':
    'Mój czas , pisanie opisów, robienie zdjęć, rozwój nowych funkcji',
  'auth.transparency.cost3':
    'Wsparcie wybranej wspólnie fundacji działającej na Dolnym Śląsku',
  'auth.transparency.cost4':
    'Drobne narzędzia (mapy, hosting zdjęć, domena, certyfikaty)',
  'auth.transparency.foundationNote':
    'Fundację wybierzemy razem , w panelu znajdziesz głosowanie nad organizacjami, które realnie pomagają regionowi.',

  // Form
  'auth.form.fullName.label': 'Imię',
  'auth.form.fullName.placeholder': 'np. Zosia',
  'auth.form.email.label': 'Email',
  'auth.form.email.placeholder': 'np. zosia@email.pl',
  'auth.form.password.label': 'Hasło',
  'auth.form.password.placeholderRegister': 'Minimum 6 znaków',
  'auth.form.password.show': 'Pokaż',
  'auth.form.password.hide': 'Ukryj',
  'auth.form.password.hint':
    'Minimum 6 znaków. Najlepiej użyj unikalnego hasła, którego nie używasz nigdzie indziej.',
  'auth.form.submitRegister': 'Opłać wpisowe',
  'auth.form.submitRegisterSuffix': 'i dołącz',
  'auth.form.submitRegisterBusy': 'Łączę z HotPay…',
  'auth.form.submitLogin': 'Zaloguj',
  'auth.form.submitLoginBusy': 'Chwileczkę…',
  'auth.form.autoLoginBusy': 'Logujemy Cię…',
  'auth.form.forgotPassword': 'Nie pamiętam hasła',
  'auth.form.resetSending': 'Wysyłam link…',
  'auth.form.resetSent':
    'Wysłaliśmy link do resetu hasła. Sprawdź skrzynkę (i spam).',
  'auth.form.legalPrefix': 'Rejestrując się, akceptujesz',
  'auth.form.termsLink': 'regulamin',
  'auth.form.legalAnd': 'oraz',
  'auth.form.privacyLink': 'politykę prywatności',
  'auth.form.marketingConsent.label':
    'Wyrażam zgodę na otrzymywanie informacji marketingowych (e-mail) o Paszporcie Dolnego Śląska i kanałach społecznościowych. Zgodę mogę wycofać w każdej chwili.',
  'auth.form.errors.invalidEmail': 'Podaj poprawny adres email.',
  'auth.form.errors.nameTooShort': 'Podaj imię (co najmniej 2 znaki).',
  'auth.form.errors.passwordTooShort': 'Hasło musi mieć co najmniej 6 znaków.',
  'auth.form.errors.resetEmailRequired':
    'Wpisz email, żeby wysłać link do resetu hasła.',
  'auth.form.errors.resetFailed':
    'Nie udało się wysłać linku do resetu hasła.',
  'auth.form.errors.invalidCredentials': 'Błędny login lub hasło.',
  'auth.form.errors.loginFailed': 'Błąd logowania.',
  'auth.form.errors.checkoutFailed': 'Nie udało się uruchomić płatności.',

  // Pricing / Cennik
  'pricing.eyebrow': 'Cennik 2026',
  'pricing.title': 'Jednorazowo, na cały rok',
  'pricing.subtitle':
    'Bez subskrypcji, bez ukrytych kosztów. Płacisz raz , masz dostęp do programu przez cały rok 2026.',
  'pricing.priceLabel': 'Pełny Paszport',
  'pricing.priceLabelMiniOnly': 'Edycja specjalna 2026',
  'pricing.variantEyebrow': 'Dwa warianty',
  'pricing.variantEyebrowMiniOnly': 'Program 2026',
  'pricing.variantTitle': '60 miejsc do odwiedzenia',
  'pricing.variantTitleMiniOnly': '12 miejsc w 12 miesięcy',
  'pricing.variantBody':
    'Domyślnie pełny Paszport. Istniejący uczestnicy mają go bez dopłaty. Poniżej możesz też wybrać edycję specjalną na 2026.',
  'pricing.variantBodyMiniOnly':
    'Sezonowe wyzwanie na cały rok 2026. Wirtualne pieczątki, dziennik w panelu i społeczność odkrywców.',
  'pricing.price': '19 zł',
  'pricing.priceRegular': '29 zł',
  'pricing.priceUnit': 'jednorazowo',
  'pricing.duration':
    'Masz 365 dni od dołączenia, żeby zebrać komplet w swoim tempie.',
  'pricing.cta.join': 'Dołączam!',
  'pricing.cta.faq': 'Zobacz FAQ',
  'pricing.cta.back': 'Wróć na stronę główną',
  'pricing.includes.eyebrow': 'Co zawiera cena',
  'pricing.includes.title': 'Wszystko w jednej opłacie',
  'pricing.includes.i1.title': 'Lista miejsc Dolnego Śląska',
  'pricing.includes.i1.body':
    'Dostęp do {{count}} starannie wybranych miejsc , z opisem, dojazdem i zdjęciami zrobionymi na żywo.',
  'pricing.includes.i2.title': 'Cyfrowy paszport z pieczątkami',
  'pricing.includes.i2.body':
    'Zbieraj pieczątki w aplikacji za każdą wizytę , bez papierowej książeczki.',
  'pricing.includes.i3.title': 'Dziennik podróży',
  'pricing.includes.i3.body':
    'Notatki, refleksje i zdjęcia z każdego miejsca. Prywatnie albo dzielone ze społecznością.',
  'pricing.includes.i4.title': 'Wszystkie aktualizacje 2026',
  'pricing.includes.i4.body':
    'Nowe miejsca i funkcje przez cały rok , bez dopłat i subskrypcji.',
  'pricing.includes.i5.title': 'Cel: skompletowanie w swoim tempie',
  'pricing.includes.i5.body':
    'Masz 365 dni od dołączenia. Bez sztucznej presji, bez timera.',
  'pricing.transparency.eyebrow': 'Skąd ta cena',
  'pricing.transparency.body':
    'Cena pokrywa serwer i utrzymanie aplikacji, mój czas na rozwój i opisy miejsc, drobne narzędzia oraz wsparcie wybranej wspólnie fundacji działającej na Dolnym Śląsku.',
  'pricing.transparency.linkPrefix': 'Pełne wyjaśnienie znajdziesz w zakładce',
  'pricing.transparency.linkText': 'Dołącz',

  // Places page (lista miejsc full-screen scroll)
  'placesPage.cta.read': 'Czytaj artykuł',
  'placesPage.cta.comingSoon': 'Wkrótce',
  'placesPage.nav.previous': 'Poprzednie miejsce',
  'placesPage.nav.next': 'Następne miejsce',
  'placesPage.registerNudge.title': 'Odkryj te miejsca na swoim koncie',
  'placesPage.registerNudge.body':
    'Zarejestruj się, żeby zbierać pieczątki i śledzić odkrycia z listy miejsc w swoim Paszporcie.',
}

export const translationsCs: Translations = {
  // Nav
  'nav.about': 'O projektu',
  'nav.aboutOverview': 'O projektu',
  'nav.aboutNews': 'Aktuality',
  'nav.aboutRanking': 'Žebříček',
  'nav.pricing': 'Ceník',
  'nav.faq': 'FAQ',
  'nav.places': 'Místa',
  'nav.community': 'Komunita',
  'nav.join': 'Připojit se teď',
  'nav.panel': 'Můj panel',
  'nav.menu.open': 'Otevřít navigační menu',
  'nav.menu.close': 'Zavřít navigační menu',
  'nav.menu.label': 'Navigace webu',
  'promo.launchBar.prefix': 'Nová, nižší cena —',
  'promo.launchBar.priceLabel': '',
  'promo.launchBar.aria': 'Promo vstupného, přejít k registraci',
  'promo.launchBlock.registerHint': 'Nová, nižší cena: 19 zł místo 29 zł.',
  'promo.countdown.daySuffix': 'd',
  'promo.countdown.ariaDays': '{{count}} dní',
  'promo.countdown.ariaHms': '{{hours}} hodin, {{minutes}} minut, {{seconds}} sekund',

  'promo.freePopup.eyebrow': 'Testovací program',
  'promo.freePopup.title': 'Připojte se zdarma a podělte se o názor',
  'promo.freePopup.body':
    'Máme omezený počet bezplatných míst v Pasu Dolního Slezska. Zaregistrujte se, vyzkoušejte panel a napište, co můžeme zlepšit.',
  'promo.freePopup.cta': 'Připojit se zdarma',
  'promo.freePopup.later': 'Později',
  'promo.freePopup.closeAria': 'Zavřít okno',

  'promo.page.seoTitle': 'Akce — účet zdarma',
  'promo.page.seoDescription':
    'Jednorázová akce: připojte se k Pasu Dolního Slezska zdarma, vyzkoušejte program a podělte se o názor.',
  'promo.page.eyebrow': 'Jednorázová akce',
  'promo.page.title': 'Připojte se k Pasu Dolního Slezska zdarma',
  'promo.page.intro':
    'Výjimečná akce pro ty, kdo chtějí program poznat a pomoci nám ho vyladit. Registrace je bezplatná — bez platby HotPay.',
  'promo.page.feedbackHint':
    'Po založení účtu používáte panel jako platící účastníci. Budeme rádi za krátkou zpětnou vazbu.',
  'promo.page.slotsRemaining': 'Zbývá {{remaining}} z {{total}} volných míst',
  'promo.page.slotsUnknown': 'Program zahrnuje maximálně {{total}} bezplatných účtů',
  'promo.page.exhaustedBody': 'Všechna místa v této akci jsou již obsazena.',
  'promo.page.exhaustedCta': 'Stále se můžete připojit standardně —',
  'promo.page.exhaustedCtaLink': 'registrace se vstupným',
  'promo.page.submit': 'Založit účet zdarma',
  'promo.page.submitBusy': 'Zakládám účet…',
  'promo.page.errors.slotsExhausted': 'Bohužel, všechna bezplatná místa jsou obsazena.',
  'promo.page.errors.alreadyClaimed': 'Tento e-mail už akci využil.',
  'promo.page.errors.generic': 'Účet se nepodařilo založit. Zkuste to znovu.',

  'promo25.seoTitle': 'Promo vstupného 19 zł — Paszport Dolního Slezska',
  'promo25.seoDescription':
    'Připojte se k programu na rok 2026 za promo vstupné. Sbírejte virtuální razítka, pište deník a objevte 12 míst Dolního Slezska.',
  'promo25.hero.eyebrow': 'Startovní promo',
  'promo25.hero.title': 'Objevujte Dolní Slezsko celý rok — teď za nižší vstupné',
  'promo25.hero.subtitle':
    'Jedna platba, plný přístup k panelu: 12 míst, virtuální razítka, cestovní deník a komunita objevitelů. Bez předplatného a skrytých poplatků.',
  'promo25.hero.priceHighlight': 'Nová, nižší cena:',
  'promo25.countdown.label': 'Promo končí za',
  'promo25.offer.bullet1': '12 pečlivě vybraných míst na mapě Dolního Slezska',
  'promo25.offer.bullet2': 'Virtuální razítka a deník v panelu — na telefonu i počítači',
  'promo25.offer.bullet3': '14 dní na vrácení vstupného, pokud vám program nesedne',
  'promo25.form.title': 'Založte účet a zaplaťte vstupné',
  'promo25.form.subtitle': 'Po platbě HotPay se hned přihlásíte do panelu a začnete sbírat razítka.',
  'promo25.form.badge': 'Promo',
  'promo25.form.submit': 'Zaplatit vstupné',
  'promo25.sticky.cta': 'Připojit se v promo',

  'newsletterLogin.seoTitle': '-10% pro odběratele. Paszport Dolního Slezska',
  'newsletterLogin.seoDescription':
    'Sleva 10 % na vstupné Mini pro odběratele newsletteru. Založte účet a připojte se k Paszportu Dolního Slezska.',
  'newsletterLogin.eyebrow': 'Nabídka newsletteru',
  'newsletterLogin.title': '-10% pro odběratele',
  'newsletterLogin.subtitle':
    'Sleva na vstupné Mini je už započítaná. Založte účet, zaplaťte vstupné a začněte sbírat razítka v Dolním Slezsku.',
  'newsletterLogin.priceNote': 'cena se slevou z newsletteru',
  'newsletterLogin.form.submit': 'Zaplatit vstupné',

  'promo25.offer.eyebrow': 'Co získáte',
  'promo25.offer.title': 'Jediný turistický Paszport Dolního Slezska',
  'promo25.offer.subtitle':
    'Paszport je objevitelská výzva: ověřte návštěvu, získejte razítko, zapište vzpomínky a vraťte se na místa, která vás oslovila.',
  'promo25.offer.savings': 'V promo ušetříte 5 zł',
  'promo25.offer.card1.title': 'Virtuální razítka',
  'promo25.offer.card1.body':
    'Každé navštívené místo je razítko v panelu — vidíte postup na mapě i v kolekci sezóny.',
  'promo25.offer.card2.title': '12 příběhů regionu',
  'promo25.offer.card2.body':
    'Články, fotky a tipy ke každému místu — plánujete víkendy bez hledání po internetu.',
  'promo25.offer.card3.title': 'Komunita a žebříček',
  'promo25.offer.card3.body':
    'Sdílejte objevy, komentujte a sledujte, jak program prožívají ostatní účastníci.',
  'promo25.testimonials.eyebrow': 'Reference účastníků',
  'promo25.testimonials.title': 'Lidé už sbírají razítka — přidejte se k nim',
  'promo25.testimonial3.text':
    'Vstupné v promo byla dobrá volba: panel je přehledný a deník pomáhá pamatovat, proč se na Dolní Slezsko vracet.',
  'promo25.testimonial3.author': 'Anna M.',
  'promo25.testimonial3.meta': 'Jelení Hora',
  'promo25.socialBand.subtitle':
    'Připojte se za promo vstupné — jedna platba na celou sezónu 2026.',
  'promo25.socialBand.cta': 'Připojit se za',
  'promo25.final.eyebrow': 'Poslední krok',
  'promo25.final.title': 'Připojte se za promo cenu — formulář zabere 2 minuty',
  'promo25.final.subtitle':
    'Vyplňte údaje, zaplaťte vstupné přes HotPay a vstupte do panelu. Zbytek roku patří vám a Dolnímu Slezsku.',

  // Locale / settings
  'settings.account.title': 'Nastavení účtu',
  'settings.account.subtitle': 'Doplňte údaje profilu.',
  'settings.membership.activeFrom': 'Členství (vstupní poplatek): aktivní od {{date}}.',
  'settings.membership.pricingNote':
    'Každá varianta stojí 19 zł. Druhou verzi odemkneš v panelu za 19 zł.',
  'settings.membership.pricingNoteMiniOnly':
    'Vstupní poplatek je 19 zł za sezónu 2026.',
  'settings.membership.tierFull': 'Paszport Dolního Slezska (60 míst)',
  'settings.membership.tierMini': 'Paszport Dolního Slezska Mini (12 míst / sezóna 2026)',
  'settings.membership.unlockFull.body':
    'Máš speciální edici 2026. Za 19 zł odemkneš plný pas — 60 míst bez časového limitu.',
  'settings.membership.unlockFull.cta': 'Odemknout plný pas',
  'settings.membership.unlockFull.busy': 'Přesměrování…',
  'settings.membership.unlockMini.body':
    'Máš plný pas (60 míst). Druhou verzi — edici Mini (12 míst, sezóna 2026) — odemkneš za 19 zł stejně, jako účastníci Mini dokupují plnou variantu.',

  // Settings - eyebrows + sekce
  'settings.language.eyebrow': 'Jazyk',
  'settings.verification.eyebrow': 'Ověření',
  'settings.verification.title': 'Způsob ověřování míst',
  'settings.verification.subtitle':
    'Můžete vynutit ověřování „pouze přes fotku". Před ověřením se objeví krátký kvíz (2 otázky). Užitečné, když je GPS nespolehlivá.',
  'settings.verification.toggle.label': 'Pouze přes fotku + kvíz',
  'settings.verification.toggle.help': 'Vypne GPS, zapne kvíz před ověřením.',
  'settings.verification.toggle.aria': 'Zapnout ověření pouze přes fotku',

  'settings.profile.eyebrow': 'Váš profil',
  'settings.profile.title': 'Údaje profilu',
  'settings.profile.subtitle':
    'Jméno (nebo přezdívka), město a informace, jak jste nás našli. Údaje jsou viditelné u vašich komentářů a příspěvků.',
  'settings.profile.fullName.label': 'Jméno',
  'settings.profile.fullName.placeholder': 'např. Eva',
  'settings.profile.origin.label': 'Odkud pocházíte',
  'settings.profile.origin.placeholder': 'např. Praha',
  'settings.profile.heardAbout.label': 'Odkud jste se o nás dozvěděli?',
  'settings.profile.heardAbout.empty': ', volitelně / nevybráno ,',
  'settings.profile.heardAbout.previouslySaved': '{{value}} (dříve uložené)',
  'settings.profile.inviter.label': 'Email zvoucí osoby',
  'settings.profile.inviter.placeholder': 'např. kamaradka@email.cz',
  'settings.profile.inviter.help': 'Volitelné pole. Po uložení ho nelze změnit.',
  'settings.profile.inviter.locked': 'Email zvoucí osoby je už uložen.',
  'settings.profile.inviter.error.invalid': 'Zadejte platný email zvoucí osoby.',

  'settings.avatar.eyebrow': 'Avatar',
  'settings.avatar.title': 'Profilová fotka',
  'settings.avatar.subtitle': 'Nastavte avatar viditelný v panelu. Max. 3 MB (PNG / JPG / WEBP).',
  'settings.avatar.uploading': 'Nahrávám…',
  'settings.avatar.change': 'Změnit fotku',
  'settings.avatar.set': 'Nastavit fotku',
  'settings.avatar.remove': 'Odebrat',
  'settings.avatar.error.notLoggedIn': 'Žádný přihlášený uživatel.',
  'settings.avatar.error.notImage': 'Vyberte obrázek (PNG/JPG/WEBP).',
  'settings.avatar.error.tooLarge': 'Soubor je příliš velký. Maximálně 3 MB.',
  'settings.avatar.error.uploadFailed': 'Nepodařilo se nastavit profilovou fotku.',
  'settings.avatar.error.removeFailed': 'Nepodařilo se odebrat profilovou fotku.',
  'settings.avatar.error.bucketMissing':
    'Bucket pro avatary nebyl nalezen ({{candidates}}). Nastavte VITE_SUPABASE_AVATARS_BUCKET nebo vytvořte bucket "{{defaultBucket}}" v Supabase Storage.',

  'settings.password.eyebrow': 'Bezpečnost',
  'settings.password.title': 'Změna hesla',
  'settings.password.subtitle': 'Nastavte nové heslo (min. 6 znaků). Po uložení zůstanete přihlášeni.',
  'settings.password.new.label': 'Nové heslo',
  'settings.password.repeat.label': 'Potvrďte nové heslo',
  'settings.password.changed': 'Heslo bylo změněno.',
  'settings.password.changing': 'Měním heslo…',
  'settings.password.save': 'Uložit nové heslo',
  'settings.password.error.tooShort': 'Heslo musí mít alespoň 6 znaků.',
  'settings.password.error.mismatch': 'Hesla se neshodují.',
  'settings.password.error.failed': 'Nepodařilo se změnit heslo.',

  'settings.delete.eyebrow': 'Kritická zóna',
  'settings.delete.title': 'Smazat účet',
  'settings.delete.subtitle': 'Tato operace je nevratná , váš účet bude trvale smazán.',
  'settings.delete.confirm.label': 'Napište „USUN" pro potvrzení',
  'settings.delete.confirm.placeholder': 'USUN',
  'settings.delete.deleting': 'Mažu účet…',
  'settings.delete.cta': 'Smazat účet',
  'settings.delete.error.confirmMismatch': 'Napište přesně: USUN',
  'settings.delete.error.failed': 'Nepodařilo se smazat účet.',

  'settings.language.title': 'Jazyk',
  'settings.language.subtitle':
    'Volba jazyka ovlivňuje mimo jiné formát dat a čísel (a postupně i texty v aplikaci).',
  'settings.language.label': 'Jazyková verze',
  'settings.language.pl': 'Polština',
  'settings.language.cs': 'Čeština',
  'settings.profile.loadError': 'Nepodařilo se načíst profil.',
  'settings.profile.saveError': 'Nepodařilo se uložit profil.',
  'settings.points.banner': 'Vaše body sezóny: {{points}}',
  'settings.points.visibility.label': 'Zobrazovat moje body',
  'settings.points.visibility.help': 'Po vypnutí nebudou body viditelné v panelu ani v nastavení.',

  // Common
  'common.loading': 'Načítám…',
  'common.error': 'Chyba',
  'common.loadError': 'Chyba načítání.',
  'common.save': 'Uložit',
  'common.saving': 'Ukládám...',
  'common.saved': 'Uloženo.',
  'common.add': 'Přidat',
  'common.delete': 'Smazat',
  'common.cancel': 'Zrušit',
  'common.close': 'Zavřít',
  'common.back': 'Zpět',
  'common.ok': 'OK',
  'common.readMore': 'Číst více',
  'common.uploading': 'Nahrávám…',
  'common.chooseFile': 'Vybrat soubor',
  'common.location': 'Lokalita',
  'common.visibility.ariaLabel': 'Viditelnost',
  'common.visibility.private': 'Jen já',
  'common.visibility.public': 'Všichni',
  'common.loadData': 'Načíst údaje',
  'common.loadingDots': 'Načítám...',

  // Profile onboarding
  'profile.onboarding.title': 'Vítejte v programu',
  'profile.onboarding.subtitle':
    'Účet je aktivní. Než budete pokračovat, řekněte nám něco o sobě , zabere to jen chvilku.',
  'profile.onboarding.fullName.label': 'Jméno',
  'profile.onboarding.fullName.placeholder': 'např. Zuzana',
  'profile.onboarding.origin.label': 'Odkud jsem / původ',
  'profile.onboarding.origin.placeholder': 'např. Wrocław, Dolní Slezsko',
  'profile.onboarding.heardAbout.label': 'Kde jste se o nás dozvěděl(a)?',
  'profile.onboarding.heardAbout.ariaLabel': 'Kde jste se o nás dozvěděl(a)?',
  'profile.onboarding.heardAbout.chooseOption': 'Vyberte možnost',
  'profile.onboarding.inviter.label': 'Email zvoucí osoby (volitelné)',
  'profile.onboarding.inviter.placeholder': 'např. kamaradka@email.cz',
  'profile.onboarding.inviter.help': 'Lze vyplnit pouze jednou.',
  'profile.onboarding.inviter.locked': 'Email zvoucí osoby je už uložen a nelze ho změnit.',
  'profile.onboarding.inviter.error.invalid': 'Zadejte platný email zvoucí osoby.',
  'profile.onboarding.submit.saving': 'Ukládám…',
  'profile.onboarding.submit.cta': 'Uložit a přejít do panelu',
  'profile.onboarding.error.fillAllFields': 'Vyplňte všechna pole.',
  'profile.onboarding.error.saveFailed': 'Nepodařilo se uložit.',

  // Place discovered modal
  'place.discovered.ariaLabel': 'Místo objeveno',
  'place.discovered.badge.verified': 'Ověřeno',
  'place.discovered.title': 'Gratulujeme!',
  'place.discovered.subtitle': 'Objevil(a) jste místo na mapě Dolního Slezska:',
  'place.discovered.note': 'Razítko se uloží do deníku. Můžete pokračovat dál.',
  'place.discovered.close': 'Zavřít okno gratulace',
  'place.discovered.describe': 'Popište své zážitky',
  'place.discovered.exploreArticle': 'Poznejte toto místo lépe',
  'place.discovered.cta': 'Super',

  // Dashboard / panel shell
  'panel.shell.title': 'Uživatelský panel',
  'panel.shell.eyebrow': 'Uživatelský panel',
  'panel.places.title': 'Vaše místa',
  'panel.places.subtitle': 'Otevřete místo, zobrazte detaily a přidejte vlastní popis.',
  'panel.nav.dashboard': 'Plocha',
  'panel.nav.places': 'Místa',
  'panel.nav.journal': 'Deník',
  'panel.nav.quiz': 'Kvíz',
  'panel.nav.settings': 'Nastavení',
  'panel.nav.logout': 'Odhlásit se',

  // Panel - section headers (per route)
  'panel.section.dashboard.title': 'Vaše plocha',
  'panel.section.dashboard.subtitle': 'Postup, víkendový tip a co se děje v komunitě , vše na jednom místě.',
  'panel.section.places.title': 'Místa',
  'panel.section.places.subtitle': 'Všechna místa z Pasu , procházej, filtruj a vybírej, kam zajdeš příště.',
  'panel.section.place.title': 'Místo',
  'panel.section.place.subtitle': 'Vše o tomto místě: popis, ověření, vaše poznámky a komentáře.',
  'panel.section.journal.title': 'Deník',
  'panel.section.journal.subtitle': 'Každé navštívené místo je samostatný příběh. Pište, doplňujte, vracejte se.',
  'panel.section.community.title': 'Komunita',
  'panel.section.community.subtitle': 'Vaše příspěvky a hlasy ze společné cestovní knihy po Dolním Slezsku.',
  'panel.section.quiz.title': 'Velký kvíz',
  'panel.section.quiz.subtitle':
    '30 otázek o Dolním Slezsku. Vyhrává nejvyšší skóre, při remíze nejkratší čas.',
  'panel.section.settings.title': 'Nastavení',
  'panel.section.settings.subtitle': 'Profil, jazyk, heslo a předvolby ověřování.',

  'panel.bigQuiz.eyebrow': 'Soutěž znalostí',
  'panel.bigQuiz.rules':
    'Odpovězte na 30 otázek o regionu. Rozhoduje skóre, při remíze vyhrává nejkratší čas. Tři nejlepší osoby získají ceny. Pouze jeden pokus.',
  'panel.bigQuiz.winnersTitle': 'Pódium (top 3)',
  'panel.bigQuiz.winnersEmpty': 'Zatím nikdo kvíz nedokončil. Buďte první.',
  'panel.bigQuiz.loading': 'Načítám žebříček…',
  'panel.bigQuiz.loadError': 'Nepodařilo se načíst žebříček kvízu.',
  'panel.bigQuiz.anonymous': 'Účastník',
  'panel.bigQuiz.you': 'Vy',
  'panel.bigQuiz.timeLabel': 'Čas',
  'panel.bigQuiz.myResult':
    'Váš výsledek {{correct}}/{{total}} ({{percent}}%), čas {{time}}.',
  'panel.bigQuiz.alreadyPlayed': 'Už máte uložený pokus. Opakovaný start není možný.',
  'panel.bigQuiz.closed': 'Soutěž skončila 31. srpna 2026.',
  'panel.bigQuiz.addressLabel': 'Adresa pro zaslání ceny',
  'panel.bigQuiz.addressPlaceholder': 'Jméno a příjmení, ulice nebo výdejní box, PSČ, město',
  'panel.bigQuiz.addressHint': 'Může to být výdejní místo, např. Zásilkovna nebo box.',
  'panel.bigQuiz.addressError': 'Zadejte adresu pro zaslání (alespoň několik znaků).',
  'panel.bigQuiz.start': 'Spustit kvíz',
  'panel.bigQuiz.progress': 'Otázka {{current}} z {{total}}',
  'panel.bigQuiz.submitting': 'Ukládám výsledek…',
  'panel.bigQuiz.submitError': 'Nepodařilo se uložit výsledek. Zkuste to později.',
  'panel.bigQuiz.resultTitle': 'Hotovo!',
  'panel.bigQuiz.resultBody': 'Máte {{correct}} z {{total}} správných odpovědí v čase {{time}}.',
  'panel.bigQuiz.resultSaved': 'Výsledek uložen. To byl váš jediný pokus.',
  'panel.bigQuiz.termsTitle': 'Krátký řád',
  'panel.bigQuiz.terms.1':
    'Soutěž trvá do 31. srpna 2026. Po tomto datu nové výsledky nepřijímáme.',
  'panel.bigQuiz.terms.2':
    'Každá přihlášená osoba může kvíz absolvovat pouze jednou.',
  'panel.bigQuiz.terms.3':
    'Podmínkou účasti je uvedení adresy pro zaslání. Může to být výdejní místo, např. box.',
  'panel.bigQuiz.terms.4':
    'Ceny jsou dolnoslezské suvenýry pro tři nejlepší výsledky (body, při remíze čas).',
  'panel.bigQuiz.terms.5':
    'Organizátor hradí všechny náklady na zaslání cen.',
  'panel.bigQuiz.terms.6':
    'Organizátor kontaktuje vítěze do 7. září 2026 ohledně převzetí cen.',

  // Panel - seznam všech míst
  'panel.placesList.stats.eyebrow': 'Ověřená',
  'panel.placesList.stats.subtitle': 'Tolik míst z Pasu už máš odškrtnutých.',
  'panel.placesList.stats.shown': 'Zobrazeno: {{current}}/{{total}}',
  'panel.placesList.filters.eyebrow': 'Filtry',
  'panel.placesList.filters.region': 'Region',
  'panel.placesList.filters.region.all': 'Všechny regiony',
  'panel.placesList.filters.category': 'Kategorie',
  'panel.placesList.filters.category.all': 'Všechny kategorie',
  'panel.placesList.empty': 'Nic neodpovídá tvým filtrům.',
  'panel.placesList.error.loadFailed': 'Nepodařilo se načíst stav tvých ověření.',
  'panel.placesList.status.verified': 'Ověřené',
  'panel.placesList.status.visited': 'Probíhá',
  'panel.placesList.status.untouched': 'Čeká',
  'panel.placesList.cta.open': 'Otevřít',

  // Panel - mapka pod seznamem míst
  'panel.placesMap.eyebrow': 'Mapa',
  'panel.placesMap.title': 'Všechna místa na mapě',
  'panel.placesMap.subtitle': 'Každý špendlík je jedno místo. Klepni a uvidíš shrnutí a další krok.',
  'panel.placesMap.hint': 'Vyber špendlík, abys viděl/a detaily.',
  'panel.placesMap.cta.open': 'Otevřít místo',
  'panel.placesMap.cta.verify': 'Ověřit',
  'panel.placesMap.legend.verified': 'Ověřená',
  'panel.placesMap.legend.untouched': 'K ověření',
  'panel.placesMap.popup.close': 'Zavřít',
  'panel.placesMap.loading': 'Načítání mapy…',

  // Panel - mobile nav
  'panel.mobileNav.open': 'Otevřít menu',
  'panel.mobileNav.close': 'Zavřít menu',
  'panel.mobileNav.label': 'Menu uživatelského panelu',

  // Panel - sidebar (menu vpravo + účet)
  'panel.sidebar.menu.eyebrow': 'Navigace',
  'panel.sidebar.search.eyebrow': 'Vyhledávání',
  'panel.sidebar.search.placeholder': 'Hledat místo…',
  'panel.sidebar.search.count': '{{current}} z {{total}} míst',
  'panel.sidebar.visited': 'Navštíveno',
  'panel.sidebar.account.eyebrow': 'Účet',
  'panel.sidebar.account.label': 'Účet:',
  'panel.sidebar.account.empty': 'Žádný',
  'panel.sidebar.account.role': 'Přihlášený uživatel',
  'panel.points.label': 'Body sezóny: {{points}}',
  'panel.sidebar.hint.journal': 'V deníku uvidíte místa označená jako navštívená a přidáte vlastní vzpomínky.',
  'panel.sidebar.hint.community': 'V komunitě přidáte příspěvek a budete spravovat své záznamy.',
  'panel.sidebar.hint.settings': 'V nastavení doplníte profil a vyberete způsob ověřování.',

  // Panel welcome
  'panel.welcome.cta.showJournal': 'Zobrazit deník',
  'panel.welcome.map.eyebrow': 'Virtuální mapa',
  'panel.welcome.map.title': 'Klikněte, dotkněte se, objevte',
  'panel.welcome.map.subtitle': 'Každý bod je konkrétní místo z naší kolekce. Vlevo uvidíte detaily a přejdete do plného zobrazení.',
  'panel.welcome.map.location': 'Lokalita',
  'panel.welcome.map.cta': 'Číst více',
  'panel.welcome.map.hint': 'Klikněte na bod na mapě, abyste viděli detaily.',
  'panel.welcome.progress.eyebrow': 'Váš postup',
  'panel.welcome.progress.title': 'Kolik už máte za sebou',
  'panel.welcome.progress.window': 'Okno: {{total}} dní · zbývá {{left}}',
  'panel.welcome.progress.loading': 'Načítám postup…',
  'panel.welcome.progress.visitedLabel': 'Navštívená místa',
  'panel.welcome.progress.percent': '{{pct}}% kolekce',
  'panel.welcome.progress.barLabel': 'Ukazatel postupu',
  'panel.welcome.progress.startedOn': 'Start: {{date}} · uplynulo {{days}} dní',
  'panel.welcome.stamps.eyebrow': 'Razítka',
  'panel.welcome.stamps.title': 'Váš pas',
  'panel.welcome.stamps.cta.goToEntry': 'Přejít na záznam',
  'panel.welcome.weekend.eyebrow': 'Tip na víkend',
  'panel.welcome.weekend.title': 'Nejbližší víkend',
  'panel.welcome.weekend.cta.details': 'Zobrazit detaily',
  'panel.welcome.weekend.cta.reroll': 'Vylosovat jiné',
  'panel.welcome.weekend.loading': 'Losuji…',
  'panel.welcome.comments.eyebrow': 'Ze života komunity',
  'panel.welcome.comments.title': 'Poslední komentáře',
  'panel.welcome.comments.subtitle': 'Nejnovější příspěvky uživatelů , podívejte se, co ostatní píší o místech.',
  'panel.welcome.comments.empty': 'Zatím nikdo nic nenapsal. Buďte první.',
  'panel.welcome.comments.placeUnknown': 'Místo',
  'panel.welcome.comments.author.anonymous': 'Uživatel',
  'panel.welcome.comments.author.fromOrigin': 'Uživatel ({{origin}})',
  'panel.welcome.announcements.eyebrow': 'Aktuálně',
  'panel.welcome.announcements.title': 'Oznámení',
  'panel.welcome.announcements.empty': 'Zatím žádná oznámení.',
  'panel.welcome.users.counting': 'Počítám uživatele…',
  'panel.welcome.users.label': 'Registrovaných:',
  'panel.welcome.users.unavailable': 'Počet uživatelů není dostupný',
  'panel.welcome.gallery.eyebrow': 'Atmosféra regionu',
  'panel.welcome.gallery.title': 'Fotky z kolekce',
  'panel.welcome.gallery.subtitle':
    'Záběry z míst Pasu a Dolního Slezska , tak vypadá cesta podle našeho seznamu.',
  'panel.welcome.badge.locked': 'Hlavní odznak',
  'panel.welcome.badge.remaining': 'Ještě {{count}} míst pro získání odznaku',

  'panel.nearby.barAria': 'Upozornění na polohu při ověřování',
  'panel.nearby.eyebrow': 'Ověření v terénu',
  'panel.nearby.hint':
    'Zapněte polohu , až budete v okolí místa z Pasu (stejně jako u ověření přes GPS), nabídneme rychlý přechod k odškrtnutí.',
  'panel.nearby.status.idle': 'Poloha vypnutá , klikněte pro zapnutí.',
  'panel.nearby.status.requesting': 'Připojuji GPS…',
  'panel.nearby.status.active': 'GPS zapnuté , hledám místa v okolí.',
  'panel.nearby.status.denied': 'Přístup k poloze zamítnut. Zapněte ho v nastavení prohlížeče.',
  'panel.nearby.status.unsupported': 'Tento prohlížeč nepodporuje geolokaci.',
  'panel.nearby.cta.enable': 'Zapnout polohu',
  'panel.nearby.cta.stop': 'Vypnout',
  'panel.nearby.modal.closeAria': 'Zavřít',
  'panel.nearby.modal.eyebrow': 'Jste poblíž',
  'panel.nearby.modal.title': 'Asi jste tady…',
  'panel.nearby.modal.body': 'Vypadá to, že jste u: {{name}}. Můžete rovnou přejít k ověření.',
  'panel.nearby.modal.later': 'Později',
  'panel.nearby.modal.verify': 'Ověřit',

  // Panel - Journal (header lifting)
  'panel.journal.eyebrow': 'Vaše kronika',
  'panel.stamps.eyebrow': 'Razítka',

  // Panel - Journal
  'panel.journal.title': 'Deník',
  'panel.journal.subtitle': 'Každé navštívené místo je samostatný příběh. Otevřete kapitolu, dopište vzpomínky a přidejte fotky.',
  'panel.journal.loginToSee': 'Přihlaste se, abyste viděli navštívená místa.',
  'panel.journal.loading': 'Načítám deník…',
  'panel.journal.error.loadFailed': 'Nepodařilo se načíst deník.',
  'panel.journal.unlockedCount': '{{current}}/{{total}} odemčeno',
  'panel.journal.day.locked': 'Zamčeno',
  'panel.journal.month.fallback': 'Kapitola',
  'panel.journal.entry.aria': 'Záznam v deníku: {{name}}',
  'panel.journal.entry.lockedAria': 'Zamčená kapitola: {{name}}',
  'panel.journal.chapter.expand': 'Rozbalit kapitolu',
  'panel.journal.chapter.collapse': 'Sbalit kapitolu',
  'panel.journal.chapter.locked': 'Kapitola je zamčená',
  'panel.journal.chapter.lockedInline': 'Tuto kapitolu odemknete po ověření místa.',
  'panel.journal.locked.badge': 'K odemknutí',
  'panel.journal.locked.toggle': 'Zbývající místa ({{count}})',
  'panel.journal.cover.label': 'Obálka (fotka)',
  'panel.journal.cover.alt': 'Obálka: {{name}}',
  'panel.journal.cover.dropHint': 'Přetáhněte fotku sem nebo vyberte soubor.',
  'panel.journal.cover.empty': 'Bez obálky',
  'panel.journal.cover.cta.save': 'Uložit obálku',
  'panel.journal.cover.error.chooseFirst': 'Nejprve vyberte fotku.',
  'panel.journal.cover.error.saveFailed': 'Nepodařilo se uložit obálku.',
  'panel.journal.location.label': 'Lokalita',
  'panel.journal.cta.edit': 'Dopsat / upravit',
  'panel.journal.cta.unlock': 'Odemknout (ověřit)',
  'panel.journal.note.title': 'Popis',
  'panel.journal.note.help': 'Popis můžete doplnit/změnit po přidání záznamu.',
  'panel.journal.note.placeholder': 'Např. co se vám líbilo, jak se tam dostat, kolik to trvalo…',
  'panel.journal.note.emptyInline': 'Zatím tu není popis. Rozbalte kapitolu a napište pár vět.',
  'panel.journal.note.cta.save': 'Uložit popis',
  'panel.journal.note.error.saveFailed': 'Nepodařilo se uložit popis.',
  'panel.journal.visitedAt': 'Navštíveno: {{date}}',
  'panel.journal.verifiedAt': 'Ověřeno: {{date}}',
  'panel.journal.empty':
    'Zatím nemáte žádné záznamy. Otevřete místo a projděte ověřením (bez GPS: po úspěšném kvízu).',

  // Panel - Stamps
  'panel.stamps.title': 'Razítka',
  'panel.stamps.subtitle': 'Ověřená místa, kde máte razítko.',
  'panel.stamps.empty': 'Zatím nemáte razítka. Otevřete místo a projděte ověřením.',
  'panel.stamps.badge': 'Razítko',
  'panel.stamps.count.one': '{{count}} razítko',
  'panel.stamps.count.few': '{{count}} razítka',
  'panel.stamps.count.many': '{{count}} razítek',

  // Panel - Journal photos
  'panel.journal.photos.title': 'Další fotky',
  'panel.journal.photos.help': 'Můžete přidat další fotky (celkem max. 3 na místo: obálka + 2).',
  'panel.journal.photos.loading': 'Načítám fotky…',
  'panel.journal.photos.dropOrClick': 'Přetáhněte nebo klikněte pro výběr',
  'panel.journal.photos.slotsLeft': 'Zbývá: {{left}}/2',
  'panel.journal.photos.newAlt': 'Nová fotka: {{name}}',
  'panel.journal.photos.extraAlt': 'Další fotka: {{name}}',
  'panel.journal.photos.empty': 'Žádné další fotky.',
  'panel.journal.photos.error.loadFailed': 'Nepodařilo se načíst fotky.',
  'panel.journal.photos.error.addFailed': 'Nepodařilo se přidat fotku.',
  'panel.journal.photos.error.deleteFailed': 'Nepodařilo se smazat fotku.',
  'panel.journal.photos.error.limitReached': 'Byl dosažen limit 3 fotek na místo.',

  // Panel - Place details / notes
  'panel.place.notFound.eyebrow': 'Bez místa',
  'panel.place.notFound.title': 'Místo nebylo nalezeno',
  'panel.place.notFound.subtitle': 'Vyberte jiné ze seznamu.',
  'panel.place.note.eyebrow': 'Vaše poznámky',
  'panel.place.note.title': 'Váš popis',
  'panel.place.note.subtitle': 'Přidejte vlastní poznámky (ukládají se do databáze).',
  'panel.place.note.placeholder': 'Např. co se vám líbilo, jak se tam dostat, kolik to trvalo...',
  'panel.place.note.extraQuestions.title': 'Doplňující otázky (volitelné)',
  'panel.place.note.extraQuestions.placeholder': 'Napište, pokud chcete...',
  'panel.note.question.learned': 'Co nového jste se o tomto místě dozvěděla/dozvěděl?',
  'panel.note.question.surprised': 'Co vás překvapilo?',
  'panel.note.question.disliked': 'Co se vám nelíbilo?',
  'panel.place.note.loginToAdd': 'Přihlaste se, abyste přidali popis.',
  'panel.place.note.error.saveFailed': 'Nepodařilo se uložit popis.',

  // Panel - Verification
  'panel.verification.eyebrow': 'Ověření',
  'panel.verification.ariaLabel': 'Ověření místa',
  'panel.verification.title': 'Ověření místa',
  'panel.verification.subtitle': 'Přidání fotky je povinné. {{mode}}',
  'panel.verification.mode.photoOnly': 'Máte zapnuté ověření pouze přes fotku (s kvízem).',
  'panel.verification.mode.choose': 'Vyberte metodu: GPS nebo „přes fotku“.',
  'panel.verification.methodLabel': 'Metoda:',
  'panel.verification.method.photo': 'Přes fotku',
  'panel.verification.loginToVerify': 'Přihlaste se, abyste ověřili místo.',
  'panel.verification.inProgress': 'Ověřuji…',
  'panel.verification.openQuiz': 'Otevřít kvíz',
  'panel.verification.cta.verify': 'Klikněte pro ověření',
  'panel.verification.verifiedAt': 'Ověřeno • {{date}}',
  'panel.verification.error.photoRequired': 'Fotka je povinná.',
  'panel.verification.error.gpsFirst': 'Nejprve načtěte GPS polohu.',
  'panel.verification.error.tooFar': 'Jste příliš daleko od místa pro ověření přes GPS.',
  'panel.verification.error.verifyFailed': 'Nepodařilo se ověřit místo.',
  'panel.verification.photo.required': 'Fotka (povinné)',
  'panel.verification.photo.add': 'Přidat fotku',
  'panel.verification.photo.previewAlt': 'Náhled fotky',
  'panel.verification.photo.empty': 'Bez fotky.',
  'panel.verification.publicPhoto.title': 'Veřejná fotka',
  'panel.verification.publicPhoto.alt': 'Fotka místa: {{name}}',
  'panel.verification.publicPhoto.note': 'Zatím zobrazujeme vaši veřejnou fotku.',
  'panel.verification.gps.optional': 'GPS (volitelné)',
  'panel.verification.gps.subtitle': 'V režimu GPS ověřujeme, zda jste poblíž místa.',
  'panel.verification.gps.disabledBecausePhotoOnly':
    'Máte zapnuté „pouze přes fotku“, proto je GPS vypnuté.',
  'panel.verification.gps.fetch': 'Načíst GPS',
  'panel.verification.gps.error.notSupported': 'Váš prohlížeč nepodporuje geolokaci.',
  'panel.verification.gps.error.fetchFailed': 'Nepodařilo se načíst polohu.',
  'panel.verification.gps.distance': 'Vzdálenost:',
  'panel.verification.gps.tooFarBadge': 'PŘÍLIŠ DALEKO',
  'panel.verification.gps.accuracy': 'Přesnost: {{meters}} m',
  'panel.verification.gps.empty': 'Bez polohy.',
  'panel.verification.gps.thresholds': 'Prahy GPS: {{distance}} m a přesnost ≤ {{accuracy}} m.',

  // Panel - Quick verify (modal)
  'panel.quickVerify.cta': 'Rychlé ověření',
  'panel.quickVerify.ariaLabel': 'Rychlé ověření místa',
  'panel.quickVerify.eyebrow': 'Rychlé ověření',
  'panel.quickVerify.title': 'Ověřte místo za 30 sekund',
  'panel.quickVerify.subtitle': 'Vyberte místo, přidejte fotku a potvrďte ověření.',
  'panel.quickVerify.close': 'Zavřít okno rychlého ověření',
  'panel.quickVerify.gps.searching': 'Hledám místo poblíž…',
  'panel.quickVerify.gps.found': 'Nejblíže: {{name}}',
  'panel.quickVerify.gps.failed': 'Nepodařilo se načíst polohu. Vyberte místo ručně.',
  'panel.quickVerify.gps.noNearby': 'Nenašli jsme místo poblíž. Vyberte ho ze seznamu.',
  'panel.quickVerify.placeLabel': 'Místo',
  'panel.quickVerify.placePlaceholder': 'Vyberte místo…',
  'panel.quickVerify.alreadyVerified': 'Toto místo už máte ověřené.',
  'panel.quickVerify.openPlace': 'Otevřít detail místa',
  'panel.quickVerify.modeGpsOk': 'Můžete ověřit přes GPS.',
  'panel.quickVerify.modePhotoQuiz': 'Ověření „přes fotku“ (s krátkým kvízem).',
  'panel.quickVerify.photo.camera': 'Vyfotit',
  'panel.quickVerify.photo.gallery': 'Vybrat z galerie',

  // Panel - Quiz
  'panel.quiz.eyebrow': 'Kvíz',
  'panel.quiz.ariaLabel': 'Ověřovací kvíz',
  'panel.quiz.title': 'Ověřovací kvíz',
  'panel.quiz.subtitle': 'Odpovězte na 2 otázky, abyste mohli ověřit místo „přes fotku“.',
  'panel.quiz.close': 'Zavřít kvíz',
  'panel.quiz.q1': '1) V jakém regionu je toto místo?',
  'panel.quiz.q2': '2) Jaká je to kategorie?',
  'panel.quiz.error.answerBoth': 'Odpovězte na obě otázky.',
  'panel.quiz.error.wrong': 'Nesprávné odpovědi. Zkuste to znovu.',
  'panel.quiz.cta.passAndVerify': 'Splnit kvíz a ověřit',

  // Place comments
  'place.comments.eyebrow': 'Rozhovor',
  'place.comments.title': 'Komentáře',
  'place.comments.subtitle': 'Napište komentář k tomuto místu.',
  'place.comments.placeholder': 'Napište komentář…',
  'place.comments.loginToComment': 'Přihlaste se, abyste mohli komentovat.',
  'place.comments.visibilityNote': 'Viditelné pro přihlášené uživatele.',
  'place.comments.persistNote': 'Komentáře se ukládají do databáze.',
  'place.comments.addError': 'Nepodařilo se přidat komentář.',
  'place.comments.author.fallback': 'Uživatel',

  // Public place details - comments
  'place.comments.add': 'Přidat komentář',
  'place.comments.empty': 'Žádné komentáře. Buďte první.',
  'place.comments.loadError': 'Nepodařilo se načíst komentáře. Zkuste to prosím později.',

  // Public place details - article + sections
  'place.article.eyebrow': 'Článek',
  'place.article.notReady.title': 'Připravujeme',
  'place.article.notReady.body':
    'Tento článek ještě dolaďujeme. Zatím se podívej na praktické informace a mapu níže.',
  'place.article.audio.aria': 'Zvuk z místa',
  'place.article.audio.eyebrow': 'Poslechni si',
  'place.article.audio.title': 'Zvuk z místa',
  'place.article.audio.unsupported': 'Tvůj prohlížeč nepodporuje přehrávání audia.',
  'place.article.history.skip': 'Historii nechci, přeskočit',
  'place.article.history.skipped': 'Historie přeskočena.',
  'place.hero.locationEyebrow': 'Lokalita',
  'place.hero.commentsEyebrow': 'Komentáře',
  'place.hero.commentsLogin': 'Přihlas se',
  'place.hero.commentsHint': 'Přidávání a zobrazení komentářů jen pro uživatele.',
  'place.hero.cta.verifyInPanel': 'Přidat foto / ověřit v panelu',
  'place.hero.cta.loginToContribute': 'Přihlas se a přidej obsah',
  'place.highlights.eyebrow': 'Nejdůležitější',
  'place.toc.eyebrow': 'Obsah',
  'place.practical.eyebrow': 'Praktické informace',
  'place.practical.visitDuration': 'Doba prohlídky',
  'place.practical.howToGetThere': 'Doprava',
  'place.practical.parking': 'Parkování',
  'place.practical.accessibility': 'Podmínky / přístupnost',
  'place.practical.goodToKnow': 'Dobré vědět',
  'place.faq.eyebrow': 'FAQ',
  'place.map.eyebrow': 'Mapa',
  'place.map.pointsHint': 'Klikni na špendlík a zobraz bod v parku.',
  'place.map.mainPin': 'Park w Bukowcu (střed)',
  'place.publicPhotos.eyebrow': 'Fotky uživatelů',
  'place.publicPhotos.subtitle': 'Veřejné fotky přidané při ověřování místa.',
  'place.publicPhotos.cta.add': 'Přidat',
  'place.publicPhotos.loading': 'Načítám fotky…',
  'place.publicPhotos.empty': 'U tohoto místa zatím nejsou žádné veřejné fotky.',
  'place.publicPhotos.error': 'Nepodařilo se načíst veřejné fotky. Zkuste to prosím později.',
  'place.photoLightbox.closeAria': 'Zavřít náhled fotky',
  'place.photoLightbox.captionEditorial': 'Ilustrace k popisu místa {{place}}.',
  'place.photoLightbox.captionUser': 'Fotka z ověření místa {{place}}.',
  'place.photoLightbox.altEditorial': 'Fotka k článku: {{place}}',
  'place.photoLightbox.altUser': 'Fotka uživatele: {{place}}',
  'place.photoLightbox.promo': 'Takovou fotku můžeš pořídit i ty s Pasem Dolního Slezska.',
  'place.photoLightbox.ctaRegister': 'Přejít na registraci',
  'place.photoLightbox.ctaPanel': 'Přidat fotku v panelu',
  'place.photoLightbox.openAria': 'Otevřít zvětšenou fotku: {{place}}',
  'site.photoLightbox.caption': 'Fotka z materiálů {{name}}.',
  'site.photoLightbox.alt': 'Ilustrace: {{name}}',
  'place.notFound.eyebrow': 'Místo',
  'place.notFound.title': 'Toto místo jsme nenašli',
  'place.notFound.subtitle': 'Zkontroluj adresu, nebo vyber jiné ze seznamu.',
  'place.notFound.cta.home': 'Zpět na úvod',

  // Landing - Auth journal
  'landing.journal.smallTitle': 'Deník',
  'landing.journal.title': 'Místo pro vaše vzpomínky ze 12 výjimečných míst.',
  'landing.journal.subtitleLead': 'Sbírejte vzpomínky',
  'landing.journal.subtitleRest':
    'pište své dojmy, přidávejte poznámky a vraťte se k nim jako k mapě vlastních objevů.',
  'landing.journal.tags.notes': 'poznámky',
  'landing.journal.tags.photos': 'fotky',
  'landing.journal.tags.memories': 'vzpomínky',
  'landing.journal.account.label': 'Účet',
  'landing.journal.account.name': 'Anička',
  'landing.journal.visitDate.label': 'Datum návštěvy',
  'landing.journal.visitDate.value': '12.05.2026',
  'landing.journal.travelNote.title': 'Poznámka z cesty',
  'landing.journal.travelNote.body':
    'Ach, jak mě to místo nadchlo… Ticho, světlo mezi stromy a ta chvíle, kdy se vám nechce odejít ještě kousek dál. Na cestě zpátky jsem si uvědomila, že jde o jedno z těch zákoutí, ke kterým se myšlenkami vracíte týdny. Udělala jsem pár fotek, zapsala detaily (vůně lesa po dešti, teplo slunce na kamenech) , a už vím, že se sem na podzim zase vrátím.',
  'landing.journal.preview.label': 'Náhled záznamu v Deníku',

  // Landing - Hero / stats
  'landing.hero.cta.register': 'Vytvořit účet',
  'landing.hero.cta.readMore': 'Zjistit více',
  'landing.stats.users.fallback': 'Účastníci',
  'landing.stats.users': '{{count}} účastníků',
  'landing.stats.cities.fallback': 'Města',
  'landing.stats.cities': '{{count}} měst',

  // Landing - Social proof
  'landing.socialProof.eyebrow': 'Komunita objevitelů',
  'landing.socialProof.headline.before': 'Připojte se k',
  'landing.socialProof.headline.after':
    'lidům, kteří už sbírají razítka a objevují Dolní Slezsko',
  'landing.socialProof.headline.loading': 'Načítám počet účastníků…',
  'landing.socialProof.headline.fallback':
    'Připojte se ke komunitě objevitelů, kteří už sbírají razítka a objevují Dolní Slezsko',
  'landing.socialProof.statsAria': 'Počet účastníků programu',
  'landing.socialProof.recent.eyebrow': 'Nedávno se připojili',
  'landing.socialProof.recent.aria': 'Nedávno připojení účastníci',
  'landing.socialProof.recent.loading': 'Načítám seznam nedávno připojených…',
  'landing.socialProof.recent.unavailable':
    'Seznam nových účastníků vyžaduje aktualizaci databáze (RPC community_recent_members).',
  'landing.socialProof.map.eyebrow': 'Odkud účastníci pocházejí',
  'landing.socialProof.map.loading': 'Načítám mapu původu…',
  'landing.socialProof.map.empty':
    'Až účastníci doplní město původu, uvidíte je na mapě.',
  'landing.socialProof.map.hint':
    'Body ukazují města uvedená při registraci. Velikost kruhu odpovídá počtu lidí z daného místa.',
  'landing.socialProof.cta': 'Připojte se ke Komunitě',
  'landing.socialProof.testimonial1.text':
    'První razítko v Bukovci bylo jako začátek nové kapitoly. Teď plánuju každý víkend jinak , s mapou a deníkem po ruce.',
  'landing.socialProof.testimonial1.author': 'Marta K.',
  'landing.socialProof.testimonial1.meta': 'Vratislav',
  'landing.socialProof.testimonial2.text':
    'Nejvíc se mi líbí vracet k záznamům v deníku i měsíce poté. Je to jako malé album vzpomínek z míst, která jsem dřív neznala.',
  'landing.socialProof.testimonial2.author': 'Piotr W.',
  'landing.socialProof.testimonial2.meta': 'Lehnice',

  // Landing - Hero (nová šablona)
  'landing.hero.eyebrow': 'Pas Dolního Slezska 2026',
  'landing.hero.stampsCaption': 'Sbírejte razítka na 12 místech Dolního Slezska',
  'landing.hero.headline': 'Připojte se k objevitelům Dolního Slezska',
  'landing.hero.cta.join': 'Připojuji se k výzvě!',
  'landing.hero.cta.more': 'O projektu',
  'landing.mobileJoinBar.cta': 'Připojte se k výzvě',

  // Landing - Hero (launch 2026)
  'landing.heroLaunch.eyebrow': 'Připojte se k objevitelům Dolního Slezska',
  'landing.heroLaunch.headline': 'Pas Dolního Slezska 2026 odstartoval!',
  'landing.heroLaunch.stampAlt': 'Razítko — Pas Dolního Slezska, 12 z 12 míst',
  'landing.heroLaunch.passportCard.aria':
    'Ukázková kartička pasu se šesti nasbíranými razítky z dvanácti míst',
  'landing.heroLaunch.passportCard.hint': 'Ukázkový náhled z uživatelského panelu',
  'landing.heroLaunch.joinCta': 'Připojuji se!',
  'landing.heroLaunch.form.subtitle': 'Vytvořte si účet a začněte sbírat razítka',
  'landing.heroLaunch.form.haveAccount': 'Máte už účet?',
  'landing.heroLaunch.form.signIn': 'Přihlaste se',
  'landing.heroLaunch.form.alreadyLogged.eyebrow': 'Ahoj zpět!',
  'landing.heroLaunch.form.alreadyLogged.title':
    'Už jste přihlášeni — skočte do panelu a vyrazte sbírat razítka.',
  'landing.heroLaunch.form.alreadyLogged.cta': 'Vstupte do panelu',

  // Stránka /formularz
  'formularz.title': 'Vytvořte si účet',
  'formularz.offer.eyebrow': 'Startovní nabídka',
  'formularz.offer.lead': 'Platíte',
  'formularz.offer.joinSuffix': 'za vstup — v balíčku máte:',
  'formularz.offer.bulletEbook': 'Zdarma ebook (PDF zápisník na váš e-mail)',
  'formularz.offer.bulletRefund':
    'Garantii vrácení peněz — pokud vám to nesedne, vrátíme platbu do 7 dnů',
  'formularz.loginCta': 'Máte účet? Přihlaste se',
  'formularz.heardAbout.label': 'Odkud o nás?',
  'formularz.heardAbout.ariaLabel': 'Odkud o nás, volitelně',
  'formularz.heardAbout.empty': 'Volitelně',
  'formularz.legalPrefix': 'Zakládáním účtu souhlasíte s',
  'formularz.legalTermsLink': 'podmínkami',
  'formularz.submit': 'Zaplatit vstupné',
  'formularz.submitSuffix': 'a připojit se',
  'formularz.tier.feeLabel': 'vstupné',

  'fullPass.label': 'Plný program',
  'fullPass.title': '60 míst k návštěvě',
  'fullPass.desc':
    '{{published}} míst připraveno, {{count}} v plánu, bez časového limitu. Nejobsáhlejší katalog v Dolním Slezsku.',
  'fullPass.bonus': 'Poznámkový blok k tisku (PDF) v balíčku.',
  'fullPass.meta': '60 míst · bez časového limitu',

  'specialEdition2026.label': 'Speciální edice 2026',
  'specialEdition2026.title': '12 míst za 12 měsíců',
  'specialEdition2026.desc':
    'Sezónní výzva na celý rok 2026. Sbírejte virtuální razítka ve svém panelu a veďte si deník. Nižší vstupné na sezónu.',
  'specialEdition2026.months': '{{count}} míst · 12 měsíců · sezóna 2026',
  'specialEdition2026.journal': 'Individuální cestovní deník v panelu',
  'specialEdition2026.ctaLanding': 'Volím speciální edici na 2026 za',
  'specialEdition2026.pickHint': 'Klikněte na kartu, pokud preferujete menší rozsah na sezónu 2026.',
  'specialEdition2026.backToFull': 'Vracím se k plnému programu: 60 míst k návštěvě',

  'formularz.success.title': 'Děkujeme, údaje uloženy',
  'formularz.success.body': 'Nyní můžete dokončit registraci a uhradit účast v programu.',

  // Landing - Intro (sekce s logem Dolního Slezska)
  'landing.intro.eyebrow': 'O programu',
  'landing.intro.title': 'První virtuální turistický pas Dolního Slezska',
  'landing.intro.subtitle':
    'Ve výchozím nastavení objevujete 60 míst bez časového limitu. Můžete také zvolit speciální edici na 2026: 12 míst za 12 měsíců s osobním deníkem v panelu.',
  'landing.intro.subtitleMiniOnly':
    'Speciální edice na 2026: 12 míst za 12 měsíců s osobním deníkem v panelu.',
  'landing.intro.regionLogoAlt': 'Znak a logo Dolního Slezska',

  // Landing - Čestná záštita
  'landing.patronage.title': 'Pod čestnou záštitou',
  'landing.patronage.logoAlt':
    'Logotyp čestné záštity maršálka Dolnoslezského vojvodství Pawła Gancarza',

  // Landing - Partneři
  'landing.partners.title': 'Partneři',
  'landing.partners.listAria': 'Partneři programu Pas Dolního Slezska',
  'landing.partners.pds.name': 'Zastávka Dolní Slezsko',
  'landing.partners.pds.logoAlt': 'Zastávka Dolní Slezsko — logo partnera',
  'landing.partners.mds.name': 'Místa Dolního Slezska',
  'landing.partners.mds.logoAlt': 'Místa Dolního Slezska — logo partnera',
  'landing.partners.skiBikeHouse.name': 'Sky & Bike House Stronie Śląskie',
  'landing.partners.skiBikeHouse.logoAlt': 'Sky & Bike House Stronie Śląskie — logo partnera',

  // Landing - Prizes teaser
  'landing.prizesTeaser.eyebrow': 'Body a ceny',
  'landing.prizesTeaser.title':
    'Sbírejte body a vyhrávejte atraktivní ceny spojené s Dolním Slezskem',
  'landing.prizesTeaser.subtitle':
    'Čím více míst navštívíte, tím výše se umístíte v žebříčku 2026. Nejlepší účastníci získají dolnoslezské ceny na konci roku.',
  'landing.prizesTeaser.cta': 'Vytvořte si účet a zjistěte více',

  // Landing - Stamps showcase
  'landing.stamps.eyebrow': 'Plný pas',
  'landing.stamps.eyebrowMiniOnly': 'Speciální edice 2026',
  'landing.stamps.title': '60 míst k návštěvě',
  'landing.stamps.titleMiniOnly': '12 míst za 12 měsíců',
  'landing.stamps.subtitle':
    'Nejobsáhlejší katalog v Dolním Slezsku: virtuální razítka, žebříček a poznámkový blok k tisku. Bez časového omezení.',
  'landing.stamps.subtitleMiniOnly':
    'Sezónní výzva na rok 2026: virtuální razítka, deník v panelu a komunitní žebříček.',
  'landing.stamps.descMiniOnly.before':
    'Pas Dolního Slezska je digitální výzva na rok 2026. Nasbírejte 12 virtuálních razítek a odemkněte fyzický odznak Pasu Dolního Slezska! Dělejte skvělé fotky a sdílejte je s ostatními v panelu ',
  'landing.stamps.descMiniOnly.communityLink': 'Komunity',
  'landing.stamps.descMiniOnly.after': '.',
  'landing.stamps.listAria': 'Ukázková razítka z programu',
  'landing.stamps.footnote':
    'Razítka výše pocházejí z katalogu speciální edice 2026. Plný pas zahrnuje 60 míst.',
  'landing.stamps.footnoteMiniOnly':
    'Razítka výše pocházejí z katalogu speciální edice 2026.',
  'landing.stamps.counter.eyebrow': 'Komunita Pasu',
  'landing.stamps.counter.loading': 'Počítám účastníky a získaná razítka…',
  'landing.stamps.counter.usersLabel': 'lidí už se připojilo',
  'landing.stamps.counter.stampsLabel': 'razítek už nasbíráno',
  'landing.stamps.counter.tagline':
    'Každý den někdo dělá své první razítko. Připojte se ke komunitě objevitelů a začněte svou sbírku.',
  'landing.stamps.counter.fallback':
    'Připojte se ke komunitě objevitelů, kteří už sbírají razítka a objevují Dolní Slezsko.',
  'landing.stamps.counter.cta': 'Připojte se ke komunitě',

  'landing.howItWorks.eyebrow': 'Jak to funguje',
  'landing.howItWorks.title': '3 kroky a jste ve hře',
  'landing.howItWorks.subtitle':
    'Založíte účet a během roku navštívíte {{count}} míst z listu. Výzva podporující region , bez tlaku, ale s krásnou vzpomínkou na závěr.',
  'landing.howItWorks.step1.title': 'Vyberte místo',
  'landing.howItWorks.step1.desc':
    'Prohlédnete si seznam {{count}} lokalit a sestavíte trasu podle sebe: jednodenní výlet, víkend nebo dovolená.',
  'landing.howItWorks.step2.title': 'Potvrďte návštěvu',
  'landing.howItWorks.step2.desc':
    'Na místě sbíráte razítko v panelu , kódem nebo jinou formou ověření připravenou organizátorem.',
  'landing.howItWorks.step3.title': 'Nasbírejte komplet',
  'landing.howItWorks.step3.desc':
    'Na konci roku máte seznam vzpomínek: razítka, zápisy v deníku a místa, kam se chcete vrátit.',

  // O projektu
  'about.seo.title': 'O projektu , Pas Dolního Slezska',
  'about.seo.description':
    'Příběh Pasu Dolního Slezska: vášeň pro region, komunita objevitelů, 12 míst a filozofie volného objevování bez spěchu.',
  'about.seo.keywords':
    'Pas Dolního Slezska, o projektu, vášeň, Dolní Slezsko, komunita, 12 míst',
  'about.hero.eyebrow': 'O projektu',
  'about.hero.title': 'Z vášně pro Dolní Slezsko',
  'about.hero.subtitle':
    'Pas vznikl z lásky k regionu, historii a místům, která v populárních průvodcích nenajdete. Je to pozvánka k pomalejšímu objevování , s razítky, deníkem a lidmi, kteří milují stejné kouty.',
  'about.story.eyebrow': 'Náš příběh',
  'about.story.lead':
    'Chceme ukázat, že Dolní Slezsko je víc než pár známých bodů na mapě. Každé místo v programu má svůj příběh , a vy k němu můžete napsat vlastní kapitolu.',
  'about.passion.bodyExtra':
    'Hledáme kláštery ukryté v lese, parky, kde slyšíte jen ptáky, a výhledy, které vám zůstanou v paměti dlouho po návratu domů. Nemusíte být „turista z průvodce" , stačí zvědavost a trocha plánu.',
  'about.passion.bodyExtra2':
    'Proto místo checklistu atrakcí dáváme rámec na celý rok: 12 míst, 12 měsíců a prostor prožít každé po svém.',
  'about.community.bodyExtra':
    'V komunitě sdílíme fotky, poznámky a drobná objevení , bez soupeření o tempo. Můžete číst, komentovat a přidávat vlastní příspěvky, když na to máte chuť.',
  'about.vision.title': 'K čemu je tento projekt?',
  'about.vision.body':
    'Chceme, aby byl Dolní Slezsko objevován vědomě a s respektem k místu. Pas spojuje cestování, paměť a lidi , aby po roce zůstalo víc než album fotek v telefonu.',

  // Aktuality
  'news.seo.title': 'Aktuality , Pas Dolního Slezska',
  'news.seo.description':
    'Novinky a oznámení Pasu Dolního Slezska: změny v programu, akce a informace pro účastníky.',
  'news.seo.keywords': 'aktuality, novinky, Pas Dolního Slezska, oznámení',
  'news.section.eyebrow': 'Aktuality',
  'news.section.title': 'Co je nového v Pasu',
  'news.section.subtitle': 'Krátké příspěvky o změnách v programu, akcích a tom, co stojí za to vědět před startem.',
  'news.section.ctaAll': 'Všechny aktuality',
  'news.page.title': 'Aktuality',
  'news.page.subtitle': 'Zde publikujeme novinky o Pasu Dolního Slezska , od funkcí v panelu po podmínky účasti.',
  'news.page.backToAbout': '← Zpět na stránku O projektu',

  // Soutěž
  'contest.seo.title': 'Soutěž , Pas Dolního Slezska',
  'contest.seo.description':
    'Vyhrajte dárky z Dolního Slezska. Připojte se k Objevitelům, přidejte příspěvek v Komunitě a přihlaste ho do soutěže.',
  'contest.seo.keywords': 'soutěž, dárky, Dolní Slezsko, komunita, Pas Dolního Slezska',
  'contest.news.tabsAria': 'Výběr sekce aktualit',
  'contest.news.tabNews': 'Aktuality',
  'contest.news.tabContest': 'Soutěž',
  'contest.tab.eyebrow': 'Soutěž',
  'contest.tab.title': 'Vyhrajte dárky z Dolního Slezska',
  'contest.tab.subtitle':
    'Nejzajímavější fotky a popisy z Komunity vyhrávají balíčky regionálních dárků.',
  'contest.tab.step1': 'Připojte se k Objevitelům Dolního Slezska na paszportdolnegoslaska.pl',
  'contest.tab.step2': 'Přidejte příspěvek v Komunitě a zaškrtněte Přihlásit do soutěže',
  'contest.tab.step3': 'Nejzajímavější fotky a popisy vyhrávají',
  'contest.tab.ctaPost': 'Přidat příspěvek a přihlásit',
  'contest.tab.ctaFeed': 'Zobrazit Komunitu',
  'contest.rules.heading': 'Pravidla soutěže',
  'contest.rules.organizer.title': 'Organizátor a předmět',
  'contest.rules.organizer.body':
    'Organizátorem soutěže je Pas Dolního Slezska (paszportdolnegoslaska.pl).\nPředmětem soutěže je výběr nejzajímavějších fotek a popisů zveřejněných v Komunitě a jejich ocenění dárky z Dolního Slezska.',
  'contest.rules.eligibility.title': 'Kdo se může zúčastnit',
  'contest.rules.eligibility.body':
    'Soutěže se mohou zúčastnit registrovaní účastníci programu Objevitelé Dolního Slezska.\nÚčast vyžaduje aktivní účet a zveřejnění příspěvku v záložce Komunita.',
  'contest.rules.howto.title': 'Jak se zúčastnit',
  'contest.rules.howto.body':
    'Připojte se k programu na paszportdolnegoslaska.pl.\nPřidejte příspěvek v Komunitě s fotkou a popisem spojeným s objevováním Dolního Slezska.\nPři publikaci zaškrtněte možnost Přihlásit do soutěže. Přihlášený příspěvek označíme žlutou ikonou soutěže.',
  'contest.rules.judging.title': 'Hodnocení přihlášek',
  'contest.rules.judging.body':
    'Vítěze vybírá organizátor z přihlášených příspěvků podle zajímavosti fotek a popisů.\nRozhodnutí organizátora je konečné.',
  'contest.rules.prizes.title': 'Ceny',
  'contest.rules.prizes.body':
    'Cenami jsou dárky z Dolního Slezska, mimo jiné lahve, hrnek, maskoti a taška podle soutěžního materiálu.\nKonkrétní sada cen se může lišit podle dostupnosti.',
  'contest.rules.moderation.title': 'Moderace a vyloučení',
  'contest.rules.moderation.body':
    'Přihlášky podléhají pravidlům komunitního kanálu.\nOrganizátor může vyloučit obsah, který porušuje pravidla, je vulgární, reklamní nebo nesouvisející s programem.',
  'contest.rules.contact.title': 'Kontakt',
  'contest.rules.contact.body':
    'Ve věcech soutěže pište na kontakt@paszportdolnegoslaska.pl.',
  'contest.poster.alt': 'Plakát soutěže Vyhrajte dárky z Dolního Slezska',
  'contest.poster.openAria': 'Otevřít plakát soutěže',
  'contest.popup.title': 'Soutěž o dárky z Dolního Slezska',
  'contest.popup.closeAria': 'Zavřít popup soutěže',
  'contest.popup.later': 'Později',
  'contest.popup.cta': 'Zúčastnit se',
  'contest.badge.label': 'Soutěžní přihláška',
  'contest.badge.short': 'Soutěž',
  'contest.badge.title': 'Příspěvek přihlášený do soutěže o dárky',
  'contest.compose.toggle': 'Přihlásit do soutěže',
  'contest.compose.helper':
    'Zaškrtněte, pokud má tento příspěvek soutěžit o dárky. V Komunitě se zobrazí žlutá ikona.',

  // Žebříček
  'ranking.word': 'Žebříček',
  'ranking.seo.title': 'Žebříček , Pas Dolního Slezska',
  'ranking.seo.description':
    'Jak fungují body v Pasu Dolního Slezska, sezónní žebříček komunity a odměny pro vítěze roku 2026.',
  'ranking.seo.keywords': 'žebříček, body, odměny, komunita, Pas Dolního Slezska, 2026',
  'ranking.page.title': 'Žebříček a odměny',
  'ranking.page.subtitle':
    'Sbírejte body za aktivitu v programu a v Komunitě. Na konci roku 2026 vyhrává účastník s nejvyšším počtem bodů atraktivní odměny.',
  'ranking.page.backToAbout': '← Zpět na stránku O projektu',
  'ranking.how.title': 'Jak získávat body?',
  'ranking.how.intro':
    'Body počítáme automaticky za vybrané aktivity v panelu a v Komunitě. Čím víc objevujete a sdílíte vzpomínky, tím výš můžete postoupit v sezónním žebříčku.',
  'ranking.points.like': '1 bod za lajk příspěvku v Komunitě',
  'ranking.points.invite': '50 bodů za zadání e-mailu osoby, která vás pozvala (pouze jednou)',
  'ranking.points.visit': '100 bodů za ověřenou návštěvu místa z programu',
  'ranking.points.complete': '500 bodů za komplet všech 12 míst',
  'ranking.how.visibility':
    'Ve veřejném žebříčku zobrazujeme účastníky od 100 bodů. Skrytí bodů v nastavení účtu vás z žebříčku nevylučuje.',
  'ranking.prizes.title': 'Odměny na konci roku 2026',
  'ranking.prizes.body':
    'Na konci roku 2026 vyhrává účastník s nejvyšším počtem bodů v sezónním žebříčku. Připravili jsme atraktivní odměny , podrobnosti oznámíme v průběhu programu.',
  'ranking.prizes.note':
    'Výsledek se počítá z bodů nasbíraných do konce sezóny. Při shodě rozhodují pravidla v podmínkách komunitního kanálu.',
  'ranking.rulesLink.prefix': 'Úplná pravidla bodování a žebříčku najdete v',
  'ranking.rulesLink.label': 'podmínkách komunitního kanálu',
  'ranking.section.eyebrow': 'Žebříček 2026',
  'ranking.section.title': 'Získejte nejvíc bodů a vyhrajte odměny',
  'ranking.section.body':
    'Navštěvujte místa, sdílejte vzpomínky v Komunitě a sbírejte body. Na konci roku 2026 nejlepší výsledek v žebříčku znamená atraktivní odměny.',
  'ranking.section.cta': 'Jak žebříček funguje',
  'news.card.readMore': 'Číst více',
  'news.article.back': 'Zpět na aktuality',
  'news.post.whatIs.category': 'O programu',
  'news.post.whatIs.title': 'Pas Dolního Slezska 2026 — co to je a jak funguje?',
  'news.post.whatIs.excerpt':
    'Digitální program na celý rok: 12 míst, virtuální razítka, deník a komunita. Vysvětlujeme krok za krokem, od registrace po ověření návštěv.',
  'news.post.whatIs.body1':
    'Pas Dolního Slezska je turistický program na sezónu 2026. Není slevovou kartou ani permanentkou do muzeí , je to pozvání k vědomému objevování regionu vlastním tempem. Přístup koupíte jednou, přihlásíte se do panelu a po celý rok máte mapu 12 pečlivě vybraných míst, materiály ke každé lokalitě a nástroje, které z běžných víkendů udělají ucelenou cestu po Dolním Slezsku.',
  'news.post.whatIs.body2':
    'Každé místo v programu je samostatný příběh: park, klášter, palác, rezervace, rozhledna nebo stezka. Na veřejné stránce místa najdete článek, praktické tipy a mapu. V panelu účastníka vidíte postup , které body už máte ověřené a které čekají na návštěvu. Cíl sezóny? Komplet všech virtuálních razítek a vlastní deník z celého roku.',
  'news.post.whatIs.body3':
    'Jak začít? Založíte účet na přihlašovací stránce, zaplatíte jednorázové vstupné a hned vstoupíte do panelu. Nemusíte plánovat celou trasu dopředu: můžete jet na jednotlivá místa, vracet se k oblíbeným bodům nebo spojit více zastávek do jednoho výletu. Program funguje v prohlížeči na telefonu , není potřeba instalovat samostatnou aplikaci.',
  'news.post.whatIs.body4':
    'Razítko získáte po ověřené návštěvě. Na místě zapnete geolokaci v panelu a potvrdíte přítomnost přes GPS. Pokud to nestihnete hned , můžete návštěvu ověřit později: přidáte fotku z místa a odpovíte na krátký kvíz o regionu a kategorii objektu. Po úspěchu razítko přibude do deníku a místo na mapě se označí jako objevené.',
  'news.post.whatIs.body5':
    'Pas není jen o „splněných úkolech“. V deníku zapisujete vzpomínky, fotky a poznámky z každé návštěvy. V Komunitě sdílíte zážitky s ostatními účastníky a v sezónním žebříčku sbíráte body za aktivitu. Na konci roku 2026 nejlepší výsledek v žebříčku znamená atraktivní odměny , podrobnosti oznamujeme během programu.',
  'news.post.whatIs.body6':
    'Vstupné je jednorázový poplatek za celou sezónu 2026: nyní 19 zł v akční nabídce (běžně 29 zł). V ceně máte plný přístup k panelu, razítkům, deníku a komunitě. Pokud po nákupu usoudíte, že vám program nevyhovuje , platí záruka vrácení peněz do 14 dnů , bez žádosti o zdůvodnění.',
  'news.post.whatIs.body7.before': 'Chcete vidět seznam míst a naplánovat první výlet? Podívejte se na ',
  'news.post.whatIs.link.places': 'mapu 12 míst',
  'news.post.whatIs.body7.mid': ' a pak na ',
  'news.post.whatIs.link.pricing': 'stránku ceníku',
  'news.post.whatIs.body7.after':
    ', abyste se k programu připojili. Dolní Slezsko čeká , zbytek roku patří vám.',
  'news.post.whatIs.img.places.alt': 'Alej v Parku v Bukovci, jedno z 12 míst programu',
  'news.post.whatIs.img.places.caption': '12 lokalit na mapě Dolního Slezska , od parků po hrady a rezervace.',
  'news.post.whatIs.img.stamp.alt': 'Virtuální razítko Park v Bukovci v panelu účastníka',
  'news.post.whatIs.img.stamp.caption': 'Razítko se objeví po ověření GPS nebo kvízu s fotkou.',
  'news.post.whatIs.img.journal.alt': 'Cestovní deník v panelu Pasu Dolního Slezska',
  'news.post.whatIs.img.journal.caption': 'Deník, komunita a žebříček , vše v jednom panelu.',
  'news.post.wilczkiWeekend.category': 'Místa',
  'news.post.wilczkiWeekend.title':
    'Vodopád Wilczki na víkend: 22 metrů vody a Vodohřmění Žeromského',
  'news.post.wilczkiWeekend.excerpt':
    'Druhý největší vodopád v polských Sudetech, krátká cesta z Międzigórze a název ze života Žeromského — který tu pravděpodobně nikdy nebyl. Víkendový plán s Pasem Dolního Slezska.',
  'news.post.wilczkiWeekend.body1':
    'Co takhle tento víkend vyrazit na… Vodopád Wilczki v přírodní rezervaci u Międzigórze. Pár minut chůze od centra vesnice a na konci cesty čeká kaskáda v zeleném údolí Masivu Králického Sněžníku — velký efekt při malé námaze, bez celodenního výstupu.',
  'news.post.wilczkiWeekend.body2':
    'Věděli jste, že má asi 22 metrů výšky a je druhým největším vodopádem v polských Sudetech, hned po Vodopádu Kamieńczyka v Krkonoších? Na jaře a po deštích Wilczka nese nejvíc vody — tehdy kaskáda udělá největší dojem, ale v zeleném údolí je příjemně po celou sezónu.',
  'news.post.wilczkiWeekend.body3':
    'Kdysi se mu říkalo Vodohřmění Žeromského — jméno mělo místu dodat polský charakter po druhé světové válce, přestože tam Stefan Žeromski pravděpodobně nikdy nedošel. Dnes se znovu říká prostě Vodopád Wilczki a rezervace chrání tento úsek údolí Wilczky od roku 1958.',
  'news.post.wilczkiWeekend.body4':
    'Na samotný vodopád a zpáteční cestu stačí asi 30–60 minut. V sezóně bývá rušno, proto je nejlepší čas na klidné fotky ráno ve všední den. U kaskády bývá mokro a kluzko — držte se vyznačené cesty a zábradlí tam, kde je.',
  'news.post.wilczkiWeekend.body5.before':
    'V Pasu Dolního Slezska je Rezervace Vodopád Wilczki jedním z 12 míst sezóny 2026. Na stránce místa najdete článek, galerii fotek a tipy před výjezdem — podívejte se na ',
  'news.post.wilczkiWeekend.link.place': 'Vodopád Wilczki',
  'news.post.wilczkiWeekend.body5.after':
    ' — a po návštěvě získejte razítko v panelu.',
  'news.post.wilczkiWeekend.body6':
    'Samotné Międzigórze vděčí za své kouzlo… Marianně Orańské! Palác Marianny může být vaším druhým bodem objevování Dolního Slezska s Pasem Dolního Slezska!',
  'news.post.wilczkiWeekend.body7.before':
    'Neogotická rezidence v Kamieńci Ząbkowickim, terasy a anglický park — vše o tomto místě přečtete v článku o ',
  'news.post.wilczkiWeekend.link.palace': 'Paláci Marianny Orańské',
  'news.post.wilczkiWeekend.body7.after': '.',
  'news.post.wilczkiWeekend.img.waterfall.alt':
    'Vodopád Wilczki v přírodní rezervaci u Międzigórze — hlavní kaskáda v Masivu Králického Sněžníku',
  'news.post.wilczkiWeekend.img.waterfall.caption':
    'Asi 22 metrů padající vody — jeden z nejvyšších vodopádů v polských Sudetech.',
  'news.post.skiBikeHouse.category': 'Partneři',
  'news.post.skiBikeHouse.title':
    'Sky & Bike House Stronie Śląskie: nový partner Pasu Dolního Slezska',
  'news.post.skiBikeHouse.excerpt':
    'V okolí Masivu Králického Sněžníku přibývá ubytování pro aktivní výlet: navštivte Vodopád Wilczki, získejte razítko a zůstaňte na cyklistickou noc ve Stroni Śląskie.',
  'news.post.skiBikeHouse.body1':
    'K partnerům Pasu Dolního Slezska se přidává Sky & Bike House Stronie Śląskie — základna v srdci Kladské kotliny pro ty, kdo spojují objevování s pohybem na dvou kolech. Přirozené spojení s naším programem: přes den razítko u vodopádu, večer aktivní odpočinek blízko tras.',
  'news.post.skiBikeHouse.body2':
    'Sky & Bike House je místo ve Stroni Śląskie vytvořené pro cyklisty a milovníky horských tras. Ubytujete se blízko výjezdů na stezky, naplánujete další etapu na mapě a po výletu se vrátíte tam, kde tempo výpravy sedí aktivnímu odpočinku — bez spěchu, ale s pořádnou dávkou pohybu.',
  'news.post.skiBikeHouse.body3':
    'V programu Pasu najdete také Rezervaci Vodopád Wilczki — jedno z 12 míst sezóny 2026. Krátký přístup, působivý vodopád v zeleni a hned šance získat razítko v panelu po ověřené návštěvě. Po návštěvě se vyplatí v okolí zůstat déle: spojte vodopád s nocí ve Stroni a naplánujte aktivní cyklistický víkend.',
  'news.post.skiBikeHouse.body4.before': 'Více o ubytování, trasách a podmínkách pobytu najdete na webu ',
  'news.post.skiBikeHouse.link.website': 'skibikehouse.pl',
  'news.post.skiBikeHouse.body4.after':
    '. Hledáte-li základnu pro objevování Masivu Králického Sněžníku s razítkem v kapse — je to dobré místo na start.',
  'news.post.skiBikeHouse.img.logo.alt':
    'Logo Sky & Bike House Stronie Śląskie, partner Pasu Dolního Slezska',
  'news.post.skiBikeHouse.img.logo.caption':
    'Ubytování a cyklistická základna ve Stroni Śląskie, nedaleko Vodopádu Wilczki.',
  'news.post.pdsPartner.category': 'Partneři',
  'news.post.pdsPartner.title':
    'Zastávka Dolní Slezsko: nový partner Pasu Dolního Slezska',
  'news.post.pdsPartner.excerpt':
    'K partnerům programu se přidává jedinečný čtvrtletník o regionu: bezplatné archivní vydání online a inspirace, které skvěle ladí s cestou po 12 místech.',
  'news.post.pdsPartner.body1':
    'S radostí oznamujeme, že Zastávka Dolní Slezsko (Przystanek Dolny Śląsk) se stala partnerem Pasu Dolního Slezska. Setkávají se dvě iniciativy, které mluví o stejném regionu jiným jazykem: my zveme k aktivnímu objevování s razítky a deníkem, oni už více než deset let vyprávějí o Dolním Slezsku ve formě čtvrtletníku, který se čte jako dobrý výlet.',
  'news.post.pdsPartner.body2.before':
    'Przystanek Dolny Śląsk je časopis věnovaný krajoznawství, regionální historii, individuální turistice a veřejné dopravě. Vydává ho ',
  'news.post.pdsPartner.link.institute': 'Instytut Dolnośląski',
  'news.post.pdsPartner.body2.after':
    ', instituce která spojuje milovníky regionu: jeho dějin, kultury, přírody a památek. Každé číslo nabízí stovky stran reportáží, tras, kolejových zajímavostí a příběhů z míst, která často v rychlosti mineme.',
  'news.post.pdsPartner.body3':
    'Čtvrtletník vychází pravidelně podle ročních období (na jaře, v létě, na podzim a v zimě) a roky buduje archiv vydání dostupných zdarma online. Je to vzácnost: časopis, který neschovává obsah za paywallem, ale zve ke čtení všechny, kdo se o Dolní Slezsko zajímají.',
  'news.post.pdsPartner.body4.before': 'Nejnovější i starší čísla si stáhnete na webu ',
  'news.post.pdsPartner.link.website': 'przystanekd.pl',
  'news.post.pdsPartner.body4.after':
    '. V archivu čtvrtletníku najdete desítky vydání, část z nich starší než deset let. Před výjezdem na místa z mapy Pasu se vyplatí nahlédnout do aktuálního čísla: najdete v něm nápady na trasy, historický kontext a inspiraci, která z návštěvy udělá plnější příběh.',
  'news.post.pdsPartner.body5.before':
    'Líbí-li se vám tento přístup, sledujte Przystanek online: přihlaste se k ',
  'news.post.pdsPartner.link.substack': 'newsletteru na Substacku',
  'news.post.pdsPartner.body5.mid': ' a navštivte ',
  'news.post.pdsPartner.link.biblioteczka': 'Dolnoslezskou bibliotéku',
  'news.post.pdsPartner.body5.after':
    ', kde redakce sdílí novinky o číslech, ukázky článků a objevy z regionu. Společně chceme, aby Dolní Slezsko nebylo jen navštívené, ale také pochopené a zapamatované: na mapě programu i na stránkách čtvrtletníku.',
  'news.post.pdsPartner.img.logo.alt':
    'Logo Zastávka Dolní Slezsko, partner Pasu Dolního Slezska',
  'news.post.pdsPartner.img.logo.caption':
    'Jedinečný čtvrtletník o Dolním Slezsku. Vydavatel: Instytut Dolnośląski.',
  'news.post.launch.category': 'Premiéra',
  'news.post.launch.title':
    'Premiéra: jediný Pas Dolního Slezska. Nasbírejte všechna virtuální razítka',
  'news.post.launch.excerpt':
    'Startuje nová turistická atrakce na Dolním Slezsku. Roční cesta 12 místy, virtuální razítka v panelu a vzpomínky na déle než jeden víkend.',
  'news.post.launch.body1':
    'Na mapě Dolního Slezska přibývá něco, co tu dříve v této podobě nebylo. Pas Dolního Slezska je program na 12 měsíců, 12 výjimečných míst a 12 příběhů, které můžete prožít vlastním tempem. Nejde o dalšího průvodce se seznamem must see, ale o pozvání k vědomému objevování regionu s razítky, deníkem a komunitou cestovatelů.',
  'news.post.launch.body2':
    'V panelu účastníka sbíráte virtuální razítka za ověřené návštěvy míst z programu. Každé razítko je značka na mapě i výchozí bod k článku, fotkám a vzpomínkám v deníku. Cíl sezóny? Komplet všech razítek a celý příběh roku na Dolním Slezsku.',
  'news.post.launch.body3':
    'Program spojuje turistiku, historii a lidi. Na jednom místě máte mapu míst, sezónní žebříček, komunitní kanál a materiály připravené s respektem k místním příběhům. Můžete jet sami, s rodinou nebo s přáteli. Objevujte vlastním rytmem, bez tlaku stihnout vše za jeden den.',
  'news.post.launch.body4':
    'Pas Dolního Slezska je dnes jediná iniciativa tohoto typu v regionu. Jednotná sezóna 2026, přehledná pravidla a jeden panel, kde vidíte postup. Hledáte-li novou atrakci na Dolním Slezsku, ne jen jedno muzeum nebo vyhlídku, ale celoroční dobrodružství, je to právě tento formát.',
  'news.post.launch.body5':
    'Připojte se k programu, prohlédněte mapu míst a začněte sbírat razítka. První kroky zaberou pár minut. Zbytek roku patří vám a Dolnímu Slezsku, který teprve poznáte.',
  'news.post.launch.hashtag.before':
    'Ukažte Dolní Slezsko na svých fotkách. Sdílejte vzpomínky z návštěv a do příspěvku přidejte ',
  'news.post.launch.hashtag.after':
    '. Vaše záběry rádi uvidíme v Komunitě i u bodů v žebříčku.',
  'news.post.launch.img.journal.alt': 'Cestovní deník v panelu Pasu Dolního Slezska',
  'news.post.launch.img.journal.caption': 'Zapisujte vzpomínky z každého místa do svého deníku.',
  'news.post.launch.img.places.alt': 'Alej v Parku v Bukovci, jedno z míst programu',
  'news.post.launch.img.places.caption': '12 míst na mapě. Každé s vlastním příběhem a razítkem.',
  'news.post.launch.img.stamp.alt': 'Virtuální razítko Park v Bukovci',
  'news.post.launch.img.stamp.caption': 'Razítka sbíráte v panelu po ověřené návštěvě.',
  'news.post.launch.img.landscape.alt': 'Horské jezero na Dolním Slezsku',
  'news.post.launch.img.landscape.caption': 'Region čeká na vaše fotky a příběhy z trasy.',
  'news.post.guarantee.category': 'Záruka',
  'news.post.guarantee.title': 'Záruka ceny a vrácení peněz',
  'news.post.guarantee.excerpt':
    'Přidali jsme přehlednou záruku: využijete akční vstupné a pokud vám program nebude vyhovovat , vrátíme poplatek do 14 dnů.',
  'news.post.guarantee.body1':
    'Chceme, aby rozhodnutí o připojení bylo klidné a bez rizika. Vedle startovní akce proto platí záruka spokojenosti: máte čas nahlédnout do panelu, prohlédnout mapu míst a zjistit, jestli je pro vás tento způsob objevování Dolního Slezska ten pravý.',
  'news.post.guarantee.body2':
    'Pokud po začátku usoudíte, že Pas nesplňuje vaše očekávání , stačí nám napsat do 14 dnů od nákupu. Vstupné vrátíme bez žádosti o zdůvodnění , podle podmínek.',
  'news.post.guarantee.body3':
    'Podrobnosti postupu a výjimek najdete v podmínkách. Na přihlašovací stránce i v panelu záruku připomínáme , aby byla vždy na dosah.',

  // Landing - Číslované sekce 01 / 02
  'landing.section01.eyebrow': '01',
  'landing.section01.title': 'Objevte neznámé klenoty',
  'landing.section01.body':
    'Pas Dolního Slezska vznikl z vášně. Z vášně k regionu, k historii a k nádherným místům , těm méně známým, která v turistických průvodcích po regionu nenajdete.',
  'landing.section01.cta': 'Připojuji se!',
  'landing.section02.eyebrow': '02',
  'landing.section02.title': 'Připojte se ke komunitě',
  'landing.section02.body':
    'Objevitelé Dolního Slezska jsou skvělí lidé, kteří stejně jako vy chtějí prožívat a doopravdy zažívat život. Připojte se k programu Pas Dolního Slezska, abyste je poznali.',
  'landing.section02.cta': 'Zobrazit komunitu',

  // Landing - Pull quote
  'landing.pullQuote.text':
    'Tento projekt má ukázat, že Dolní Slezsko není jen Wrocław a Sněžka.',
  'landing.pullQuote.author': 'Zuzia Kowalska',
  'landing.pullQuote.role': 'Autorka',

  // Landing - Manifest „12 míst. 12 dobrodružství. 12 měsíců.”
  'landing.manifesto.eyebrow': 'Pas Dolního Slezska 2026',
  'landing.manifesto.title': '12 míst. 12 dobrodružství. 12 měsíců.',
  'landing.manifesto.body':
    'Na jednu stranu stačí, abyste nasedli do auta a vyrazili na cestu po vybraných místech. Na druhou stranu vám dáváme rámec, díky kterému se každý víkend mění v malý rituál objevování regionu. Sbíráte razítka, vedete deník, dělíte se o to, co vás překvapilo. Bez tlaku, bez bodových tabulek. Jen vy, mapa Dolního Slezska a 12 měsíců na to, abyste vyšli z vyšlapaných cest.',

  // Landing - Galerie
  'landing.gallery.title': 'Objevujte a zažívejte!',
  'landing.gallery.subtitle': 'Poznejte Dolní Slezsko, jaké neznáte',
  'landing.gallery.headerImageAlt': 'Dolní Slezsko , krajinný park, pohled z dronu',
  'landing.gallery.spotlightEyebrow': 'V programu',
  'landing.gallery.spotlightTitle': 'Cisterciácký klášter v Lubiąži',
  'landing.gallery.spotlightBody':
    'Jeden z největších klášterních komplexů v Evropě , barokní monument v jednom záběru.',
  'landing.gallery.spotlightCta': 'Zobrazit místo',
  'landing.gallery.spotlightAltDrone': 'Cisterciácký klášter v Lubiąži , pohled z dronu',
  'landing.gallery.spotlightAltFront': 'Cisterciácký klášter v Lubiąži , průčelí',
  'landing.gallery.spotlightAltDetail': 'Cisterciácký klášter v Lubiąži , architektonický detail',
  'landing.gallery.mapEyebrow': 'Mapa míst',
  'landing.gallery.mapTitle': '60 míst na mapě Dolního Slezska',
  'landing.gallery.mapTitleMiniOnly': '12 míst na mapě Dolního Slezska',
  'landing.gallery.mapBody':
    'Prohlédněte si celý katalog na mapě. Přibližte zobrazení, zkontrolujte lokace a připojte se k programu pro detaily.',
  'landing.gallery.mapBodyMiniOnly':
    '12 výjimečných a méně známých, ale neuvěřitelně atraktivních míst Dolního Slezska, která vás okouzlí svou historií nebo úžasnými výhledy. Objevíte Dolní Slezsko, jaké ještě neznáte.',
  'landing.gallery.mapHint': 'Vyberte špendlík na mapě pro náhled místa.',
  'landing.gallery.mapOpenPlace': 'Zobrazit místo',
  'landing.gallery.mapLockedTitle': 'Připojte se k výzvě a objevte místa',
  'landing.gallery.mapLockedCta': 'Zaregistrovat se',

  // Landing , vybraná místa
  'landing.placesSection.eyebrow': 'Z programu',
  'landing.placesSection.title': 'Objevte místa',
  'landing.placesSection.subtitle': 'Tři tipy na začátek , kompletní seznam najdete v průvodci.',
  'landing.placesSection.ctaAll': 'Zobrazit všechna místa',

  // Landing - Mobilní aplikace
  'landing.app.title': 'Paszport Dolnego Śląska je k dispozici v aplikaci!',
  'landing.app.subtitle':
    'Stáhněte si aplikaci a sbírejte virtuální razítka na 12 výjimečných místech Dolního Slezska.',
  'landing.app.cta': 'Stáhnout',
  'landing.app.imageAlt':
    'Telefon s aplikací Paszport Dolnego Śląska na pláži u přehrady Mietków',

  // Landing - Feature: deník / razítka
  'landing.journalFeature.title':
    'Sbírejte virtuální razítka ve svém panelu a veďte si deník',
  'landing.journalFeature.subtitle':
    'Objevujte nová místa, zapisujte si zážitky',
  'landing.journalFeature.cta': 'Připojuji se!',
  'landing.journalFeature.previewAlt':
    'Náhled uživatelského panelu , záznam v deníku k místu „Park w Bukowcu”',

  'landing.journalPreview.regionAria': 'Interaktivní náhled deníku z uživatelského panelu',
  'landing.journalPreview.demoEyebrow': 'Náhled panelu , osobní deník',
  'landing.journalPreview.hint': 'Klikněte na jiný záznam a přepněte kapitolu.',
  'landing.journalPreview.tabsAria': 'Výběr ukázkového záznamu v deníku',
  'landing.journalPreview.entry.1.note':
    'Vrátila jsem se unavená a šťastná , tenhle park opravdu svádí ke zpomalení. Nejvíc mi utkvěl výhled směrem ke Krkonoším z jedné z mýtin.',
  'landing.journalPreview.entry.1.more':
    'Vzala jsem si termosku s čajem a sedla si na lavičku u rybníka. Byl to jeden z těch dnů, kdy nic „nemuselo”.',
  'landing.journalPreview.entry.2.note':
    'Velikost stavby ohromí už od parkoviště. Uvnitř mě nejvíc přitahoval klid ambitů , hodně jsem fotila detaily.',
  'landing.journalPreview.entry.2.more':
    'Vyplatí se přijet dříve; později přibývá skupin a hůř se vcítíte do atmosféry.',
  'landing.journalPreview.entry.3.note':
    'Neogotický palác jako z ilustrace , terasy a schody fungují skvěle při západu slunce.',
  'landing.journalPreview.entry.3.more':
    'Spojila jsem prohlídku s krátkou procházkou po okolí; den utekl rychleji, než jsem čekala.',
  'landing.panelShowcase.eyebrow': 'Funkce panelu',
  'landing.panelShowcase.title': 'Poznejte panel zevnitř',
  'landing.panelShowcase.subtitle':
    'Procházejte screenshoty a podívejte se, jak funguje deník, mapa, ověření i hotové návrhy výletů.',
  'landing.panelShowcase.imageAlt': 'Náhled funkce panelu: {{title}}',
  'landing.panelShowcase.slideLabel': 'Obrazovka {{current}} z {{total}}',
  'landing.panelShowcase.prevAria': 'Předchozí obrazovka funkcí panelu',
  'landing.panelShowcase.nextAria': 'Další obrazovka funkcí panelu',
  'landing.panelShowcase.tabsAria': 'Výběr náhledu funkcí panelu',
  'landing.panelShowcase.slide.journal.title': 'Cestovní deník',
  'landing.panelShowcase.slide.journal.body':
    'Každé navštívené místo se ukládá jako kapitola — s datem, fotkou a poznámkou, kterou můžete rozvíjet.',
  'landing.panelShowcase.slide.personalJournal.title': 'Osobní zápisky',
  'landing.panelShowcase.slide.personalJournal.body':
    'Vlastní postřehy a vzpomínky máte vždy po ruce. Je to vaše soukromá kronika výprav po Dolním Slezsku.',
  'landing.panelShowcase.slide.verification.title': 'Rychlé ověření',
  'landing.panelShowcase.slide.verification.body':
    'Panel vás provede jednoduchým ověřením místa, takže hned odemknete razítko i další část deníku.',
  'landing.panelShowcase.slide.map.title': 'Interaktivní mapa',
  'landing.panelShowcase.slide.map.body':
    'Na mapě vidíte, která místa už máte splněná a co vás ještě čeká.',
  'landing.panelShowcase.slide.tripProposal.title': 'Návrh výletu',
  'landing.panelShowcase.slide.tripProposal.body':
    'Dostanete hotovou inspiraci na další výlet: kam jet, co vidět a jak si naplánovat trasu.',

  // Landing - Bez AI
  'landing.noAi.title': 'Bez AI, bez podnětů.',
  'landing.noAi.body':
    'Veškerý obsah, který tu uvidíte, je práce lidských rukou. Je to také prostor pro vaši tvořivost, citlivost a prosté objevování. Veďte si deník, zapisujte, co vás překvapilo, co se vám líbilo a co nelíbilo. Sdílejte to s ostatními a poznávejte pohled lidí podobných vám!',

  // Landing - Banner CTA „připojit se!”
  'landing.joinBanner.line1': 'Nezbývá nic jiného než…',
  'landing.joinBanner.line2': 'připojit se!',
  'landing.joinBanner.aria': 'Připojte se k programu Pas Dolního Slezska',

  // Landing - FAQ (nový obsah podle Figmy)
  'landing.faq.eyebrow': 'FAQ',
  'landing.faq.title': 'Nejčastější otázky',
  'landing.faq.subtitle':
    'Krátké odpovědi na otázky, které se obvykle objevují před připojením.',
  'landing.faq.q1': 'Proč je jen 12 míst?',
  'landing.faq.a1':
    'Protože chci, aby každé místo bylo zážitkem. Věnujte čas pořízení krásných fotek a vedení svého virtuálního deníku.',
  'landing.faq.q2': 'Jak probíhá ověření místa?',
  'landing.faq.a2':
    'Stačí, když na místě zapnete geolokaci. A pokud byste zapomněli, můžete místo ověřit pomocí fotky a krátkého kvízu.',
  'landing.faq.q3': 'Co až dokončím?',
  'landing.faq.a3':
    'Získáte přístup k elektronickému odznaku, diplomu a možnost objednat si fyzický odznak.',
  'landing.faq.q4': 'Kolik stojí zapojení do programu?',
  'landing.faq.a4': 'Edice 2026 (12 míst) i plný pas (60 míst) — po 19 zł. Druhou verzi dokoupíš v panelu za 19 zł.',
  'landing.faq.a4MiniOnly':
    'Edice 2026 zahrnuje 12 míst. Vstupní poplatek je 19 zł za celou sezónu, panel, razítka, deník a komunitu.',
  'landing.faq.q5': 'Můžu vyhrát odměny v žebříčku?',
  'landing.faq.a5':
    'Ano. Sbírejte body za aktivitu v programu a Komunitě , návštěvy míst, lajky a další činnosti popsané na stránce žebříčku. Účastník s nejvyšším výsledkem na konci roku 2026 získá atraktivní odměny.',

  // Landing - Why
  'landing.why.badge': 'O akci',
  'landing.why.title.line1.before': 'Objevte',
  'landing.why.title.line1.emphasis': 'Dolní Slezsko',
  'landing.why.title.line2.before': 'z nové',
  'landing.why.title.line2.emphasis': 'perspektivy',
  'landing.why.cards.places.title': '12 výjimečných míst',
  'landing.why.cards.places.desc':
    'Pečlivě vybraný seznam , příroda, památky a příběhy, ke kterým se chcete vracet.',
  'landing.why.cards.days.title': '365 dní na komplet',
  'landing.why.cards.days.desc':
    'Razítka sbíráte vlastním tempem: o víkendech, na dovolené nebo při krátkých výletech.',
  'landing.why.cards.rules.title': 'Jednoduchá pravidla',
  'landing.why.cards.rules.desc':
    'Vytvoříte účet, navštívíte místa a potvrdíte návštěvy. Zbytek necháme na vaší zvědavosti.',

  // Landing - Badge / challenge
  'landing.badge.kicker': 'Výzva',
  'landing.badge.title.line1': 'Nasbírejte komplet',
  'landing.badge.title.line2': 'a uzavřete rok příběhem',
  'landing.badge.subtitle':
    'Odznak je symbolem cesty , nejde o tempo, ale o objevování. Každé razítko je jeden skutečný den venku.',
  'landing.badge.cta.primary': 'Zobrazit místa',
  'landing.badge.cta.secondary': 'O akci',
  'landing.badge.cards.places.k': 'Místa',
  'landing.badge.cards.places.v': '12 lokalit k návštěvě',
  'landing.badge.cards.months.k': 'Čas',
  'landing.badge.cards.months.v': '12 měsíců na získání kompletu',
  'landing.badge.cards.stories.k': 'Příběhy',
  'landing.badge.cards.stories.v': 'Vaše zápisky, poznámky a vzpomínky',

  // Community (public feed)
  'community.public.title': 'Komunita',
  'community.public.subtitle':
    'Vzpomínky, objevy a fotky účastníků Pasu Dolního Slezska. Přihlaste se, abyste mohli přidat příspěvek.',
  'community.public.filter.allPlaces': 'Všechna místa',
  'community.public.filter.label': 'Filtrovat podle místa',
  'community.public.filter.popular': 'Nejpopulárnější',
  'community.feed.empty': 'Zatím je tu prázdno. Buďte první, kdo se podělí o příběh.',
  'community.feed.loading': 'Načítám příspěvky…',
  'community.feed.loadMore': 'Zobrazit další',
  'community.feed.loadError': 'Nepodařilo se načíst příspěvky komunity.',
  'community.feed.cta.addPost': 'Přidat příspěvek',
  'community.feed.cta.loginToPost': 'Založte si účet a přidávejte příspěvky',
  'community.leaderboard.title': 'Sezónní žebříček',
  'community.leaderboard.titleSuffix': 'sezóny',
  'community.leaderboard.moreInfo': 'Více informací',
  'community.leaderboard.noSeason': 'Žádná aktivní sezóna',
  'community.leaderboard.status.active': 'Sezóna aktivní',
  'community.leaderboard.status.closed': 'Sezóna uzavřena',
  'community.leaderboard.loading': 'Načítám žebříček…',
  'community.leaderboard.empty': 'V této sezóně zatím nejsou body.',
  'community.leaderboard.loadError': 'Nepodařilo se načíst žebříček.',
  'community.gate.title': 'Přihlaste se pro zobrazení dalších příspěvků',
  'community.gate.subtitle':
    'Začátek feedu je veřejný. Pro další prohlížení komunity se přihlaste nebo si vytvořte účet.',
  'community.gate.backToPreview': 'Zpět k náhledu (bez přihlášení)',
  'community.registerNudge.title': 'Přidejte se ke komunitě',
  'community.registerNudge.body':
    'Zaregistrujte se, abyste mohli přidávat příspěvky, komentovat a sbírat body v žebříčku.',
  'community.registerNudge.cta': 'Zaregistrovat se',
  'community.registerNudge.later': 'Teď ne',
  'community.registerNudge.close': 'Zavřít',
  'community.post.author.anonymous': 'Anonymní cestovatel',

  // Community (panel)
  'community.panel.title': 'Komunita',
  'community.panel.subtitle':
    'Vytvářejte nové příspěvky a spravujte text i fotky svých příspěvků v komunitě.',
  'community.panel.compose.eyebrow': 'Nový příspěvek',
  'community.panel.posts.eyebrow': 'Vaše příspěvky',
  'community.panel.compose.title': 'Nový příspěvek',
  'community.panel.compose.place.label': 'Místo (povinné)',
  'community.panel.compose.place.placeholder': 'Vyberte místo z pasu',
  'community.panel.compose.body.label': 'Obsah příspěvku',
  'community.panel.compose.body.placeholder': 'Napište, o co se chcete podělit…',
  'community.panel.compose.body.counter': '{{current}}/{{max}}',
  'landing.physicalPassport.eyebrow': 'Novinka',
  'landing.physicalPassport.title': 'Fyzický Pas Dolního Slezska , knížka',
  'landing.physicalPassport.body':
    'Pracujeme na papírové verzi pasu, kterou si vezmete s sebou na cesty, budete sbírat razítka a vlastní poznámky. Chcete dostat informaci mezi prvními, až spustíme zápisy?',
  'landing.physicalPassport.form.label': 'Zadejte email, pokud máte zájem',
  'landing.physicalPassport.form.placeholder': 'tvuj@email.cz',
  'landing.physicalPassport.form.submit': 'Přidat se na čekací listinu',
  'landing.physicalPassport.form.submitting': 'Ukládám…',
  'landing.physicalPassport.form.success':
    'Skvělé, zapsáno! Jakmile spustíme fyzickou knížku, dáme vám vědět e-mailem.',
  'landing.physicalPassport.form.error.invalidEmail': 'Zadejte platnou emailovou adresu.',
  'landing.physicalPassport.form.error.generic':
    'Nepodařilo se uložit email. Zkuste to prosím znovu později.',
  'landing.waitlistPopup.eyebrow': 'Zdarma',
  'landing.waitlistPopup.title': 'Objevte Dolní Slezsko zdarma',
  'landing.waitlistPopup.body':
    'Zanechte svůj email a přidejte se na čekací listinu. Dáme vám vědět, až vyrazíme — a občas vám pošleme zajímavosti z regionu.',
  'landing.waitlistPopup.form.label': 'Váš email',
  'landing.waitlistPopup.form.placeholder': 'tvuj@email.cz',
  'landing.waitlistPopup.form.submit': 'Přidat mě na seznam',
  'landing.waitlistPopup.form.submitting': 'Ukládám…',
  'landing.waitlistPopup.form.success':
    'Skvělé! Jste na seznamu — ozveme se e-mailem a budeme posílat zajímavosti z Dolního Slezska.',
  'landing.waitlistPopup.form.error.invalidEmail': 'Zadejte platnou emailovou adresu.',
  'landing.waitlistPopup.form.error.generic':
    'Nepodařilo se uložit email. Zkuste to prosím znovu později.',
  'landing.waitlistPopup.later': 'Později',
  'landing.waitlistPopup.closeAria': 'Zavřít okno',
  'community.panel.compose.photos.label': 'Fotky (volitelné)',
  'community.panel.compose.photos.helper':
    'Povolené JPG / PNG / WebP. Velké soubory budou automaticky zmenšeny.',
  'community.panel.compose.submit': 'Publikovat příspěvek',
  'community.panel.compose.submitting': 'Publikuji…',
  'community.panel.compose.success': 'Příspěvek byl publikován.',
  'community.panel.posts.title': 'Vaše příspěvky',
  'community.panel.posts.empty': 'Zatím nemáte žádné příspěvky. Napište první výše.',
  'community.panel.posts.loading': 'Načítám vaše příspěvky…',
  'community.panel.posts.loadError': 'Nepodařilo se načíst vaše příspěvky.',
  'community.panel.posts.editBody': 'Upravit text',
  'community.panel.posts.saveBody': 'Uložit text',
  'community.panel.posts.cancelEdit': 'Zrušit úpravu',
  'community.panel.posts.addPhoto': 'Přidat fotku',
  'community.panel.posts.addingPhoto': 'Nahrávám fotku…',
  'community.panel.posts.deletePhoto': 'Smazat fotku',
  'community.panel.posts.deletePhoto.confirm': 'Smazat tuto fotku z příspěvku?',
  'community.panel.posts.delete': 'Smazat příspěvek',
  'community.panel.posts.delete.confirm': 'Opravdu smazat tento příspěvek? Tuto akci nelze vrátit.',
  'community.panel.posts.viewPublic': 'Zobrazit v komunitě',
  'community.errors.notLoggedIn': 'Nejprve se přihlaste do svého účtu.',
  'community.errors.placeRequired': 'Vyberte místo, ke kterému se příspěvek vztahuje.',
  'community.errors.bodyRequired': 'Obsah příspěvku nesmí být prázdný.',
  'community.errors.bodyTooLong': 'Obsah příspěvku je příliš dlouhý.',
  'community.errors.saveFailed': 'Nepodařilo se uložit příspěvek.',
  'community.errors.deleteFailed': 'Nepodařilo se smazat příspěvek.',
  'community.errors.uploadFailed': 'Nepodařilo se nahrát fotku.',

  // Publish to community (panel detailu místa)
  'community.publish.title': 'Publikovat v komunitě',
  'community.publish.subtitle':
    'Podělte se o svůj popis tohoto místa s ostatními uživateli ve veřejném feedu komunity.',
  'community.publish.loginRequired': 'Pro publikování se přihlaste do svého účtu.',
  'community.publish.loading': 'Kontroluji stav publikace…',
  'community.publish.notPublishedHint':
    'Váš popis tohoto místa ještě nebyl publikován v komunitě. Po publikaci se objeví ve feedu /spolecznosc.',
  'community.publish.cta': 'Publikovat v komunitě',
  'community.publish.publishing': 'Publikuji…',
  'community.publish.publishedAt': 'Publikováno {{date}}',
  'community.publish.publishedBody': 'Publikovaný obsah',
  'community.publish.viewInFeed': 'Zobrazit ve feedu',
  'community.publish.edit': 'Upravit obsah',
  'community.publish.save': 'Uložit změny',
  'community.publish.saving': 'Ukládám…',
  'community.publish.cancel': 'Zrušit',
  'community.publish.error.bodyRequired':
    'Nejprve vyplňte popis výše (poznámka nebo odpověď na otázku) a poté publikujte.',
  'community.publish.error.bodyTooLong': 'Obsah příspěvku je příliš dlouhý.',
  'community.publish.error.publish': 'Nepodařilo se publikovat v komunitě.',
  'community.publish.error.update': 'Nepodařilo se uložit změny v publikovaném příspěvku.',
  'community.publish.error.load': 'Nepodařilo se zkontrolovat stav publikace.',

  // Likes
  'community.likes.count': '{{count}}',
  'community.likes.like': 'To se mi líbí',
  'community.likes.liked': 'Líbí se mi',
  'community.likes.loginToLike': 'Přihlaste se, abyste mohli dát „líbí se mi“',
  'community.likes.error': 'Nepodařilo se aktualizovat hodnocení.',

  // Comments
  'community.comments.count': 'Komentáře ({{count}})',
  'community.comments.show': 'Zobrazit komentáře ({{count}})',
  'community.comments.hide': 'Skrýt komentáře',
  'community.comments.loading': 'Načítám komentáře…',
  'community.comments.empty': 'Zatím žádné komentáře. Buďte první.',
  'community.comments.loadError': 'Nepodařilo se načíst komentáře.',
  'community.comments.compose.placeholder': 'Napište komentář…',
  'community.comments.compose.submit': 'Odeslat',
  'community.comments.compose.submitting': 'Odesílám…',
  'community.comments.compose.loginCta': 'Přihlaste se, abyste mohli komentovat',
  'community.comments.compose.counter': '{{current}}/{{max}}',
  'community.comments.edit': 'Upravit',
  'community.comments.save': 'Uložit',
  'community.comments.cancel': 'Zrušit',
  'community.comments.delete': 'Smazat',
  'community.comments.delete.confirm': 'Smazat tento komentář?',
  'community.comments.errors.bodyRequired': 'Komentář nesmí být prázdný.',
  'community.comments.errors.bodyTooLong': 'Komentář je příliš dlouhý.',
  'community.comments.errors.saveFailed': 'Nepodařilo se uložit komentář.',
  'community.comments.errors.deleteFailed': 'Nepodařilo se smazat komentář.',

  // Panel nav (community tab)
  'panel.nav.community': 'Komunita',
  'panel.nav.legacyFull': '60 míst',

  // Trust / garance vrácení peněz
  'trust.moneyBack.text':
    'Program se ti nelíbí? Vrátíme ti peníze do 14 dní — bez udávání důvodu.',
  'trust.moneyBack.termsLink': 'Podrobnosti v podmínkách.',

  'sales.cta.hint.default': 'Jednorázový poplatek · 365 dní na objevy · bez předplatného',
  'sales.cta.hint.promo': 'Nová, nižší cena: 19 zł místo 29 zł',
  'sales.conversion.eyebrow': 'Připraveni začít?',
  'sales.conversion.title': 'Začněte sbírat razítka ještě dnes',
  'sales.conversion.subtitle':
    'Připojte se k programu, odemkněte panel a objevujte 12 míst Dolního Slezska vlastním tempem.',
  'sales.conversion.bullet1': 'Jedna platba — přístup po celý rok 2026',
  'sales.conversion.bullet2': '12 míst, deník a komunita objevitelů',
  'sales.conversion.bullet3': '14 dní na vrácení peněz, pokud program nesedne',
  'sales.conversion.cta': 'Připojuji se teď',
  'landing.joinBanner.cta': 'Ano — připojuji se!',
  'landing.map.cta': 'Odemknout mapu míst',
  'landing.manifesto.cta': 'Připojuji se k výzvě',
  'landing.panelShowcase.cta': 'Zobrazit panel po registraci',

  // Auth (login / registrace)
  'auth.eyebrow.login': 'Přihlášení',
  'auth.eyebrow.register': 'Připojuji se k programu',
  'auth.title.login': 'Vítej zpět',
  'auth.title.register': 'Připoj se k objevitelům Dolního Slezska',
  'auth.subtitle.login': 'Přihlas se a vrať se ke své trase.',
  'auth.subtitle.register': '',
  'auth.toggle.login': 'Přihlášení',
  'auth.toggle.register': 'Registrace',
  'auth.toggle.aria': 'Vyber režim',

  'panel.trial.banner':
    'Testovací účet — vidíš jen seznam míst. Razítka, deník a komunitu odemkneš po zaplacení vstupného.',
  'panel.trial.upgradeCta': 'Zaplatit plný pas',
  'panel.trial.navLockedAria':
    '{{label}} — v plné verzi. Klikni pro registraci se vstupným.',

  'auth.register.pitch.eyebrow': '{{count}} míst programu',
  'auth.register.pitch.title': 'Sbírej virtuální razítka',
  'auth.register.pitch.subtitle':
    'Každá ověřená návštěva odhalí další razítko v tvém pasu — skutečná místa Dolního Slezska, fotky z terénu, ne ze stocku.',
  'auth.register.pitch.highlight1': 'Razítko po GPS nebo fotokvízu',
  'auth.register.pitch.highlight2': 'Deník a mapa postupu v panelu',
  'auth.register.pitch.highlight3': 'Komunita objevitelů a žebříček',

  'auth.register.shelterDonation':
    '10 % z vstupného předáme jednomu z dolnoslezských útulků pro zvířata — vy si vyberete, který!',

  // Co dostaneš (legacy)
  'auth.benefits.eyebrow': 'Co dostaneš',
  'auth.benefits.title': 'Vše v jednom pasu',
  'auth.benefits.b1.title': 'Digitální pas s razítky',
  'auth.benefits.b1.body':
    'Sbíráš razítka z každého navštíveného místa přímo v aplikaci , bez papírové knížky, kterou se dá ztratit.',
  'auth.benefits.b2.title': 'Interaktivní mapa míst',
  'auth.benefits.b2.body':
    'Pečlivě vybraná místa Dolního Slezska , s navigací, popisem a fotkami pořízenými na místě, ne ze stockové banky.',
  'auth.benefits.b3.title': 'Cestovní deník',
  'auth.benefits.b3.body':
    'Tvé poznámky, postřehy a fotky z každé návštěvy , zůstanou s tebou navždy, soukromě nebo sdílené s komunitou.',
  'auth.benefits.b4.title': 'Komunita objevitelů',
  'auth.benefits.b4.body':
    'Lidé, kteří jako ty chtějí poznat region za hranicemi Vratislavi a Sněžky. Ptej se, doporučuj, najdi parťáky na výlety.',
  'auth.benefits.b5.title': 'Bez AI v obsahu',
  'auth.benefits.b5.body':
    'Každý popis místa psaný ručně. Každá fotka pořízená osobně. Žádná generativní shrnutí, žádné halucinace.',
  'auth.benefits.b6.title': 'Všechny aktualizace 2026',
  'auth.benefits.b6.body':
    'Nová místa, funkce a mapy po celý rok 2026 , bez doplatků, bez předplatného, bez skrytých nákladů.',

  // Proč 19 zł (startovní promo)
  'auth.transparency.eyebrow': 'Cena',
  'auth.transparency.title': 'Proč',
  'auth.transparency.body':
    'Nejraději bych tento projekt dala úplně zadarmo. Dělám ho z vášně k Dolnímu Slezsku, ne pro zisk , ale někdo to musí zaplatit a já se taky musím něčím živit. Proto jednorázový, férový vstupní poplatek na celý rok.',
  'auth.transparency.breakdownTitle': 'Na co jdou tvých 19 zł',
  'auth.transparency.cost1':
    'Server a provoz aplikace po celý rok 2026',
  'auth.transparency.cost2':
    'Můj čas , psaní popisů, focení míst, vývoj nových funkcí',
  'auth.transparency.cost3':
    'Podpora společně vybrané nadace působící v Dolním Slezsku',
  'auth.transparency.cost4':
    'Drobné nástroje (mapy, hosting fotek, doména, certifikáty)',
  'auth.transparency.foundationNote':
    'Nadaci vybereme společně , v panelu najdeš hlasování o organizacích, které regionu reálně pomáhají.',

  // Form
  'auth.form.fullName.label': 'Jméno',
  'auth.form.fullName.placeholder': 'např. Zuzana',
  'auth.form.email.label': 'Email',
  'auth.form.email.placeholder': 'např. zuzana@email.cz',
  'auth.form.password.label': 'Heslo',
  'auth.form.password.placeholderRegister': 'Minimálně 6 znaků',
  'auth.form.password.show': 'Zobrazit',
  'auth.form.password.hide': 'Skrýt',
  'auth.form.password.hint':
    'Minimálně 6 znaků. Nejlépe použij unikátní heslo, které nikde jinde nepoužíváš.',
  'auth.form.submitRegister': 'Zaplatit',
  'auth.form.submitRegisterSuffix': 'a připojit se',
  'auth.form.submitRegisterBusy': 'Připojuji se k HotPay…',
  'auth.form.submitLogin': 'Přihlásit',
  'auth.form.submitLoginBusy': 'Okamžik…',
  'auth.form.autoLoginBusy': 'Přihlašujeme tě…',
  'auth.form.forgotPassword': 'Zapomenuté heslo',
  'auth.form.resetSending': 'Posílám odkaz…',
  'auth.form.resetSent':
    'Poslali jsme odkaz na reset hesla. Zkontroluj schránku (i spam).',
  'auth.form.legalPrefix': 'Registrací přijímáš',
  'auth.form.termsLink': 'podmínky',
  'auth.form.legalAnd': 'a',
  'auth.form.privacyLink': 'zásady ochrany soukromí',
  'auth.form.marketingConsent.label':
    'Souhlasím se zasíláním marketingových informací (e-mail) o Pasu Dolního Slezska a jeho sociálních kanálech. Souhlas lze kdykoli odvolat.',
  'auth.form.errors.invalidEmail': 'Zadej platnou emailovou adresu.',
  'auth.form.errors.nameTooShort': 'Zadej jméno (alespoň 2 znaky).',
  'auth.form.errors.passwordTooShort': 'Heslo musí mít alespoň 6 znaků.',
  'auth.form.errors.resetEmailRequired':
    'Zadej email pro odeslání odkazu k resetu hesla.',
  'auth.form.errors.resetFailed':
    'Nepodařilo se odeslat odkaz k resetu hesla.',
  'auth.form.errors.invalidCredentials': 'Nesprávný e-mail nebo heslo.',
  'auth.form.errors.loginFailed': 'Chyba přihlášení.',
  'auth.form.errors.checkoutFailed': 'Nepodařilo se spustit platbu.',

  // Pricing / Ceník
  'pricing.eyebrow': 'Ceník 2026',
  'pricing.title': 'Jednorázově, na celý rok',
  'pricing.subtitle':
    'Bez předplatného, bez skrytých nákladů. Zaplatíš jednou , máš přístup k programu na celý rok 2026.',
  'pricing.priceLabel': 'Plný pas',
  'pricing.priceLabelMiniOnly': 'Speciální edice 2026',
  'pricing.variantEyebrow': 'Dvě varianty',
  'pricing.variantEyebrowMiniOnly': 'Program 2026',
  'pricing.variantTitle': '60 míst k návštěvě',
  'pricing.variantTitleMiniOnly': '12 míst za 12 měsíců',
  'pricing.variantBody':
    'Ve výchozím nastavení plný pas. Stávající účastníci ho mají bez doplatku. Níže můžete také zvolit speciální edici na 2026.',
  'pricing.variantBodyMiniOnly':
    'Sezónní výzva na celý rok 2026. Virtuální razítka, deník v panelu a komunita objevitelů.',
  'pricing.price': '19 zł',
  'pricing.priceRegular': '29 zł',
  'pricing.priceUnit': 'jednorázově',
  'pricing.duration':
    'Máš 365 dní od přihlášení, aby ses dostal k cíli vlastním tempem.',
  'pricing.cta.join': 'Připojit se!',
  'pricing.cta.faq': 'Přečíst FAQ',
  'pricing.cta.back': 'Zpět na hlavní stránku',
  'pricing.includes.eyebrow': 'Co je v ceně',
  'pricing.includes.title': 'Vše v jedné platbě',
  'pricing.includes.i1.title': 'Seznam míst Dolního Slezska',
  'pricing.includes.i1.body':
    'Přístup k {{count}} pečlivě vybraným místům , s popisem, navigací a fotkami pořízenými na místě.',
  'pricing.includes.i2.title': 'Digitální pas s razítky',
  'pricing.includes.i2.body':
    'Sbírej razítka v aplikaci za každou návštěvu , bez papírové knížky.',
  'pricing.includes.i3.title': 'Cestovní deník',
  'pricing.includes.i3.body':
    'Poznámky, postřehy a fotky z každého místa. Soukromě nebo sdílené s komunitou.',
  'pricing.includes.i4.title': 'Všechny aktualizace 2026',
  'pricing.includes.i4.body':
    'Nová místa a funkce po celý rok , bez doplatků a předplatného.',
  'pricing.includes.i5.title': 'Cíl: splnit ve vlastním tempu',
  'pricing.includes.i5.body':
    'Máš 365 dní od přihlášení. Bez umělého tlaku, bez časomíry.',
  'pricing.transparency.eyebrow': 'Odkud ta cena',
  'pricing.transparency.body':
    'Cena pokrývá server a provoz aplikace, můj čas na vývoj a popisy míst, drobné nástroje a podporu společně vybrané nadace působící v Dolním Slezsku.',
  'pricing.transparency.linkPrefix': 'Úplné vysvětlení najdeš v záložce',
  'pricing.transparency.linkText': 'Přidat se',

  // Places page (seznam míst full-screen scroll)
  'placesPage.cta.read': 'Číst článek',
  'placesPage.cta.comingSoon': 'Brzy',
  'placesPage.nav.previous': 'Předchozí místo',
  'placesPage.nav.next': 'Další místo',
  'placesPage.registerNudge.title': 'Objevte tato místa na svém účtu',
  'placesPage.registerNudge.body':
    'Zaregistrujte se a sbírejte razítka a sledujte objevená místa ze seznamu ve svém Pasu.',
}

